<!--suppress ALL -->
<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>



			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
							  :fileNumber="appraisalfile.number" :reportOpen="reportOpen"
							  :reportNumber="appraisalreport.number" :versionNumber="appraisalreport.version"
							  :realEstates="appraisalreport_realestates" :realEstateId="realestate.id"
							  :reportId="appraisalreport.id"></side-nav-bar>

				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Appraisal') }} {{ $t('of') }} <span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span> {{ $t('with') }} {{ $t('date')
						}} {{ appraisal.appraisaldate}} {{$t('at')}} <span
								v-if="realestate.street_name">{{ realestate.street_name
							}}</span><span
								v-if="realestate.street_number">, {{ realestate.street_number }}</span><span
								v-if="realestate.floor">, {{ realestate.floor}}</span><span
								v-if="realestate.door"> {{ realestate.door }}</span> <span
								v-if="appraisal.dirty">*</span>
					</h1>
					<div v-if="appraisal.realestate_adopted_appraisal_method">
						<h2 v-if="currentLocale == 'ca'">{{ appraisal.realestate_adopted_appraisal_method.name_ca
							}}: {{ appraisal.realestate_total_adopted_value | formatNumber }} €</h2>
						<h2 v-else-if="currentLocale == 'en'">{{ appraisal.realestate_adopted_appraisal_method.name_ca
							}}: {{ appraisal.realestate_total_adopted_value | formatNumber }} €</h2>
						<h2 v-else>{{ appraisal.realestate_adopted_appraisal_method.name_es
							}}: {{ appraisal.realestate_total_adopted_value | formatNumber }} €</h2>
					</div>
					<message
							v-if="appraisal.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(appraisal.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(appraisal.date_modified) }}</p>
					</div>

					<vue-tabs v-model="tabName">
						<v-tab :title="General_data_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Dades generals')">{{General_data_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('General data')">{{General_data_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Datos generales')">{{General_data_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<h3>{{ $t('Elements_included_in_this_valuation') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Property_type') }}</label>
													<multiselect placeholder=""
																 :value="property_typeValue"
																 :options="property_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.property_type"
																 @input="set_appraisal_property_type"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Parking_spots_included_number') }}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.parking_spots_included_number"
														   @input="set_appraisal_parking_spots_included_number">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Storage_room_included_in_appraisal')
														}}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="appraisal.storage_room"
														   @click="set_appraisal_storage_room">
												</div>
											</div>




										</div>
										<div class="section-container">
											<h3>{{ $t('Appraisal_type') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Appraisal_type')
														}}</label>
													<multiselect placeholder=""
																 :value="appraisalTypeValue"
																 :options="appraisalTypeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
																 :searchable="false"
																 v-model="appraisal.type"
																 @input="set_appraisal_type"></multiselect>
												</div>
											</div>
										</div>

										<div class="form-section">
											<h3>{{ $t('Date') }} {{ $t('and') }} {{ $t('Appraisal_purpose') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Date_of_the_appraisal_value')
														}}</label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="appraisal.appraisaldate"
														   @input="set_appraisal_appraisaldate">
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Appraisal_purpose')
														}}</label>
													<multiselect placeholder=""
																 :value="appraisalPurposeValue"
																 :options="appraisalPurposeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
																 :searchable="false"
																 v-model="appraisal.purpose"
																 @input="set_appraisal_purpose"></multiselect>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Market_value_adjustment_pct')
														}} (%)</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.reduction_pct"
														   @input="set_appraisal_reduction_pct">
												</div>
											</div>
											<div v-if="loadingAppraisalPurpose">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Notes') }}<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
													<textarea class="field__group__textarea"
															  rows="5"
															  spellcheck="false"
															  v-model="appraisal.purpose_notes"
															  @input="set_appraisal_purpose_notes"></textarea>
												</div>
											</div>

											<!-- TODO: en totes les observacions i textos, fer com a annexes photograph on segons l'idioma apareix un text o l'altre, etc -->

										</div>
										<div class="section-container">
											<h3>{{ $t('Visit') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Visit_date')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="appraisal.visitdate"
														   @input="set_appraisal_visitdate">
												</div>
											</div>
											<div class="ms-container">
												<label class="field__group__label">{{ $t('Technician_who_performed_the_visit')
													}}<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
												<multiselect placeholder=""
															 :value="technician_visitingValue"
															 :options="object_to_array(appraisers)"
															 track-by="id"
															 :label="'complete_name'"
															 :searchable="true"
															 v-model="appraisal.technician_visiting"
															 @input="set_appraisal_technician_visiting"></multiselect>
											</div>
										</div>

										<!-- TODO: comprovar que la data de visita sigui anterior a la data de l'informe i de taxació-->

										<div class="section-container">
											<h3>{{ $t('Cadastral_data') }}</h3>
											<div class="field-container">

												<div class="field__group">
													<label class="field__group__label">{{ $t('Cadastral_reference')
														}}</label>
													<span> {{ realestate.cadastral_reference }} </span>

												</div>
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralFile"
															@keyup.enter="onOpenCadastralFile">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_file')}}</span>
													</button>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_year')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.cadastral_construction_year"
														   @input="set_appraisal_cadastral_construction_year">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Usage')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.cadastral_usage"
														   @input="set_appraisal_cadastral_usage">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Floor')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.cadastral_floor"
														   @input="set_appraisal_cadastral_floor">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Door')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.cadastral_door"
														   @input="set_appraisal_cadastral_door">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Block')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.cadastral_block"
														   @input="set_appraisal_cadastral_block">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Staircase')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.cadastral_staircase"
														   @input="set_appraisal_cadastral_staircase">
												</div>
												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Net_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.net_cadastral_area"
														   @input="set_appraisal_net_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Enclosed_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.enclosed_cadastral_area"
														   @input="set_appraisal_enclosed_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Covered_terraces_total_cadastral_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.covered_terraces_total_cadastral_area"
														   @input="set_appraisal_covered_terraces_total_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Uncovered_terraces_total_cadastral_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.uncovered_terraces_total_cadastral_area"
														   @input="set_appraisal_uncovered_terraces_total_cadastral_area">
												</div>
												-->
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.built_cadastral_area"
														   @input="set_appraisal_built_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Common_elements_cadastral_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.common_elements_cadastral_area"
														   @input="set_appraisal_common_elements_cadastral_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_plus_common_elements_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.built_plus_common_elements_cadastral_area"
														   @input="set_appraisal_built_plus_common_elements_cadastral_area">
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Registry_data') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Registry') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_name"
														   @input="set_appraisal_registry_name">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Section')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_section"
														   @input="set_appraisal_registry_section">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Volume')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_volume"
														   @input="set_appraisal_registry_volume">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Book') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_book"
														   @input="set_appraisal_registry_book">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Page') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_page"
														   @input="set_appraisal_registry_page">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Registry_real_estate_number')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_real_estate_number"
														   @input="set_appraisal_registry_real_estate_number">
												</div>
												<div class="field__group">
													<label class="field__group__label">IDUFIR</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_idufir"
														   @input="set_appraisal_registry_idufir">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Holder') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.registry_owner"
														   @input="set_appraisal_registry_owner">
												</div>


												<div class="field__group">
													<label class="field__group__label">{{ $t('Property_coef') }}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.registry_property_coef"
														   @input="set_appraisal_registry_property_coef">
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Net_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.net_registry_area"
														   @input="set_appraisal_net_registry_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Enclosed_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.enclosed_registry_area"
														   @input="set_appraisal_enclosed_registry_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Covered_outdoors_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.covered_terraces_total_registry_area"
														   @input="set_appraisal_covered_terraces_total_registry_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Uncovered_outdoors_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.uncovered_terraces_total_registry_area"
														   @input="set_appraisal_uncovered_terraces_total_registry_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.built_registry_area"
														   @input="set_appraisal_built_registry_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_plus_common_elements_area')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.built_plus_common_elements_registry_area"
														   @input="set_appraisal_built_plus_common_elements_registry_area">
												</div>


											</div>
										</div>


									</form>
								</div>
							</div>

						</v-tab>
						<v-tab :title="urban_and_surroundings_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Urbanisme i entorn')">{{urban_and_surroundings_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Urban planning and surroundings')">{{urban_and_surroundings_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Urbanismo y entorno')">{{urban_and_surroundings_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<h3>{{ $t('Urban_planning_parameters') }}</h3>
											<div v-if="muc_info_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
											</div>
											<div>
												<div @click.prevent="onRequestMucInfo"
													 style="width: fit-content; margin-right: auto">
													<icon-button icon="globe" text="MUC Info"
																 icon_color="rgb(0, 79, 146)"
																 text_color="rgb(0, 79, 146)"
																 border_color="lightgray"></icon-button>
												</div>
											</div>


											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Plan_type')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_type"
														   @input="set_appraisal_urban_planning_type">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('File')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_file"
														   @input="set_appraisal_urban_planning_file">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Council_qualification')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_council_qualification"
														   @input="set_appraisal_urban_planning_council_qualification">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Council_qualification_description')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_council_qualification_description"
														   @input="set_appraisal_urban_planning_council_qualification_description">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Council_classification')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_council_classification"
														   @input="set_appraisal_urban_planning_council_classification">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Council_classification_description')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_council_classification_description"
														   @input="set_appraisal_urban_planning_council_classification_description">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Regional_qualification')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_regional_qualification"
														   @input="set_appraisal_urban_planning_regional_qualification">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Regional_qualification_description')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_regional_qualification_description"
														   @input="set_appraisal_urban_planning_regional_qualification_description">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Regional_classification')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_regional_classification"
														   @input="set_appraisal_urban_planning_regional_classification">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Regional_classification_description')
														}}<span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.urban_planning_regional_classification_description"
														   @input="set_appraisal_urban_planning_regional_classification_description">
												</div>
											</div>
										</div>
										<div class="form-section">
											<h3>{{ $t('MUC_map') }}</h3>
											<div v-if="muc_map_01_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 01...</span>
											</div>
											<div v-if="muc_map_02_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 02...</span>
											</div>
											<div v-if="muc_map_03_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 03...</span>
											</div>
											<div>
												<div @click.prevent="onRequestMucMap"
													 style="width: fit-content; margin-right: auto">
													<icon-button icon="globe" text="Mapa del MUC"
																 icon_color="rgb(0, 79, 146)"
																 text_color="rgb(0, 79, 146)"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
											<!--
											<div class="field-container">
												<div v-if="appraisal.map_urban_muc_land_colors">
													<img :src="appraisal.map_urban_muc_land_colors" width="600px"
														 height="600px">
												</div>
												<div v-if="appraisal.map_urban_muc_council_qual">
													<img :src="appraisal.map_urban_muc_council_qual" width="600px"
														 height="600px">
												</div>
												<div v-if="appraisal.map_urban_icc_topo">
													<img :src="appraisal.map_urban_icc_topo" width="600px"
														 height="600px">
												</div>
											</div>
											-->
											<div class="field-container" style="justify-content: baseline!important;">
												<div v-if="appraisal.map_urban_muc_land_colors">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em;  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 1/3</span>
														</div>
														<div><img :src="appraisal.map_urban_muc_land_colors"
																  width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">

																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ appraisal.map_urban_muc_land_colors_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
												<div v-if="appraisal.map_urban_muc_council_qual">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 2/3</span>
														</div>
														<div><img :src="appraisal.map_urban_muc_council_qual"
																  width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">

																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ appraisal.map_urban_muc_council_qual_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
												<div v-if="appraisal.map_urban_icc_topo">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 3/3</span>
														</div>
														<div><img :src="appraisal.map_urban_icc_topo" width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">

																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ appraisal.map_urban_icc_topo_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapUrbanMuc"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
											</div>
										</div>
										<div class="form-section">
											<div class="section-container">
												<h3>{{ $t('Locality') }}</h3>
												<div v-if="idescat_info_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>
												<div>
													<div @click.prevent="onRequestIdescatInfoByCodeIne"
														 style="width: fit-content; margin-right: auto">
														<icon-button icon="globe" text="Idescat Info"
																	 icon_color="rgb(0, 79, 146)"
																	 text_color="rgb(0, 79, 146)"
																	 border_color="lightgray"></icon-button>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Nucleus_area')
															}} (km²)</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.nucleus_area"
															   @input="set_appraisal_nucleus_area">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Population')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.nucleus_population"
															   @input="set_appraisal_nucleus_population">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Population_density')
															}} (hab/km²)</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.nucleus_population_density"
															   @input="set_appraisal_nucleus_population_density">
													</div>
													<div class="field__group">
														<!--<label class="field__group__label">{{ $t('Population_growth')
															}} ({{ $t('Last_year') }}) (%)</label>-->
														<label class="field__group__label">{{ $t('Population_growth')
															}} ({{ $t('Gross_tax_per_1000_inhabitants') }})</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.nucleus_population_growth"
															   @input="set_appraisal_nucleus_population_growth">
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Nucleus_type')
															}}</label>
														<textarea class="field__group__textarea"
																  rows="2"
																  spellcheck="false"
																  v-model="appraisal.nucleus_type"
																  @input="set_appraisal_nucleus_type"></textarea>
													</div>
												</div>
												<!--
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Occupation_agriculture_pct') }}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.occupation_agriculture_pct"
															   @input="set_appraisal_occupation_agriculture_pct">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Occupation_industry_pct') }}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.occupation_industry_pct"
															   @input="set_appraisal_occupation_industry_pct">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Occupation_construction_pct') }}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.occupation_construction_pct"
															   @input="set_appraisal_occupation_construction_pct">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Occupation_services_pct') }}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.occupation_services_pct"
															   @input="set_appraisal_occupation_services_pct">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Occupation_total_pct') }}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.occupation_total_pct"
															   @input="set_appraisal_occupation_total_pct">
													</div>
												</div>
												-->
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Employment_occupation')
															}}</label>
														<textarea class="field__group__textarea"
																  rows="3"
																  spellcheck="false"
																  v-model="appraisal.occupation_description"
																  @input="set_appraisal_occupation_description"></textarea>
													</div>

												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Surroundings') }}</h3>
												<div class="field-container">
													<table>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Territorial_feature')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_territorial_featureValue"
																				 :options="territorial_featureOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_territorial_feature"
																				 @input="set_appraisal_surrounding_territorial_feature"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Income_level')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_income_levelValue"
																				 :options="quality_levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_income_level"
																				 @input="set_appraisal_surrounding_income_level"></multiselect>
																</div>
															</td>

														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Homogeneity_feature')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_homogeneity_featureValue"
																				 :options="homogeneity_featureOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_homogeneity_feature"
																				 @input="set_appraisal_surrounding_homogeneity_feature"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Main_uses')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_main_usesValue"
																				 :options="usage_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_main_uses"
																				 @input="set_appraisal_surrounding_main_uses"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Density')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_densityValue"
																				 :options="quality_levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_density"
																				 @input="set_appraisal_surrounding_density"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Accessibility')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_accessibilityValue"
																				 :options="accessibility_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_accessibility"
																				 @input="set_appraisal_surrounding_accessibility"></multiselect>
																</div>
															</td>
														</tr>
													</table>


												</div>
											</div>
											<h3>{{ $t('Building_development_level') }}</h3>
											<div class="section-container">
												<div class="field-container">
													<table>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Consolidation_degree')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_consolidation_degreeValue"
																				 :options="degree_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_consolidation_degree"
																				 @input="set_appraisal_surrounding_consolidation_degree"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Occupation_degree')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_occupation_degreeValue"
																				 :options="degree_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_occupation_degree"
																				 @input="set_appraisal_surrounding_occupation_degree"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Evolution')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_evolution_speedValue"
																				 :options="evolution_speedOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_evolution_speed"
																				 @input="set_appraisal_surrounding_evolution_speed"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Average_age')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_average_ageValue"
																				 :options="average_ageOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_average_age"
																				 @input="set_appraisal_surrounding_average_age"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Conservation_status')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_conservation_statusValue"
																				 :options="conservation_statusOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_conservation_status"
																				 @input="set_appraisal_surrounding_conservation_status"></multiselect>
																</div>
															</td>
														</tr>
													</table>
												</div>
											</div>
											<h3>{{ $t('Facilities') }}</h3>
											<div class="section-container">
												<div class="field-container">
													<table>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Commercial')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_commercial_facilitiesValue"
																				 :options="levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_commercial_facilities"
																				 @input="set_appraisal_surrounding_commercial_facilities"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Educational')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_educational_facilitiesValue"
																				 :options="levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_educational_facilities"
																				 @input="set_appraisal_surrounding_educational_facilities"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Public_parking')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_public_parkingValue"
																				 :options="levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_public_parking"
																				 @input="set_appraisal_surrounding_public_parking"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Medical_assistance')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_medical_assistanceValue"
																				 :options="levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_medical_assistance"
																				 @input="set_appraisal_surrounding_medical_assistance"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Leisure')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<multiselect placeholder=""
																				 :value="surrounding_leisureValue"
																				 :options="levelOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.surrounding_leisure"
																				 @input="set_appraisal_surrounding_leisure"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field-container">
																	<div class="field__group">
																		<label class="field__group__label">{{ $t('Notes')
																			}}<span
																					v-if="tags_display">&emsp;<span
																					class="pdf_tag">PDF</span></span></label>
																		<textarea class="field__group__textarea"
																				  rows="3"
																				  spellcheck="false"
																				  v-model="appraisal.surrounding_facilities_notes"
																				  @input="set_appraisal_surrounding_facilities_notes"></textarea>
																	</div>

																</div>
															</td>
														</tr>
													</table>
												</div>

											</div>
											<h3>{{ $t('Communications') }}</h3>
											<div class="section-container">
												<div class="field-container">
													<table>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Airport')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<input class="field__group__input"
																		   type="text"
																		   spellcheck="false"
																		   v-model="appraisal.communications_airport"
																		   @input="set_appraisal_communications_airport">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Harbour')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<input class="field__group__input"
																		   type="text"
																		   spellcheck="false"
																		   v-model="appraisal.communications_harbour"
																		   @input="set_appraisal_communications_harbour">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Train') }}<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																	<input class="field__group__input"
																		   type="text"
																		   spellcheck="false"
																		   v-model="appraisal.communications_train"
																		   @input="set_appraisal_communications_train">
																</div>
															</td>
														</tr>
													</table>


												</div>
												<h3>{{ $t('Public_transport') }}</h3>
												<div class="field-container">
													<table>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Urban_underground')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<input class="field__group__input"
																		   type="text"
																		   spellcheck="false"
																		   v-model="appraisal.public_transport_urban_underground"
																		   @input="set_appraisal_public_transport_urban_underground">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Interurban')
																		}}<span
																				v-if="tags_display">&emsp;<span
																				class="pdf_tag">PDF</span></span></label>
																	<input class="field__group__input"
																		   type="text"
																		   spellcheck="false"
																		   v-model="appraisal.public_transport_interurban"
																		   @input="set_appraisal_public_transport_interurban">
																</div>
															</td>
														</tr>
													</table>


												</div>
											</div>

										</div>
									</form>
								</div>
							</div>
						</v-tab>

						<v-tab :title="land_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Terreny')">{{land_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Terrain')">{{land_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Terreno')">{{land_text}}</div>
							<div class="tab_content">
								<div>
									<form action="" class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Plot_area') }}</h3>
											<div class="field-container">
												<table style="width: 40em;">
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Registry_area')
																	}} (m²)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_registry_area"
																	   @input="set_appraisal_land_registry_area">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Cadastral_area')
																	}} (m²)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_cadastral_area"
																	   @input="set_appraisal_land_cadastral_area">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Checked_area')
																	}} (m²)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_checked_area"
																	   @input="set_appraisal_land_checked_area">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="ms-container">
																<label class="field__group__label">{{ $t('Land_selected_area')
																	}}</label>
																<multiselect placeholder=""
																			 :value="land_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.land_selected_area"
																			 @input="set_appraisal_land_selected_area"></multiselect>
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Adopted_area')
																	}} (m²)<span
																			v-if="tags_display">&emsp;<span
																			class="bde_tag">BdE</span>&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_adopted_area"
																	   @input="set_appraisal_land_adopted_area">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Notes_on_plot_area')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<textarea class="field__group__textarea"
																		  rows="5"
																		  spellcheck="false"
																		  v-model="appraisal.land_area_notes"
																		  @input="set_appraisal_land_area_notes"></textarea>
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Land_is_plot_according_to_law')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_is_plot_according_to_law"
																	   @input="set_appraisal_land_is_plot_according_to_law">
															</div>
														</td>
													</tr>
												</table>
											</div>


										</div>
										<div class="section-container">
											<h3>{{ $t('Plot_occupation') }}</h3>
											<div class="field-container">
												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Plot_occupation')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.plot_occupation"
														   @input="set_appraisal_plot_occupation">
												</div>
												-->
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Plot_occupation')
														}} <span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="plot_occupationValue"
																 :options="plot_occupationOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.plot_occupation"
																 @input="set_appraisal_plot_occupation"></multiselect>
												</div>
												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Plot_free_area_usage')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.plot_free_area_usage"
														   @input="set_appraisal_plot_free_area_usage">
												</div>
												-->
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Plot_free_area_usage')
														}} <span
																v-if="tags_display">&emsp;<span
																class="pdf_tag">PDF</span></span></label>
													<multiselect placeholder=""
																 :value="plot_free_area_usageValue"
																 :options="plot_free_area_usageOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.plot_free_area_usage"
																 @input="set_appraisal_plot_free_area_usage"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Infrastructures') }}</h3>
											<div class="field-container">
												<table style="width: 60em">
													<tr>
														<td style="width: 20em">
															<div class="field__group">
																<label class="field__group__label">{{ $t('Paving')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_paving"
																	   @click="set_appraisal_land_infrastructure_paving">
															</div>

														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Paving_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_paving_execution_pct"
																	   @input="set_appraisal_land_infrastructure_paving_execution_pct">
															</div>

														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Sewage')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_sewage"
																	   @click="set_appraisal_land_infrastructure_sewage">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Sewage_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_sewage_execution_pct"
																	   @input="set_appraisal_land_infrastructure_sewage_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Public_lighting')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_public_lighting"
																	   @click="set_appraisal_land_infrastructure_public_lighting">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Public_lighting_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_public_lighting_execution_pct"
																	   @input="set_appraisal_land_infrastructure_public_lighting_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Water_supply')
																	}}</label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_water_supply"
																	   @click="set_appraisal_land_infrastructure_water_supply">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Water_supply_execution_pct')
																	}}</label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_water_supply_execution_pct"
																	   @input="set_appraisal_land_infrastructure_water_supply_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Electricity_supply')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_electricity_supply"
																	   @click="set_appraisal_land_infrastructure_electricity_supply">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Electricity_supply_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_electricity_supply_execution_pct"
																	   @input="set_appraisal_land_infrastructure_electricity_supply_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Piped_gas')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_piped_gas"
																	   @click="set_appraisal_land_infrastructure_piped_gas">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Piped_gas_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_piped_gas_execution_pct"
																	   @input="set_appraisal_land_infrastructure_piped_gas_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Telephone_service')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_telephone_service"
																	   @click="set_appraisal_land_infrastructure_telephone_service">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Telephone_service_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_telephone_service_execution_pct"
																	   @input="set_appraisal_land_infrastructure_telephone_service_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Gardened_areas')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="checkbox"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_gardened_areas"
																	   @click="set_appraisal_land_infrastructure_gardened_areas">
															</div>
														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label">{{ $t('Gardened_areas_execution_pct')
																	}} (%)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_gardened_areas_execution_pct"
																	   @input="set_appraisal_land_infrastructure_gardened_areas_execution_pct">
															</div>
														</td>
													</tr>
													<tr>
														<td>

														</td>
														<td>
															<div class="field__group">
																<label class="field__group__label"><strong>{{ $t('Total_execution_pct')
																	}} (%)</strong><span
																		v-if="tags_display">&emsp;<span
																		class="pdf_tag">PDF</span></span></label>
																<!--
																<input class="field__group__input"
																	   type="number"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_total_execution_pct"
																	   @input="set_appraisal_land_infrastructure_total_execution_pct">
																	   -->
																<span><strong>{{ appraisal.land_infrastructure_total_execution_pct | formatNumber
																	}} %</strong></span>
															</div>
														</td>

													</tr>
													<tr>
														<td colspan="2">
															<div class="ms-container">
																<label class="field__group__label">{{ $t('Conservation_status')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<multiselect placeholder=""
																			 :value="land_infrastructure_conservation_statusValue"
																			 :options="conservation_statusOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.land_infrastructure_conservation_status"
																			 @input="set_appraisal_land_infrastructure_conservation_status"></multiselect>
															</div>
														</td>
													</tr>
													<tr>
														<td colspan="2">
															<div class="field__group">
																<label class="field__group__label">{{ $t('Infrastructures_repercussion_cost')
																	}} (€/m²)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<input class="field__group__input"
																	   type="number"
																	   min="0"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_repercussion_cost"
																	   @input="set_appraisal_land_infrastructure_repercussion_cost">
															</div>
														</td>
													</tr>
													<tr>
														<td colspan="2">
															<div class="field__group">
																<label class="field__group__label">{{ $t('Pending_investment')
																	}} (€/m²)<span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<!--<input class="field__group__input"
																	   type="number"
																	   spellcheck="false"
																	   v-model="appraisal.land_infrastructure_pending_investment"
																	   @input="set_appraisal_land_infrastructure_pending_investment"> -->

																<span> {{ appraisal.land_infrastructure_pending_investment | formatNumber
																	}} €/m²</span>
															</div>
														</td>
													</tr>
													<tr>
														<td colspan="2">
															<div class="field__group">
																<label class="field__group__label">{{ $t('Notes_on_plot_infrastructures')
																	}} <span
																			v-if="tags_display">&emsp;<span
																			class="pdf_tag">PDF</span></span></label>
																<textarea class="field__group__textarea"
																		  rows="5"
																		  spellcheck="false"
																		  v-model="appraisal.land_infrastructure_notes"
																		  @input="set_appraisal_land_infrastructure_notes"></textarea>
															</div>
														</td>
													</tr>
												</table>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>

						<v-tab :title="features_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Característiques')">{{features_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Features')">{{features_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Características')">{{features_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">

											<div class="section-container">
												<h3>{{ $t('Number_of_floors_and_use') }}</h3>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Floors_number_underground')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.floors_number_underground"
															   @input="set_appraisal_floors_number_underground">
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Floors_usage_underground')
															}}</label>
														<multiselect placeholder=""
																	 :value="floors_usage_undergroundValue"
																	 :options="usage_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.floors_usage_underground"
																	 @input="set_appraisal_floors_usage_underground"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">

													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Groundfloor_usage')
															}}</label>
														<multiselect placeholder=""
																	 :value="groundfloor_usageValue"
																	 :options="usage_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.groundfloor_usage"
																	 @input="set_appraisal_groundfloor_usage"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Floors_number_overground')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.floors_number_overground"
															   @input="set_appraisal_floors_number_overground">
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Floors_usage_overground')
															}}</label>
														<multiselect placeholder=""
																	 :value="floors_usage_overgroundValue"
																	 :options="usage_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.floors_usage_overground"
																	 @input="set_appraisal_floors_usage_overground"></multiselect>
													</div>


												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Features') }}</h3>
												<div class="field-container">
													<table style="width: 30em;">
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Lift')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.lift"
																		   @input="set_appraisal_lift">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Entrance_hall')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.entrance_hall"
																		   @click="set_appraisal_entrance_hall">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Doorman_space')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.doorman_space"
																		   @click="set_appraisal_doorman_space">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Staircase')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.staircase"
																		   @click="set_appraisal_staircase">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Swimming_pool')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.swimming_pool"
																		   @click="set_appraisal_swimming_pool">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Gardened_areas')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.gardened_areas"
																		   @click="set_appraisal_gardened_areas">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Sports_facilities')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.sports_facilities"
																		   @click="set_appraisal_sports_facilities">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Community_room')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.community_room"
																		   @click="set_appraisal_community_room">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Community_parking')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.community_parking"
																		   @click="set_appraisal_community_parking">
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Facilities_others')
																		}}</label>
																	<textarea class="field__group__textarea"
																			  rows="3"
																			  spellcheck="false"
																			  v-model="appraisal.facilities_others"
																			  @input="set_appraisal_facilities_others"></textarea>
																</div>
															</td>
														</tr>
													</table>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Qualities') }}</h3>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Quality_of_neighbourhood')
															}}</label>
														<multiselect placeholder=""
																	 :value="quality_of_neighbourhoodValue"
																	 :options="quality_of_neighbourhoodOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.quality_of_neighbourhood"
																	 @input="set_appraisal_quality_of_neighbourhood"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Quality_of_situation')
															}}</label>
														<multiselect placeholder=""
																	 :value="quality_of_situationValue"
																	 :options="quality_of_situationOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.quality_of_situation"
																	 @input="set_appraisal_quality_of_situation"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Quality_of_construction')
															}}</label>
														<multiselect placeholder=""
																	 :value="quality_of_constructionValue"
																	 :options="quality_of_constructionOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.quality_of_construction"
																	 @input="set_appraisal_quality_of_construction"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Quality_of_realestate')
															}}</label>
														<multiselect placeholder=""
																	 :value="quality_of_realestateValue"
																	 :options="quality_of_realestateOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.quality_of_realestate"
																	 @input="set_appraisal_quality_of_realestate"></multiselect>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Age') }} {{ $t('and') }} {{ $t('conservation_status')
													}} </h3>
												<div class="field-container">
													<!--
													<div class="field__group">
														<label class="field__group__label">{{ $t('Adopted_area') }}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="appraisal.adopted_area"
															   @input="set_appraisal_adopted_area">
													</div>-->
													<div class="field__group">
														<label class="field__group__label">{{ $t('Construction_year')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.construction_year"
															   @input="set_appraisal_construction_year">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Last_renovation_year')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.last_renovation_year"
															   @input="set_appraisal_last_renovation_year">
													</div>

													<div class="field__group">
														<label class="field__group__label">{{ $t('Adopted_age')
															}} ({{ $t('Average') }})</label>
														<!--<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.adopted_age"
															   @input="set_appraisal_adopted_age">-->
														<strong><span>{{ appraisal.adopted_age }}</span></strong>
													</div>
												</div>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Conservation_status')
															}}</label>
														<multiselect placeholder=""
																	 :value="conservation_statusValue"
																	 :options="conservation_statusOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.conservation_status"
																	 @input="set_appraisal_conservation_status"></multiselect>
													</div>

												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Structure') }} {{ $t('and') }} {{ $t('shell') }}</h3>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Foundation')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_foundationValue"
																	 :options="foundationOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_foundation"
																	 @input="set_appraisal_realestate_foundation"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Structure')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_structureValue"
																	 :options="structureOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_structure"
																	 @input="set_appraisal_realestate_structure"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Roof')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_roofValue"
																	 :options="roofOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_roof"
																	 @input="set_appraisal_realestate_roof"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('External_enclosures')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_external_enclosuresValue"
																	 :options="external_enclosuresOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_external_enclosures"
																	 @input="set_appraisal_realestate_external_enclosures"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Insulation')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_insulationValue"
																	 :options="insulationOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_insulation"
																	 @input="set_appraisal_realestate_insulation"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('External_carpentry')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_external_carpentryValue"
																	 :options="external_carpentry_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_external_carpentry"
																	 @input="set_appraisal_realestate_external_carpentry"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Glazing')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_glazingValue"
																	 :options="glazingOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_glazing"
																	 @input="set_appraisal_realestate_glazing"></multiselect>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Interior_finishes') }}</h3>
												<div class="field-container">
													<div class="calc_table overflow_auto">
														<table class="table-striped" style="width: 100%">
															<tr>
																<th style="width: 200px;"></th>
																<th style="width: 300px;">{{ $t('Paving') }}</th>
																<th style="width: 300px;">{{ $t('Walls') }}</th>
																<th style="width: 300px;">{{ $t('Ceilings') }}</th>
																<th style="width: 300px;">{{ $t('Interior_carpentry')
																	}}
																</th>
															</tr>
															<tr>
																<td style="text-align: left;"><strong v-if="appraisal.property_type.name_db == 'residential'">{{ $t('Living')
																	}}</strong><strong v-else="">General</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_livingValue"
																				 :options="pavingOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_living"
																				 @input="set_appraisal_realestate_interior_paving_living"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_livingValue"
																				 :options="wallsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_living"
																				 @input="set_appraisal_realestate_interior_walls_living"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_livingValue"
																				 :options="ceilingsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_living"
																				 @input="set_appraisal_realestate_interior_ceilings_living"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_livingValue"
																				 :options="interior_carpentry_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_living"
																				 @input="set_appraisal_realestate_interior_carpentry_living"></multiselect>
																</td>


															</tr>
															<tr v-if="appraisal.property_type.name_db == 'residential'">
																<td style="text-align: left;">
																	<strong>{{ $t('Circulations')
																		}}</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_corridorValue"
																				 :options="pavingOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_corridor"
																				 @input="set_appraisal_realestate_interior_paving_corridor"></multiselect>
																</td>

																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_corridorValue"
																				 :options="wallsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_corridor"
																				 @input="set_appraisal_realestate_interior_walls_corridor"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_corridorValue"
																				 :options="ceilingsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_corridor"
																				 @input="set_appraisal_realestate_interior_ceilings_corridor"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_corridorValue"
																				 :options="interior_carpentry_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_corridor"
																				 @input="set_appraisal_realestate_interior_carpentry_corridor"></multiselect>
																</td>


															</tr>
															<tr v-if="appraisal.property_type.name_db == 'residential'">
																<td style="text-align: left;"><strong>{{ $t('Bedrooms')
																	}}</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_bedroomValue"
																				 :options="pavingOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_bedroom"
																				 @input="set_appraisal_realestate_interior_paving_bedroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_bedroomValue"
																				 :options="wallsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_bedroom"
																				 @input="set_appraisal_realestate_interior_walls_bedroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_bedroomValue"
																				 :options="ceilingsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_bedroom"
																				 @input="set_appraisal_realestate_interior_ceilings_bedroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_bedroomValue"
																				 :options="interior_carpentry_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_bedroom"
																				 @input="set_appraisal_realestate_interior_carpentry_bedroom"></multiselect>
																</td>


															</tr>
															<tr v-if="appraisal.property_type.name_db == 'residential'">
																<td style="text-align: left;">
																	<strong>{{ $t('Kitchen') }}</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_kitchenValue"
																				 :options="pavingOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_kitchen"
																				 @input="set_appraisal_realestate_interior_paving_kitchen"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_kitchenValue"
																				 :options="wallsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_kitchen"
																				 @input="set_appraisal_realestate_interior_walls_kitchen"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_kitchenValue"
																				 :options="ceilingsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_kitchen"
																				 @input="set_appraisal_realestate_interior_ceilings_kitchen"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_kitchenValue"
																				 :options="interior_carpentry_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_kitchen"
																				 @input="set_appraisal_realestate_interior_carpentry_kitchen"></multiselect>
																</td>


															</tr>
															<tr v-if="appraisal.property_type.name_db == 'residential' || appraisal.property_type.name_db == 'retail_and_industrial' || appraisal.property_type.name_db == 'office'">
																<td style="text-align: left;">
																	<strong>{{ $t('Bathrooms') }}</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_bathroomValue"
																				 :options="pavingOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_bathroom"
																				 @input="set_appraisal_realestate_interior_paving_bathroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_bathroomValue"
																				 :options="wallsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_bathroom"
																				 @input="set_appraisal_realestate_interior_walls_bathroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_bathroomValue"
																				 :options="ceilingsOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_bathroom"
																				 @input="set_appraisal_realestate_interior_ceilings_bathroom"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_bathroomValue"
																				 :options="interior_carpentry_typeOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_bathroom"
																				 @input="set_appraisal_realestate_interior_carpentry_bathroom"></multiselect>
																</td>

															</tr>
															<tr>
																<td style="text-align: left;">
																	<strong>{{ $t('Quality') }}</strong></td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_paving_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_paving_quality"
																				 @input="set_appraisal_realestate_interior_paving_quality"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_walls_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_walls_quality"
																				 @input="set_appraisal_realestate_interior_walls_quality"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_ceilings_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_ceilings_quality"
																				 @input="set_appraisal_realestate_interior_ceilings_quality"></multiselect>
																</td>
																<td>
																	<multiselect placeholder=""
																				 :value="realestate_interior_carpentry_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_interior_carpentry_quality"
																				 @input="set_appraisal_realestate_interior_carpentry_quality"></multiselect>
																</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
											<div class="section-container" v-if="appraisal.property_type.name_db == 'residential'">
												<h3>{{ $t('Habitability_conditions') }}</h3>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Number_of_rooms_to_exterior')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.realestate_rooms_to_exterior_number"
															   @input="set_appraisal_realestate_rooms_to_exterior_number">
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Main_orientation')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_main_orientationValue"
																	 :options="main_orientationOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_main_orientation"
																	 @input="set_appraisal_realestate_main_orientation"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Views')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_main_viewsValue"
																	 :options="main_viewsOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_main_views"
																	 @input="set_appraisal_realestate_main_views"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Windows_size_and_quantity')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_windows_size_and_quantityValue"
																	 :options="windows_size_and_quantityOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_windows_size_and_quantity"
																	 @input="set_appraisal_realestate_windows_size_and_quantity"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Noise_facade')
															}}</label>
														<multiselect placeholder=""
																	 :value="realestate_noise_facadeValue"
																	 :options="noise_levelOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.realestate_noise_facade"
																	 @input="set_appraisal_realestate_noise_facade"></multiselect>
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Day_night_zoning')
															}}</label>
														<input class="field__group__input"
															   type="checkbox"
															   spellcheck="false"
															   v-model="appraisal.realestate_day_night_zoning"
															   @click="set_appraisal_realestate_day_night_zoning">
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Systems') }}</h3>
												<div class="field-container">
													<table style="width: 40em;">
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Door_opener')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_door_opener"
																		   @click="set_appraisal_realestate_systems_door_opener">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Fitted_cupboards')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_fitted_cupboards"
																		   @click="set_appraisal_realestate_systems_fitted_cupboards">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Gas')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_gas"
																		   @click="set_appraisal_realestate_systems_gas">
																</div>
															</td>
														</tr>
														<tr>
															<td style="width: 15em;">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Sanitary_fittings')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_sanitary_fittings"
																		   @click="set_appraisal_realestate_systems_sanitary_fittings">
																</div>
															</td>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Sanitary_fittings_quality')
																		}}</label>
																	<multiselect placeholder=""
																				 :value="realestate_systems_sanitary_fittings_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_systems_sanitary_fittings_quality"
																				 @input="set_appraisal_realestate_systems_sanitary_fittings_quality"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td>
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Taps')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_taps"
																		   @click="set_appraisal_realestate_systems_taps">
																</div>
															</td>
															<td>
																<div class="ms-container">
																	<label class="field__group__label">{{ $t('Taps_quality')
																		}}</label>
																	<multiselect placeholder=""
																				 :value="realestate_systems_taps_qualityValue"
																				 :options="quality_of_finishesOptions"
																				 track-by="id"
																				 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																				 :searchable="true"
																				 v-model="appraisal.realestate_systems_taps_quality"
																				 @input="set_appraisal_realestate_systems_taps_quality"></multiselect>
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Hot_water')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_hot_water"
																		   @click="set_appraisal_realestate_systems_hot_water">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Heating')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_heating"
																		   @click="set_appraisal_realestate_systems_heating">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Air_conditioning')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_air_conditioning"
																		   @click="set_appraisal_realestate_systems_air_conditioning">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">Tv</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_tv"
																		   @click="set_appraisal_realestate_systems_tv">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Telephone')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_telephone"
																		   @click="set_appraisal_realestate_systems_telephone">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Fire_prevention')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_fire_prevention"
																		   @click="set_appraisal_realestate_systems_fire_prevention">
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="2">
																<div class="field__group">
																	<label class="field__group__label">{{ $t('Intrusion_prevention')
																		}}</label>
																	<input class="field__group__input"
																		   type="checkbox"
																		   spellcheck="false"
																		   v-model="appraisal.realestate_systems_intrusion_prevention"
																		   @click="set_appraisal_realestate_systems_intrusion_prevention">
																</div>
															</td>
														</tr>
													</table>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{$t('Real_estates_useful_life') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Real_estates_total_useful_life')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.useful_life_years"
														   @input="set_appraisal_useful_life_years">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Remaining_useful_life_years')
														}}</label>
													<!--<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.remaining_useful_life_years"
														   @input="set_appraisal_remaining_useful_life_years">-->
													<span>{{ appraisal.remaining_useful_life_years }} {{ $t('years')
														}}</span>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Construction_cost') }}</h3>

											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Property_type')}} (B.E.C.)</label>
													<multiselect placeholder=""
																 :value="bec_property_typeValue"
																 :options="this.object_to_array(appraisal_bec_properties)"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.bec_property_type"
																 @input="set_appraisal_bec_property_type"></multiselect>
												</div>
												<div class="ms-container" v-if="appraisal.bec_property_type">
													<label class="field__group__label">{{ $t('Number')}} (B.E.C.)</label>
													<multiselect placeholder=""
																 :value="bec_numberValue"
																 :options="this.object_to_array(appraisal_bec_prices)"
																 track-by="id"
																 :label="'number'"
																 :searchable="true"
																 v-model="appraisal.bec_number"
																 @input="set_appraisal_bec_number"></multiselect>
												</div>
												<div class="ms-container" v-if="appraisal.bec_number">
													<label class="field__group__label">{{ $t('Year')}}</label>
													<span> {{ appraisal.bec_number.year }} </span>
												</div>
												<div class="ms-container" v-if="appraisal.bec_number">
													<label class="field__group__label">{{ $t('Quarter')}}</label>
													<span> {{ appraisal.bec_number.quarter }} </span>
												</div>
											</div>
											<div class="field-container" v-if="appraisal.bec_number">
												<div class="field__group">
													<label class="field__group__label">B.E.C. {{ $t('Construction_cost')
														}} total</label>
													<strong><span> {{ appraisal.bec_number.total | formatNumber}} €/m²</span></strong>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Bec_adjustment_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   step="0.05"
														   spellcheck="false"
														   v-model="appraisal.bec_adjustment_coef"
														   @input="set_appraisal_bec_adjustment_coef">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adjusted_bec_price')
														}}</label>
													<span> {{ appraisal.adjusted_bec_price | formatNumber }} €/m²</span>
												</div>
											</div>
											<div class="field-container" v-if="appraisal.bec_number">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Expenses_and_industrial_benefit_bec_pct')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.expenses_and_industrial_benefit_bec_pct"
														   @input="set_appraisal_expenses_and_industrial_benefit_bec_pct">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Material_execution_cost')
														}}</label>
													<span> {{ appraisal.material_execution_cost | formatNumber
														}} €/m²</span>
												</div>
											</div>
											<div class="field-container" v-if="appraisal.bec_number">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Mec_adjustment_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   min="0"
														   step="0.05"
														   spellcheck="false"
														   v-model="appraisal.mec_adjustment_coef"
														   @input="set_appraisal_mec_adjustment_coef">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_material_execution_cost')
														}}</label>
													<strong><span> {{ appraisal.adopted_material_execution_cost | formatNumber
														}} €/m²</span></strong>
												</div>
											</div>
											<div class="field-container" v-if="appraisal.bec_number">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_cost_notes')
														}}</label>
													<textarea class="field__group__textarea"
															  rows="5"
															  spellcheck="false"
															  v-model="appraisal.construction_cost_notes"
															  @input="set_appraisal_construction_cost_notes"></textarea>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Construction_status') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Construction_status')
														}}</label>
													<multiselect placeholder=""
																 :value="construction_statusValue"
																 :options="construction_statusOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.construction_status"
																 @input="set_appraisal_construction_status"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_progress_percentage') }}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   max="100"
														   step="1"
														   min="0"
														   v-model="appraisal.total_construction_progress_pct"
														   @input="set_appraisal_total_construction_progress_pct">
												</div>
											</div>
											<br>
											<span v-if="appraisal.total_construction_progress_pct < 100" style="background: lightyellow"><strong>Nota:</strong> Degut a que l'immoble es troba en construcció, en els càlculs es forçarà que l'edifici no està depreciat per antiguitat (da = 1 - d = 100%)</span>
											<!--
											<div class="field-container">
												<div class="" v-if="appraisal.bec_number">
													<table class="table-striped" style="width: 100%">
														<tr>
															<th></th>
															<th style="min-width: 120px;">
																{{ $t('Price') }} (€/m²)
															</th>

														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Movimiento tierras</strong></td>
															<td>
																<span> {{ appraisal.bec_number.movimiento_tierras | formatNumber
																	}} €/m²</span>

															</td>
														</tr>

														<tr>
															<td style="text-align: left">
																<strong>Cimentación y muro sótano</strong></td>
															<td>
																<span> {{ appraisal.bec_number.cimentacion_y_muro_sotano | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Estructura</strong></td>
															<td>
																<span> {{ appraisal.bec_number.estructura | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Saneamiento (horizontal y vertical)</strong>
															</td>
															<td>
																<span> {{ appraisal.bec_number.saneamiento | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería gruesa</strong></td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_gruesa | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería, azoteas e impermeabilización</strong>
															</td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_azoteas | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería, acabados de fachada</strong></td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_acabados_fachada | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería, solados</strong></td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_solados | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería, acabados interiores</strong></td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_acabados_interiores | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Albañilería, ayudas a industriales</strong></td>
															<td>
																<span> {{ appraisal.bec_number.albanileria_ayudas_industriales | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Yesería cielosrasos</strong></td>
															<td>
																<span> {{ appraisal.bec_number.yeseria_cielosrasos | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Cerrajería</strong></td>
															<td>
																<span> {{ appraisal.bec_number.cerrajeria | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Carpintería exterior</strong></td>
															<td>
																<span> {{ appraisal.bec_number.carpinteria_exterior | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Carpintería interior</strong></td>
															<td>
																<span> {{ appraisal.bec_number.carpinteria_interior | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Persianas</strong></td>
															<td>
																<span> {{ appraisal.bec_number.persianas | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Fontanería</strong></td>
															<td>
																<span> {{ appraisal.bec_number.fontaneria | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Material sanitario grifería</strong></td>
															<td>
																<span> {{ appraisal.bec_number.mat_sanitario_griferia | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Electricidad</strong></td>
															<td>
																<span> {{ appraisal.bec_number.electricidad | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Aire acondicionado</strong></td>
															<td>
																<span> {{ appraisal.bec_number.aire_acondicionado | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Instalaciones especiales</strong></td>
															<td>
																<span> {{ appraisal.bec_number.instal_especiales | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Fumistería y muebles cocina</strong></td>
															<td>
																<span> {{ appraisal.bec_number.fumisteria_y_muebles_cocina | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Ascensores</strong></td>
															<td>
																<span> {{ appraisal.bec_number.ascensores | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Vidrieria</strong></td>
															<td>
																<span> {{ appraisal.bec_number.vidrieria | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Pintura y estucos</strong></td>
															<td>
																<span> {{ appraisal.bec_number.pintura_y_estucos | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Calefacción</strong></td>
															<td>
																<span> {{ appraisal.bec_number.calefaccion | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Energía solar a.c.s.</strong></td>
															<td>
																<span> {{ appraisal.bec_number.energia_solar_acs | formatNumber
																	}} €/m²</span>
															</td>
														</tr>

														<tr>
															<td style="text-align: left">
																<strong>Jardinería decorativa</strong></td>
															<td>
																<span> {{ appraisal.bec_number.jardineria_decorativa | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Renovación de aire</strong></td>
															<td>
																<span> {{ appraisal.bec_number.renovacion_aire | formatNumber
																	}} €/m²</span>
															</td>
														</tr>

														<tr>
															<td style="text-align: left">
																<strong>Subtotal</strong></td>
															<td>

																<strong><span> {{ appraisal.bec_number.subtotal | formatNumber
																	}} €/m²</span></strong>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Seguridad y salud (2%)</strong></td>
															<td>

																<span> {{ appraisal.bec_number.seguridad_y_salud | formatNumber
																	}} €/m²</span>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>Total</strong></td>
															<td>

																<strong><span> {{ appraisal.bec_number.total | formatNumber
																	}} €/m²</span></strong>
															</td>
														</tr>


													</table>
												</div>
											</div>
											-->
											<!--
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Bec_adjustment_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.bec_adjustment_coef"
														   @input="set_appraisal_bec_adjustment_coef">
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Bec_property_type')
														}}</label>
													<multiselect placeholder=""
																 :value="bec_property_typeValue"
																 :options="bec_property_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.bec_property_type"
																 @input="set_appraisal_bec_property_type"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Bec_number') }}</label>
													<multiselect placeholder=""
																 :value="bec_numberValue"
																 :options="bec_numberOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.bec_number"
																 @input="set_appraisal_bec_number"></multiselect>
												</div>


											</div>
											-->
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<!--- TODO: al canviar algun tipus de les característiques que es fan servir per a l'estudi de mercat... recalcular estudi de mercat i actualitzar les taxaciones que pengin d'aquell estudi de mercat -->
						<v-tab :title="Areas_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Superfícies')">{{Areas_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Areas')">{{Areas_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Superficies')">{{Areas_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<div class="section-container">
												<h3>{{ $t('Net_areas') }}</h3>
												<div>
													<div @click.prevent="onCreateNewRoom"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle" :text="new_room_button_text"
																	 icon_color="black"
																	 :text_color="editing_room_text_color"
																	 :disabled="editing_room"
																	 :border_color="editing_room_border_color"></icon-button>
													</div>
												</div>


												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-main"
																	   :source="object_to_array(appraisal_rooms)"
																	   :filterable="false"
																	   :striped="room_table.striped"
																	   :editable="room_table.editable"
																	   :line-numbers="room_table.lineNumbers">
																<datatable-column
																		v-for="column in room_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-rooms"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-rooms" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="deleteRoom(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="netarea" scope="cell">
																	<div class="">
																		<input type="number"
																			   min="0"
																			   v-model="cell.row['netarea']"
																			   @input="set_room_netarea($event, cell.row)">

																	</div>
																</template>
																<template slot="description" scope="cell">
																	<div class="">
																		<input type="text"
																			   v-model="cell.row['description']"
																			   @input="set_room_description($event, cell.row)">
																	</div>
																</template>
																<template slot="type" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="room_typeValue"
																					 :options="room_typeOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['type']"
																					 @input="set_room_type($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Bedrooms_and_bathrooms') }}</h3>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Bathrooms_number')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.bathrooms_number"
															   @input="set_appraisal_bathrooms_number">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Bedrooms_number')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.bedrooms_number"
															   @input="set_appraisal_bedrooms_number">
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Enclosed_area') }}</h3>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Enclosed_checked_area')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.enclosed_checked_area"
															   @input="set_appraisal_enclosed_checked_area">
													</div>
													<div class="field-group">
														<div v-if="!this.appraisal.enclosed_checked_area || this.appraisal.enclosed_checked_area < this.appraisal.net_checked_area">
															<message
																	:text="enclosed_checked_area_error_text"
																	icon_name="exclamation"
																	icon_color="darkred"
																	border_color="red" text_color="darkred">
															</message>
														</div>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Proportional_part_of_common_elements') }}</h3>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Common_elements_cadastral_area')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.common_elements_cadastral_area"
															   @input="set_appraisal_common_elements_cadastral_area">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Common_elements_registry_area')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.common_elements_registry_area"
															   @input="set_appraisal_common_elements_registry_area">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Common_elements_checked_area')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.common_elements_checked_area"
															   @input="set_appraisal_common_elements_checked_area">
													</div>
													<!--
													<div class="field__group">
														<label class="field__group__label">{{ $t('Common_elements_adopted_area')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.common_elements_adopted_area"
															   @input="set_appraisal_common_elements_adopted_area">
													</div>-->
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Covered_outdoor_areas') }}</h3>
												<div>
													<div @click.prevent="onCreateNewCoveredOutdoor"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle"
																	 :text="new_covered_outdoor_button_text"
																	 icon_color="black"
																	 :text_color="editing_covered_outdoor_text_color"
																	 :disabled="editing_covered_outdoor"
																	 :border_color="editing_covered_outdoor_border_color"></icon-button>
													</div>
												</div>


												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="covered-outdoor-table-main"
																	   :source="object_to_array(appraisal_covered_outdoors)"
																	   :filterable="false"
																	   :striped="covered_outdoor_table.striped"
																	   :editable="covered_outdoor_table.editable"
																	   :line-numbers="covered_outdoor_table.lineNumbers">
																<datatable-column
																		v-for="column in covered_outdoor_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-covered-outdoors"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-covered-outdoors" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="deleteCoveredOutdoor(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="netarea" scope="cell">
																	<div class="">
																		<input type="number"
																			   min="0"
																			   v-model="cell.row['netarea']"
																			   @input="set_covered_outdoor_netarea($event, cell.row)">

																	</div>
																</template>
																<template slot="description" scope="cell">
																	<div class="">
																		<input type="text"
																			   v-model="cell.row['description']"
																			   @input="set_covered_outdoor_description($event, cell.row)">
																	</div>
																</template>
																<template slot="type" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="covered_outdoor_typeValue"
																					 :options="covered_outdoor_typeOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['type']"
																					 @input="set_covered_outdoor_type($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Uncovered_outdoor_areas') }}</h3>
												<div>
													<div @click.prevent="onCreateNewUncoveredOutdoor"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle"
																	 :text="new_uncovered_outdoor_button_text"
																	 icon_color="black"
																	 :text_color="editing_uncovered_outdoor_text_color"
																	 :disabled="editing_uncovered_outdoor"
																	 :border_color="editing_uncovered_outdoor_border_color"></icon-button>
													</div>
												</div>


												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="uncovered-outdoor-table-main"
																	   :source="object_to_array(appraisal_uncovered_outdoors)"
																	   :filterable="false"
																	   :striped="uncovered_outdoor_table.striped"
																	   :editable="uncovered_outdoor_table.editable"
																	   :line-numbers="uncovered_outdoor_table.lineNumbers">
																<datatable-column
																		v-for="column in uncovered_outdoor_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-uncovered-outdoors"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-uncovered-outdoors"
																		  scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="deleteUncoveredOutdoor(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="netarea" scope="cell">
																	<div class="">
																		<input type="number"
																			   min="0"
																			   v-model="cell.row['netarea']"
																			   @input="set_uncovered_outdoor_netarea($event, cell.row)">

																	</div>
																</template>
																<template slot="description" scope="cell">
																	<div class="">
																		<input type="text"
																			   v-model="cell.row['description']"
																			   @input="set_uncovered_outdoor_description($event, cell.row)">
																	</div>
																</template>
																<template slot="type" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="uncovered_outdoor_typeValue"
																					 :options="uncovered_outdoor_typeOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['type']"
																					 @input="set_uncovered_outdoor_type($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>


											<div class="section-container">
												<h3>{{ $t('Total_areas_summary_table') }}</h3>

												<div class="calc_table">
													<table class="table-striped" style="width: 100%">
														<tr>
															<th></th>
															<th style="min-width: 120px; text-align: right">
																{{ $t('Registry') }}
															</th>
															<th style="min-width: 120px">{{ $t('Cadaster') }}</th>
															<th style="min-width: 120px">{{ $t('Checked') }}</th>
															<th style="min-width: 300px">{{ $t('Selected') }}</th>
															<th style="min-width: 120px">{{ $t('Adopted') }}</th>
														</tr>
														<tr>
															<td style="text-align: left"><strong>{{ $t('Net_area')
																}}</strong></td>
															<td>{{ appraisal.net_registry_area | formatNumber }} m²</td>
															<td>{{ appraisal.net_cadastral_area | formatNumber }} m²
															</td>
															<td>{{ appraisal.net_checked_area | formatNumber }} m²</td>
															<td>

																<multiselect placeholder=""
																			 :value="net_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.net_selected_area"
																			 @input="set_appraisal_net_selected_area"></multiselect>
															</td>
															<td>{{ appraisal.net_adopted_area | formatNumber }} m²</td>
														</tr>
														<tr>
															<td style="text-align: left"><strong>{{ $t('Enclosed_area')
																}} (A)</strong></td>
															<td>{{ appraisal.enclosed_registry_area | formatNumber }} m²
															</td>
															<td>{{ appraisal.enclosed_cadastral_area | formatNumber
																}} m²
															</td>
															<td>{{ appraisal.enclosed_checked_area | formatNumber
																}} m²
															</td>
															<td>

																<multiselect placeholder=""
																			 :value="enclosed_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.enclosed_selected_area"
																			 @input="set_appraisal_enclosed_selected_area"></multiselect>
															</td>
															<td>{{ appraisal.enclosed_adopted_area | formatNumber
																}} m²
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>{{ $t('Covered_outdoor_area') }} (B)</strong>
															</td>
															<td>
																{{ appraisal.covered_terraces_total_registry_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.covered_terraces_total_cadastral_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.covered_terraces_total_checked_area | formatNumber
																}} m²
															</td>
															<td>

																<multiselect placeholder=""
																			 :value="covered_outdoors_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.covered_outdoors_selected_area"
																			 @input="set_appraisal_covered_outdoors_selected_area"></multiselect>
															</td>
															<td>
																{{ appraisal.covered_terraces_total_adopted_area | formatNumber
																}} m²
															</td>
														</tr>
														<tr>
															<td style="text-align: left"><strong>{{ $t('Built_area')
																}} ( (A+B) / 2 )</strong></td>
															<td>{{ appraisal.built_registry_area | formatNumber }} m²
															</td>
															<td>{{ appraisal.built_cadastral_area | formatNumber }} m²
															</td>
															<td>{{ appraisal.built_checked_area | formatNumber }} m²
															</td>
															<td>

																<multiselect placeholder=""
																			 :value="built_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.built_selected_area"
																			 @input="set_appraisal_built_selected_area"></multiselect>
															</td>
															<td><strong>{{ appraisal.built_adopted_area | formatNumber
																}} m²</strong>
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>{{ $t('Common_elements') }}</strong>
															</td>
															<td>
																{{ appraisal.common_elements_registry_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.common_elements_cadastral_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.common_elements_checked_area | formatNumber
																}} m²
															</td>
															<td>

																<multiselect placeholder=""
																			 :value="common_elements_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.common_elements_selected_area"
																			 @input="set_appraisal_common_elements_selected_area"></multiselect>
															</td>
															<td>
																{{ appraisal.common_elements_adopted_area | formatNumber
																}} m²
															</td>
														</tr>
														<tr>
															<td style="text-align: left">
																<strong>{{ $t('Built_plus_common_elements') }}</strong>
															</td>
															<td>
																{{ appraisal.built_plus_common_elements_registry_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.built_plus_common_elements_cadastral_area | formatNumber
																}} m²
															</td>
															<td>
																{{ appraisal.built_plus_common_elements_checked_area | formatNumber
																}} m²
															</td>
															<td>
																<multiselect placeholder=""
																			 :value="built_plus_common_elements_selected_areaValue"
																			 :options="selected_areaOptions"
																			 track-by="id"
																			 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																			 :searchable="true"
																			 v-model="appraisal.built_plus_common_elements_selected_area"
																			 @input="set_appraisal_built_plus_common_elements_selected_area"></multiselect>
															</td>
															<td>
																{{ appraisal.built_plus_common_elements_adopted_area | formatNumber
																}} m²
															</td>
														</tr>
													</table>
												</div>
											</div>
										</div>

									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="cession_and_rights_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Cessió, drets i protecció')">{{cession_and_rights_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Cession, rights and protection')">{{cession_and_rights_text}}
							</div>
							<div v-else slot="title"
								 @click.prevent="setCurrentTabTitle('Cessión, derechos y protección')">{{cession_and_rights_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Occupancy') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Property_title')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.property_title"
														   @input="set_appraisal_property_title">
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Occupancy_status')
														}}</label>
													<multiselect placeholder=""
																 :value="occupancy_statusValue"
																 :options="occupancy_statusOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="appraisal.occupancy_status"
																 @input="set_appraisal_occupancy_status"></multiselect>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Usage_assigned')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.usage_assigned"
														   @input="set_appraisal_usage_assigned">
												</div>
												<div class="field-group">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Property_usage') }} (BdE)</label>
														<multiselect placeholder=""
																	 :value="usage_typeBdEValue"
																	 :options="usage_typeBdEOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.usage_type"
																	 @input="set_appraisal_usage_type"></multiselect>
													</div>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Inspection_realized')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.inspection_realized"
														   @input="set_appraisal_inspection_realized">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Economical_activity')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.economical_activity"
														   @input="set_appraisal_economical_activity">
												</div>


											</div>
										</div>
										<div class="form-section">
											<h3>{{ $t('Lease') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Is_it_rented_or_ceded_q')
														}}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="appraisal.cession_boolean"
														   @click="set_appraisal_cession_boolean">
												</div>
											</div>
											<div v-if="appraisal.cession_boolean">
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_contract_start_date')
															}}</label>
														<input class="field__group__input"
															   type="date"
															   spellcheck="false"
															   v-model="appraisal.cession_contract_start_date"
															   @input="set_appraisal_cession_contract_start_date">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_contract_period_years')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.cession_contract_period_years"
															   @input="set_appraisal_cession_contract_period_years">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_contract_remaining_years')
															}} ({{ $t('acc_appraisal_date')}})</label>
														<span>{{ appraisal.cession_contract_remaining_years
															}} {{ $t('years') }}</span>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_gross_monthly_income')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.cession_gross_monthly_income"
															   @input="set_appraisal_cession_gross_monthly_income">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_gross_yearly_income')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.cession_gross_yearly_income"
															   @input="set_appraisal_cession_gross_yearly_income">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Landlord_expenses_pct')
															}} (%)</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.landlord_expenses_pct"
															   @input="set_appraisal_landlord_expenses_pct">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_net_yearly_income')
															}}</label>
														<span>{{ appraisal.cession_net_yearly_income | formatNumber
															}} €</span>
													</div>
												</div>
												<div class="fiel-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Cession_gross_monthly_income_by_contract')
															}}</label>
														<!--<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.cession_gross_monthly_income_by_contract"
															   @input="set_appraisal_cession_gross_monthly_income_by_contract">-->
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Tenant_age_years')
															}} ({{ $t('years') }})</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.tenant_age_years"
															   @input="set_appraisal_tenant_age_years">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Tenant_life_expectancy_years')
															}} ({{ $t('years') }})</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.tenant_life_expectancy_years"
															   @input="set_appraisal_tenant_life_expectancy_years">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Tenant_remaining_life_expectancy_years')
															}} ({{ $t('years') }})</label>
														<span>{{ appraisal.tenant_remaining_life_expectancy_years
															}} {{ $t('years') }}</span>
													</div>
												</div>
											</div>

										</div>
										<div class="form-section">
											<h3>{{ $t('Right_of_use') }} {{ $t('and') }} {{ $t('Bare_ownership') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Is_the_right_of_use_ceded_q')
														}}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="appraisal.right_of_use_boolean"
														   @click="set_appraisal_right_of_use_boolean">
												</div>
											</div>
											<div v-if="appraisal.right_of_use_boolean">
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Usufructuary_age_years')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.usufructuary_age_years"
															   @input="set_appraisal_usufructuary_age_years">
													</div>

												</div>
											</div>

										</div>
										<div class="form-section">
											<h3>{{ $t('Protection_regime') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Is_the_real_estate_protected_q')
														}}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="appraisal.protection_boolean"
														   @click="set_appraisal_protection_boolean">
												</div>
											</div>
											<div v-if="appraisal.protection_boolean">
												<div class="field-container">
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Protection_type')
															}}</label>
														<multiselect placeholder=""
																	 :value="protection_typeValue"
																	 :options="protection_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.protection_type"
																	 @input="set_appraisal_protection_type"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Protection_regime')
															}}</label>
														<multiselect placeholder=""
																	 :value="protection_regimeValue"
																	 :options="protection_regimeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.protection_regime"
																	 @input="set_appraisal_protection_regime"></multiselect>
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Protection_zone')
															}}</label>
														<multiselect placeholder=""
																	 :value="protection_zoneValue"
																	 :options="protection_zoneOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="appraisal.protection_zone"
																	 @input="set_appraisal_protection_zone"></multiselect>
													</div>
												</div>
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Maximum_legal_sale_price')
															}} (€/m²)</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.max_legal_price"
															   @input="set_appraisal_max_legal_price">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Maximum_legal_computable_area')
															}} (m²)</label>
														<input class="field__group__input"
															   type="number"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.max_legal_area"
															   @input="set_appraisal_max_legal_area">
													</div>
												</div>
											</div>

										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="Market_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Mercat')">{{Market_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Market')">{{Market_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Mercado')">{{Market_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Market_study') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Select') }} {{ $t('a')
														}} {{ $t('Market_study') }}</label>
													<multiselect placeholder=""
																 :value="marketstudy_idValue"
																 :options="this.object_to_array(realestate_marketstudies)"
																 track-by="id"
																 :label="'id'"
																 :searchable="true"
																 @input="set_appraisal_marketstudy_id"></multiselect>
												</div>
												<div class="field__group">
													<label class="field__group__label">Id</label>
													<span> {{ appraisal.marketstudy_id }} </span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Market_value') }}</label>
													<span> {{ appraisal.market_value | formatNumber }} € </span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Market_unit_value')
														}}</label>
													<strong><span> {{ appraisal.market_unit_value | formatNumber
														}} €/m² </span></strong>
												</div>
											</div>
										</div>
										<div class="section-container">
											<div class="field__group">
												<button
														class="quote-request__aux__button"
														@click.prevent="onOpenMarketStudy"
														@keyup.enter="onOpenMarketStudy">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Edit')}}&nbsp;{{ $t('Market_study')}}</span>
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="technical_values_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Valors tècnics')">{{technical_values_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Technical values')">{{technical_values_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Valores técnicos')">{{technical_values_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Construction_cost_by_contract') }}</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Adjusted_bec_price') }}</td>
													<td>{{ appraisal.adjusted_bec_price }}</td>
												</tr>
												<tr>
													<td>{{ $t('BEC_expenses_plus_builders_benefit_pct') }}</td>
													<td>{{ appraisal.expenses_and_industrial_benefit_bec_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Material_execution_cost_as_new') }}</td>
													<td> {{ appraisal.material_execution_cost | formatNumber }} €/m²
													</td>
												</tr>
												<tr>
													<td>{{ $t('Mec_adjustment_coef') }}</td>
													<td><!--{{ appraisal.mec_adjustment_coef }}--><input class="field__group__input"
																										  type="number"
																										  min="0"
																										  step="0.05"
																										  spellcheck="false"
																										  v-model="appraisal.mec_adjustment_coef"
																										  @input="set_appraisal_mec_adjustment_coef"></td>
												</tr>
												<tr>
													<td>{{ $t('Adopted_material_execution_cost') }}</td>
													<td> {{ appraisal.adopted_material_execution_cost | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Integrity') }} {{ $t('or') }} {{ $t('remaining') }} {{ $t('of') }} {{ $t('Depreciation_by_antiquity') }} (da = 100 - d)</td>
													<td>{{ appraisal.total_depreciation_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Adopted_material_execution_cost_deprecated_by_antiquity')}} (Cem))
													</td>
													<td>{{ appraisal.deprecated_material_execution_cost | formatNumber}} €/m²
													</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_industrial_benefit_percentage') }}</td>
													<td><input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.bc_pct"
															   @input="set_appraisal_bc_pct"> %</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_industrial_benefit') }}</td>
													<td>{{ appraisal.bc | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_general_expenses_percentage') }} (% Gc)</td>
													<td><input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.gc_pct"
															   @input="set_appraisal_gc_pct"> %</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_general_expenses') }} (Gc) </td>
													<td>{{ appraisal.gc | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_expenses_and_benefit_percentage')
														}} (% Bc + % Gc)
													</td>
													<td>{{ appraisal.bc_and_gc_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Builders_expenses_and_benefit') }} (Bc + Gc) </td>
													<td>{{ appraisal.bc_and_gc | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Construction_costs')
														}} (Cc = Cem + Bc + Gc) </strong></td>
													<td><strong>{{ appraisal.cc | formatNumber }} €/m²</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Development_expenses') }}</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Honorarium_c_taxes_and_licenses_percentage')
														}} (% HTL)
													</td>
													<td>{{ appraisal.htl_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Honorarium_c_taxes_and_licenses')
														}} (HTL)
													</td>
													<td>{{ appraisal.htl | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Non_recoverable_taxes_percentage')
														}} % Impostos no recuperables (% INR)
													</td>
													<td>{{ appraisal.inr_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Non_recoverable_taxes')
														}} Impostos no recuperables (INR)
													</td>
													<td>{{ appraisal.inr | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Developers_administrative_expenses_percentage')
														}} (% Ga)
													</td>
													<td>{{ appraisal.ga_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Developers_administrative_expenses') }} (Ga)</td>
													<td>{{ appraisal.ga | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Decennial_insurance_policy_expenses_percentage')
														}} (% Gpd)
													</td>
													<td>{{ appraisal.gpd_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Decennial_insurance_policy_expenses') }} (Gpd)</td>
													<td>{{ appraisal.gpd | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>% OCT</td>
													<td>{{ appraisal.oct_pct }} %</td>
												</tr>
												<tr>
													<td>OCT</td>
													<td>{{ appraisal.oct | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Development_expenses_percentage')}} (% Gp = % HTL + % INR + % Ga + % Gpd + % OCT)
													</td>
													<td>{{ appraisal.gp_pct }} %</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Development_expenses')
														}} (Gp = HTL + INR + Ga + Gpd + OCT)</strong>
													</td>
													<td><strong>{{ appraisal.gp | formatNumber }} €/m²</strong></td>
												</tr>
												<tr>
													<td>{{ $t('Construction_costs')
														}} (Cc)
													</td>
													<td>{{ appraisal.cc | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Construction_replacement_cost')
														}} (Cc + Gp)</strong>
													</td>
													<td><strong>{{ appraisal.cc_and_gp | formatNumber }} €/m²</strong>
													</td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Developers_benefit') }}</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Riskfree_rate')}} (TLR)
													</td>
													<td>{{ appraisal.tlr_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Risk_premium') }} (PR)
													</td>
													<td>{{ appraisal.pr_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Agravation_or_improvement_coeficient')}} (Coef. AM)
													</td>
													<td>{{ appraisal.am_coef }}</td>
												</tr>
												<tr>
													<td>{{ $t('Freemarket_benefit')}} (b1 = (TLR + PR) * Coef. AM )
													</td>
													<td>{{ appraisal.b1_pct}} %</td>
												</tr>
												<tr>
													<td>{{ $t('Minimum_benefit_acc_to_regulation')}} (b2)
													</td>
													<td>{{ appraisal.b2_pct }} %</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Developers_benefit') }}  (max: b1 vs b2)</strong>
													</td>
													<td><strong>{{ appraisal.b_pct }} %</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Land_market_value') }}</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Building_market_value') }}
													</td>
													<td>{{ appraisal.market_unit_value | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Market_value_adjustment') }} (%)
													</td>
													<td><!--{{ appraisal.market_value_appraiser_adjustment_pct }} %-->
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="appraisal.market_value_appraiser_adjustment_pct"
															   @input="set_appraisal_market_value_appraiser_adjustment_pct"> %</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Adopted_building_market_value') }} (VM)</strong>
													</td>
													<td><strong>{{ appraisal.adopted_market_unit_value | formatNumber
														}} €/m²</strong>
													</td>
												</tr>
												<tr>
													<td>{{ $t('Construction_costs') }} (Cc)
													</td>
													<td>{{ appraisal.cc | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Development_expenses') }} (Gp)
													</td>
													<td>{{ appraisal.gp | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Remaining_of_the_developers_benefit') }} (1-b)
													</td>
													<td>{{ appraisal.b_remaining_pct }} %</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Land_market_value')
														}} ( F = Vm * (1-b) - (Cc + Gp) )</strong>
													</td>
													<td><strong>{{ appraisal.f | formatNumber }} €/m²</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>CRB: {{ $t('Gross_Replacement_Cost') }} ({{ $t('finished_building')
												}})</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Land_market_value') }} (F)
													</td>
													<td>{{ appraisal.f | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('As_new_construction_cost') }} (Ccb)
													</td>
													<td>{{ appraisal.ccb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Development_expenses') }} (Gpb)
													</td>
													<td>{{ appraisal.gpb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td><strong>{{ $t('Gross_Replacement_Cost') }} (CRB)</strong>
													</td>
													<td><strong>{{ appraisal.crb | formatNumber }} €/m²</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>CRN: {{ $t('Net_Replacement_Cost') }} ({{ $t('finished_building')
												}})</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Land_market_value') }} (F)
													</td>
													<td>{{ appraisal.f | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('As_new_construction_cost') }} (Ccb)
													</td>
													<td>{{ appraisal.ccb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Development_expenses') }} (Gpb)
													</td>
													<td>{{ appraisal.gpb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Construction_cost_and_development_expenses') }} (Ccb + Gpb)
													</td>
													<td>{{ appraisal.ccb_and_gpb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Adopted_age') }} (A)
													</td>
													<td>{{ appraisal.adopted_age_years_old }} {{ $t('years')
														}} ({{ appraisal.adopted_age }})
													</td>
												</tr>
												<tr>
													<td>{{ $t('Estimated_useful_life') }} (V<sub>u</sub>)
													</td>
													<td>{{ appraisal.useful_life_years }} {{ $t('years') }}</td>
												</tr>
												<tr>
													<td>{{ $t('Physical_depreciation') }} (DFI = A * V<sub>u</sub>)
													</td>
													<td>{{ appraisal.physical_depreciation_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Functional_depreciation') }} (DFU)
													</td>
													<td>{{ appraisal.functional_depreciation_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Total_depreciation') }} (D = (1 - DFI) * (1 - DFU))
													</td>
													<td>{{ appraisal.total_depreciation_pct }} %</td>
												</tr>
												<tr>
													<td>{{ $t('Deprecated_construction_cost') }} (CCD = (Ccb + Gpb) * D)
													</td>
													<td>{{ appraisal.ccd | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Developers_administrative_expenses') }} (Ga)
													</td>
													<td>{{ appraisal.ga | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Land_value_plus_deprecated_construction_cost')
														}} (F + Ccd)
													</td>
													<td>{{ appraisal.deprecated_land_and_ccd | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td><strong>CRN: {{ $t('Net_Replacement_Cost')
														}} ({{ $t('finished_building') }})</strong>
													</td>
													<td><strong>{{ appraisal.finished_realestate_crn | formatNumber
														}} €/m²</strong>
													</td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>CRN: {{ $t('Net_Replacement_Cost')
												}} ({{ $t('real_estate_under_construction') }})</h3>
											<table class="table-striped calc">
												<tr>
													<td>{{ $t('Land_market_value') }} (F)
													</td>
													<td>{{ appraisal.f | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('As_new_construction_cost') }} (Ccb)
													</td>
													<td>{{ appraisal.ccb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Development_expenses') }} (Gpb)
													</td>
													<td>{{ appraisal.gpb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Construction_cost_and_development_expenses') }} (Ccb + Gpb)
													</td>
													<td>{{ appraisal.ccb_and_gpb | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Construction_progress_percentage') }} (%)
													</td>
													<!-- <td>{{ appraisal.total_construcion_progress_pct }} %</td> -->
													<td><input class="field__group__input"
															   type="number"
															   max="100"
															   step="1"
															   min="0"
															   spellcheck="false"
															   v-model="appraisal.total_construction_progress_pct"
															   @input="set_appraisal_total_construction_progress_pct"> %
													</td>
												</tr>
												<tr>
													<td>{{ $t('Executed_construction_cost') }} (Ccr)
													</td>
													<td>{{ appraisal.ccr | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Developers_administrative_expenses') }} ({{ $t('executed_construction') }}) (Gar)
													</td>
													<td>{{ appraisal.gar | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td>{{ $t('Land_value_plus_executed_construction_cost')
														}} (F + Ccr)
													</td>
													<td>{{ appraisal.executed_construction_cost | formatNumber }} €/m²</td>
												</tr>
												<tr>
													<td><strong>CRN: {{ $t('Net_Replacement_Cost')
														}} ({{ $t('real_estate_under_construction') }}) (F + Ccr + Gar)</strong></td>
													<td><strong>{{ appraisal.under_construction_realestate_crn
                                                    | formatNumber }} €/m²</strong></td>
												</tr>

											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Market_value') }}</h3>
											<table class="table-striped calc">
												<tr>
													<td><strong>{{ $t('Finished_building_market_value') }} (VM)</strong>
													</td>
													<td><strong>{{ appraisal.adopted_market_unit_value | formatNumber
														}} €/m²</strong>
													</td>
												</tr>
												<tr>
													<td>{{ $t('Market_coeficient') }} (K)
													</td>
													<td>{{ appraisal.k | formatNumber }}</td>
												</tr>
											</table>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="total_values_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Valors totals')">{{total_values_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Total values')">{{total_values_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Valores totales')">{{total_values_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Land_value') }}</h3>
											<h4>{{ $t('Repercussion_method') }}</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} (f)</th>
													<th> {{ $t('Land_total_value') }} {{ $t('by')
														}} {{ $t('Repercussion_method') }}
													</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td> {{ appraisal.f | formatNumber }} €/m²</td>
													<td>
														<strong>{{ appraisal.repercussion_method_land_value | formatNumber
															}} €</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Construction_value') }}</h3>
											<h4>{{ $t('Cost_method') }}</h4>
											<h4>{{ $t('Gross_Replacement_Cost') }} (CRB)</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} (Ccb + Gpb)</th>
													<th> {{ $t('Construction_value') }} (CRB)</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td> {{ appraisal.ccb_and_gpb | formatNumber }} €/m²</td>
													<td><strong>{{ appraisal.cost_method_construction_crb_value
                                                    | formatNumber }} €</strong></td>
												</tr>
											</table>
											<br>
											<h4>{{ $t('Net_Replacement_Cost') }} (CRN)</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} {{ $t('Deprecated_construction_cost')
														}}  (Ccd)
													</th>
													<th> {{ $t('Construction_value') }} (CRN)</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td> {{ appraisal.ccd | formatNumber }} €/m²</td>
													<td><strong>{{ appraisal.cost_method_construction_crn_value
                                                    | formatNumber }} €</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Real_estate_value') }} ({{ $t('Construction') }} + {{ $t('Land')}})</h3>
											<h4>{{ $t('Cost_method') }}</h4>
											<h4>{{ $t('Gross_Replacement_Cost') }} (CRB)</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} {{ $t('Gross_Replacement_Cost')
														}} (CRB)
													</th>
													<th> {{ $t('Real_estate_value') }} (CRB)</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td> {{ appraisal.crb | formatNumber }} €/m²</td>
													<td><strong>{{ appraisal.cost_method_realestate_crb_value
                                                    | formatNumber }} €</strong></td>
												</tr>
											</table>
											<br>
											<!--  -->
											<h4>{{ $t('Net_Replacement_Cost') }} (CRN) ({{ $t('finished_building')}})</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} {{ $t('Net_Replacement_Cost') }}  (CRN)
													</th>
													<th> {{ $t('Real_estate_value') }} (CRN)</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td>{{ appraisal.finished_realestate_crn | formatNumber }} €/m²</td>
													<td><strong>{{ appraisal.cost_method_realestate_crn_value
                                                    | formatNumber }} €</strong></td>
												</tr>
											</table>
											<br>
											<h4 v-if="appraisal.total_construction_progress_pct < 100">{{ $t('Net_Replacement_Cost') }} (CRN) ({{ $t('real_estate_under_construction') }})</h4>
											<table class="table-striped calc" v-if="appraisal.total_construction_progress_pct < 100">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }} {{ $t('Net_Replacement_Cost') }}  (CRN)
													</th>
													<th> {{ $t('Real_estate_value') }} (CRN)</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td>{{ appraisal.under_construction_realestate_crn | formatNumber }} €/m²</td>
													<td><strong>{{ appraisal.cost_method_unfinished_realestate_crn_value | formatNumber }} €</strong></td>
												</tr>
											</table>
											<br>
											<h4>{{ $t('Comparison_Method') }}</h4>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Built_area') }}</th>
													<th>{{ $t('Unit_value') }}</th>
													<th>{{ $t('Real_estate_value')
														}} {{ $t('by')}} {{ $t('Comparison_Method') }}
													</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.adopted_area | formatNumber }} m²</td>
													<td>{{ appraisal.adopted_market_unit_value | formatNumber }} €/m²
													</td>
													<td><strong>{{ appraisal.comparison_method | formatNumber
														}} €</strong></td>
												</tr>
											</table>
											<br>
											<h4>{{ $t('Maximum_Legal_Method') }}</h4>
											<div v-if="this.appraisal.protection_boolean">
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Maximum_legal_computable_area') }}</th>
														<th>{{ $t('Maximum_legal_sale_price') }}</th>
														<th>{{ $t('Real_estate_value')
															}} {{ $t('by')}} {{ $t('Maximum_Legal_Method') }}
														</th>
													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.max_legal_area | formatNumber }} m²</td>
														<td>{{ appraisal.max_legal_price | formatNumber }} €/m²</td>
														<td><strong>{{ appraisal.max_legal_method | formatNumber
															}} €</strong></td>
													</tr>
												</table>
											</div>
											<div v-else>
												<span>{{ $t('The_Real_Estate_is_not_protected')
													}}. {{ $t('The_value_is_not_calculated') }}.</span>
											</div>

											<br>
											<h4>{{ $t('Expected_Income_Update_Method') }}</h4>
											<div v-if="this.appraisal.cession_boolean">
												<span>({{ $t('Remaining_period_update')
													}}. {{ $t('Constant_income_with_CPI_update_clause') }})</span>
												<br>
												<h4>{{ $t('Contracts_foreseeable_remaining_period') }} (u)</h4>
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Cession_contract_start_date') }}</th>
														<th>{{ $t('Cession_contract_period_years') }}</th>
														<th>
															{{ $t('Cession_contract_remaining_years')}} ({{ $t('acc_appraisal_date')}}) (n1)
														</th>
														<th>{{ $t('Realestates_remaining_useful_life') }} (n2)</th>
														<th>{{ $t('Tenant_remaining_life_expectancy_years') }} (n3)</th>
														<th>{{ $t('Contracts_foreseeable_remaining_period')
															}} (min. n1/n2/n3)
														</th>
													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.cession_contract_start_date }}</td>
														<td>{{ appraisal.cession_contract_period_years }} {{ $t('years')
															}}
														</td>
														<td>{{ appraisal.cession_contract_remaining_years
															}} {{ $t('years') }}
														</td>
														<td>{{ appraisal.remaining_useful_life_years }} {{ $t('years')
															}}
														</td>
														<td>
															{{ appraisal.tenant_remaining_life_expectancy_years}} {{ $t('years')
															}}
														</td>
														<td>{{ appraisal.u }} {{ $t('years') }}</td>
													</tr>
												</table>
												<br>
												<h4>{{ $t('Real_Estates_residual_value') }}</h4>
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Market_value') }}</th>
														<th>{{ $t('Construction_cost_by_contract') }} (CRB-Constr.)</th>
														<th>{{ $t('Buildings_useful_life') }}</th>
														<th>{{ $t('Remaining_contract_years') }}</th>
														<th>{{ $t('Residual_depreciation') }}</th>
														<th>
															{{ $t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')
															}}
														</th>

													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.comparison_method | formatNumber }} €</td>
														<!--<td>{{ appraisal.adopted_market_value | formatNumber }} €</td>-->
														<td>
															{{ appraisal.cost_method_construction_crb_value | formatNumber
															}} €
														</td>
														<td>{{ appraisal.useful_life_years }} {{ $t('years') }} </td>
														<td><!--{{ appraisal.cession_contract_remaining_years
															}} {{ $t('years') }}-->
															{{ appraisal.u
															}} {{ $t('years') }}
														</td>
														<td>{{ appraisal.residual_depreciation | formatNumber }} €</td>
														<td>{{ appraisal.realestate_residual_value | formatNumber }} €
														</td>

													</tr>
												</table>
												<br>
												<h4>{{ $t('Current_value_of_future_rents') }}</h4>
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Gross_yearly_rent_income') }}</th>
														<th>{{ $t('Landlord_expenses_pct') }}</th>
														<th>{{ $t('Net_yearly_rent_income') }} (Rn)</th>
														<th>{{ $t('Remaining_contract_years') }}</th>
														<th>{{ $t('Update_type')}} (i) (%)</th>
														<th>Coef. 1: [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]</th>
														<th>{{ $t('Current_value_of_future_rents')
															}} (Rn * n * coef_1)
														</th>
													</tr>
													<tr>
														<td>
															<span v-if="appraisal.property_type">
																<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
																<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
																<span v-else>{{ appraisal.property_type.name_es}}</span>
															</span><span
																	v-if="realestate.floor">, {{ realestate.floor}}</span><span
																	v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.cession_gross_yearly_income | formatNumber
															}} €
														</td>
														<td>{{ appraisal.landlord_expenses_pct }}%</td>
														<td>{{ appraisal.cession_net_yearly_income | formatNumber }} €
														</td>
														<td>{{ appraisal.u
															}} {{ $t('years') }}
														</td>
														<!--<td>{{ appraisal.i_pct }} %</td>-->
														<td><input class="field__group__input"
																   type="number"
																   min="0"
																   spellcheck="false"
																   v-model="appraisal.i_pct"
																   @input="set_appraisal_i_pct">
														</td>
														<td>{{ appraisal.coef_1 }}</td>
														<td>{{ appraisal.current_future_income_value | formatNumber }} €
														</td>
													</tr>
												</table>
												<br>
												<h4>{{ $t('Current_reversion_value_calculation') }}</h4>
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>
															{{ $t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')
															}}
														</th>
														<th>{{ $t('Remaining_contract_years') }}</th>
														<th>{{ $t('Update_type')}} (i) (%)</th>
														<th>Coef. 2: ((1 + i) ^ n )</th>
														<th>{{ $t('Updated_reversion_value') }} ({{ $t('Residual_value')
															}}/ coef. 2)
														</th>
													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.cession_gross_yearly_income | formatNumber
															}} €
														</td>
														<td>{{ appraisal.u
															}} {{ $t('years') }}
														</td>
														<!--<td>{{ appraisal.i_pct }} %</td>-->
														<td><input class="field__group__input"
																   type="number"
																   min="0"
																   spellcheck="false"
																   v-model="appraisal.i_pct"
																   @input="set_appraisal_i_pct">
														</td>
														<td>{{ appraisal.coef_2 }}</td>
														<td>{{ appraisal.updated_reversion_value | formatNumber }} €
														</td>
													</tr>
												</table>
												<br>
												<h4>{{ $t('Update_value_calculation') }}</h4>
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Current_value_of_future_rents') }} (A)</th>
														<th>{{ $t('Updated_reversion_value') }} (B)</th>
														<th>{{ $t('Update_value') }} (A+B)</th>

													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.current_future_income_value | formatNumber
															}} €
														</td>
														<td>{{ appraisal.updated_reversion_value | formatNumber }} €
														</td>
														<td>{{ appraisal.update_value | formatNumber }} €</td>

													</tr>
												</table>
											</div>
											<div v-else>
												<span>{{ $t('The_Real_Estate_is_not_rented_or_ceded')
													}}. {{ $t('The_value_is_not_calculated') }}.</span>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Right_of_use_value') }}</h3>
											<div v-if="this.appraisal.right_of_use_boolean">
												<table class="table-striped calc">
													<tr>
														<th></th>
														<th>{{ $t('Usufructuary_age_years') }} (n)</th>
														<th>Coef. V<sub>u</sub> (max: 10% vs. 0,7 - 0,01 * ( n - 20))
														</th>
														<th>{{ $t('Usufruct_value') }} (VM * Coef. V<sub>u</sub>)</th>
														<th>{{ $t('Bare_ownership_value')
															}} (VM * (1 - Coef. V<sub>u</sub>))
														</th>

													</tr>
													<tr>
														<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
																v-if="realestate.floor">, {{ realestate.floor}}</span><span
																v-if="realestate.door">-{{ realestate.door}}</span>
														</td>
														<td>{{ appraisal.usufructuary_age_years }} {{ $t('years') }}
														</td>
														<td>{{ appraisal.vu_coef }}</td>
														<td><strong>{{ appraisal.usufruct_value | formatNumber
															}} €</strong></td>
														<td><strong>{{ appraisal.bare_ownership_value | formatNumber
															}} €</strong></td>
													</tr>
												</table>
											</div>
											<div v-else>
												<span>{{ $t('There_is_no_cession_of_the_right_of_use')
													}}. {{ $t('The_value_is_not_calculated') }}.</span>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Insurance_value') }} s/ R. D. 685/1982</h3>
											<table class="table-striped calc">
												<tr>
													<th></th>

													<th>{{ $t('Gross_Replacement_Cost')
														}} (CRB)
													</th>
													<th width="50px" style="text-align: center"></th>
													<th>{{ $t('Land_value') }}</th>
													<th  width="50px" style="text-align: center"></th>
													<th> Total </th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.cost_method_realestate_crb_value | formatNumber }} €</td>
													<td> - </td>
													<td> {{ appraisal.repercussion_method_land_value | formatNumber }} €</td>
													<td> = </td>
													<td><strong>{{ appraisal.insurance_value_rd_685_1982 | formatNumber
														}} €</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Insurance_value') }} s/ R. D. 246/1998, 716/2009</h3>
											<table class="table-striped calc">
												<tr>
													<th></th>

													<th>{{ $t('Appraisal_value') }}
													</th>
													<th width="50px" style="text-align: center"></th>
													<th>{{ $t('Land_value') }}</th>
													<th  width="50px" style="text-align: center"></th>
													<th> Total </th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.realestate_total_adopted_value | formatNumber }} €</td>
													<td> - </td>
													<td> {{ appraisal.repercussion_method_land_value | formatNumber }} €</td>
													<td> = </td>
													<td><strong>{{ appraisal.insurance_value_rd_716_2009 | formatNumber }} €</strong></td>
												</tr>
											</table>
										</div>
										<div class="section-container">
											<h3>{{ $t('Appraisal_total_value_determination') }}</h3>
											<table class="table-striped calc">
												<tr>
													<th></th>
													<th>{{ $t('Comparison_Method') }}</th>
													<th>{{ $t('Adjusted_Comparison_Method')}}</th>
													<th>{{ $t('Maximum_Legal_Method')}}</th>
													<th v-if="appraisal.cession_boolean">{{ $t('Expected_Income_Update_Method')}}</th>
													<th v-if="appraisal.total_construction_progress_pct < 100">{{ $t('Net_Replacement_Cost')}} ({{ $t('real_estate_under_construction') }})</th>
													<th>{{ $t('Adopted_value')}}</th>
												</tr>
												<tr>
													<td>
														<span v-if="appraisal.property_type">
															<span v-if="currentLocale == 'ca'">{{ appraisal.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ appraisal.property_type.name_en}}</span>
															<span v-else>{{ appraisal.property_type.name_es}}</span>
														</span><span
															v-if="realestate.floor">, {{ realestate.floor}}</span><span
															v-if="realestate.door">-{{ realestate.door}}</span>
													</td>
													<td>{{ appraisal.comparison_method | formatNumber }} €</td>
													<td>{{ appraisal.adjusted_market_value | formatNumber }} €</td>
													<td>{{ appraisal.max_legal_method | formatNumber }} €</td>
													<td v-if="appraisal.cession_boolean">{{ appraisal.update_value | formatNumber }} €</td>
													<td v-if="appraisal.total_construction_progress_pct < 100">{{ appraisal.cost_method_unfinished_realestate_crn_value | formatNumber }} €</td>
													<td>
														<strong>{{ appraisal.realestate_total_adopted_value | formatNumber
															}} €</strong></td>
												</tr>
											</table>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="warnings_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Advertiments i observacions')">{{warnings_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Warnings and notes')">{{warnings_text}}
							</div>
							<div v-else slot="title"
								 @click.prevent="setCurrentTabTitle('Advertencias y observaciones')">{{warnings_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<div class="section-container">
												<h3>{{ $t('Constraints') }}</h3>
												<div>
													<div @click.prevent="onCreateNewConstraint"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle"
																	 :text="new_constraint_button_text"
																	 icon_color="black"
																	 text_color="black"
																	 border_color="lightgray"></icon-button>
													</div>
												</div>


												<div class="" v-if="currentLocale === 'ca'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_constraints)"
																	   :filterable="false"
																	   :striped="constraint_table_ca.striped"
																	   :editable="constraint_table_ca.editable"
																	   :line-numbers="constraint_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in constraint_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-constraints_ca"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-constraints_ca" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else-if="currentLocale === 'en'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_constraints)"
																	   :filterable="false"
																	   :striped="constraint_table_en.striped"
																	   :editable="constraint_table_en.editable"
																	   :line-numbers="constraint_table_en.lineNumbers">
																<datatable-column
																		v-for="column in constraint_table_en.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<template slot="actions-constraints_en" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else>
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_constraints)"
																	   :filterable="false"
																	   :striped="constraint_table_es.striped"
																	   :editable="constraint_table_es.editable"
																	   :line-numbers="constraint_table_es.lineNumbers">
																<datatable-column
																		v-for="column in constraint_table_es.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<template slot="actions-constraints_es" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteConstraint(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Warnings') }}</h3>
												<div>
													<div @click.prevent="onCreateNewWarning"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle" :text="new_warning_button_text"
																	 icon_color="black"
																	 text_color="black"
																	 border_color="lightgray"></icon-button>
													</div>
												</div>


												<div class="" v-if="currentLocale === 'ca'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="warning-table-main"
																	   :source="object_to_array(appraisal_warnings)"
																	   :filterable="false"
																	   :striped="warning_table_ca.striped"
																	   :editable="warning_table_ca.editable"
																	   :line-numbers="warning_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in warning_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-warnings_ca"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-warnings_ca" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else-if="currentLocale === 'en'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="warning-table-main"
																	   :source="object_to_array(appraisal_warnings)"
																	   :filterable="false"
																	   :striped="warning_table_en.striped"
																	   :editable="warning_table_en.editable"
																	   :line-numbers="warning_table_en.lineNumbers">
																<datatable-column
																		v-for="column in warning_table_en.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-warnings_en"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-warnings_em" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else>
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="warning-table-main"
																	   :source="object_to_array(appraisal_warnings)"
																	   :filterable="false"
																	   :striped="warning_table_es.striped"
																	   :editable="warning_table_es.editable"
																	   :line-numbers="warning_table_es.lineNumbers">
																<datatable-column
																		v-for="column in warning_table_es.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-warnings_es"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-warnings_es" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteWarning(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>
											<div class="section-container">
												<h3>{{ $t('Notes') }}</h3>
												<div>
													<div @click.prevent="onCreateNewNote"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="plus-circle" :text="new_note_button_text"
																	 icon_color="black"
																	 text_color="black"
																	 border_color="lightgray"></icon-button>
													</div>
												</div>


												<div class="" v-if="currentLocale === 'ca'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="note-table-main"
																	   :source="object_to_array(appraisal_notes)"
																	   :filterable="false"
																	   :striped="note_table_ca.striped"
																	   :editable="note_table_ca.editable"
																	   :line-numbers="note_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in note_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-notes_es"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-notes_es" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editNote(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteNote(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else-if="currentLocale === 'en'">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="note-table-main"
																	   :source="object_to_array(appraisal_notes)"
																	   :filterable="false"
																	   :striped="note_table_en.striped"
																	   :editable="note_table_en.editable"
																	   :line-numbers="note_table_en.lineNumbers">
																<datatable-column
																		v-for="column in note_table_en.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="actions-notes_en"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-notes_en" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editNote(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteNote(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="" v-else>
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="note-table-main"
																	   :source="object_to_array(appraisal_notes)"
																	   :filterable="false"
																	   :striped="note_table_es.striped"
																	   :editable="note_table_es.editable"
																	   :line-numbers="note_table_es.lineNumbers">
																<datatable-column
																		v-for="column in note_table_es.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
															</datatable>
														</div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="checks_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Comprovacions')">{{checks_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Checks')">{{checks_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Comprobaciones')">{{checks_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">

											<div class="field-container">
												<table style="width: 60em;">
													<tr>
														<th>
															<h4>{{ $t('Checkings_realized') }}</h4>
														</th>
														<th>
															<h4>{{ $t('Documents_used') }}</h4>
														</th>
													</tr>
													<tr>
														<td>
															<table style="width: 30em;">
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Cadastral_data')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_cadastral_data"
																				   @click="set_appraisal_checks_cadastral_data">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Conservation_status')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_conservation_status"
																				   @click="set_appraisal_checks_conservation_status">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Expropriation_procedure')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_expropriation_procedure"
																				   @click="set_appraisal_checks_expropriation_procedure">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Expropriation_plan')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_expropriation_plan"
																				   @click="set_appraisal_checks_expropriation_plan">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Expropriation_admin_ruling')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_expropriation_admin_ruling"
																				   @click="set_appraisal_checks_expropriation_admin_ruling">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>

																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Expropriation_file')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_expropriation_file"
																				   @click="set_appraisal_checks_expropriation_file">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Interior_visit')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_interior_visit"
																				   @click="set_appraisal_checks_interior_visit">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Occupancy')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_occupancy"
																				   @click="set_appraisal_checks_occupancy">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>

																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Registry_data')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_registry_data"
																				   @click="set_appraisal_checks_registry_data">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Servitudes')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_servitudes"
																				   @click="set_appraisal_checks_servitudes">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Public_protection_regime')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_subsidy_status"
																				   @click="set_appraisal_checks_subsidy_status">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Urban_parameters_suitability')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.checks_urban_planning"
																				   @click="set_appraisal_checks_urban_planning">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Other')
																				}}</label>
																			<input class="field__group__input"
																				   type="text"
																				   spellcheck="false"
																				   v-model="appraisal.checks_other"
																				   @input="set_appraisal_checks_other">
																		</div>
																	</td>
																</tr>
															</table>
														</td>
														<td>
															<table style="width: 30em;">
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Approved_project_by_professional_association')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_approved_project"
																				   @click="set_appraisal_docs_approved_project">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Cadastral_documents')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_cadastral_data"
																				   @click="set_appraisal_docs_cadastral_data">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Construction_license')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_construction_license"
																				   @click="set_appraisal_docs_construction_license">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Construction_last_certificate')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_construction_last_certificate"
																				   @click="set_appraisal_docs_construction_last_certificate">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Construction_contract')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_construction_contract"
																				   @click="set_appraisal_docs_construction_contract">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Occupancy_status')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_occupancy_status"
																				   @click="set_appraisal_docs_occupancy_status">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Photographic_report')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_photographic_report"
																				   @click="set_appraisal_docs_photographic_report">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Property_sketch')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_property_sketch"
																				   @click="set_appraisal_docs_property_sketch">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Property_titles')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_property_titles"
																				   @click="set_appraisal_docs_property_titles">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Situation_plan')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_situation_plan"
																				   @click="set_appraisal_docs_situation_plan">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Subsidy_status')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_subsidy_status"
																				   @click="set_appraisal_docs_subsidy_status">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Ten_year_insurance')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_tenyear_insurance"
																				   @click="set_appraisal_docs_tenyear_insurance">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Urban_plan')
																				}}</label>
																			<input class="field__group__input"
																				   type="checkbox"
																				   spellcheck="false"
																				   v-model="appraisal.docs_urban_plan"
																				   @click="set_appraisal_docs_urban_plan">
																		</div>
																	</td>
																</tr>
																<tr>
																	<td>
																		<div class="field__group">
																			<label class="field__group__label">{{ $t('Other')
																				}}</label>
																			<input class="field__group__input"
																				   type="text"
																				   spellcheck="false"
																				   v-model="appraisal.docs_other"
																				   @input="set_appraisal_docs_other">
																		</div>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>


											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="annexes_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Annexes')">{{annexes_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Annexes')">{{annexes_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Anexos')">{{annexes_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div style="background: lightyellow; padding: 1rem;">
											<span><strong>Nota:</strong> Les imatges han de ser carregades en format PNG o JPG. Altres formats no funcionaran correctament a l'hora d'imprimir el PDF de l'informe.</span>

											<br>
										</div>
										<div class="form-section">
											<div class="section-container">
												<h3>{{ $t('Photographs') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadPhotographFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_photographs)"
																	   :filterable="false"
																	   :striped="photograph_table_ca.striped"
																	   :editable="photograph_table_ca.editable"
																	   :line-numbers="photograph_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in photograph_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="cover-checkbox"
																				  :label="cover_text"
																				  width="80px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-photographs"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-photographs" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editPhotograph(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deletePhotograph(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="cover-checkbox" scope="cell">
																	<div>
																		<checkbox :id="cell.row.id"
																				  :editable="editabletrue"
																				  v-model="cell.row['is_cover_photo']"
																				  @toggle_flag="set_appraisal_cover_photo(cell.row['is_cover_photo'], cell.row)"
																		>
																		</checkbox>
																	</div>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Registry_Documents') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadRegistryAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_registryannexes)"
																	   :filterable="false"
																	   :striped="registryannex_table_ca.striped"
																	   :editable="registryannex_table_ca.editable"
																	   :line-numbers="registryannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in registryannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-registryannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-registryannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editRegistryAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteRegistryAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Cadastral_Documents') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadCadasterAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_cadasterannexes)"
																	   :filterable="false"
																	   :striped="cadasterannex_table_ca.striped"
																	   :editable="cadasterannex_table_ca.editable"
																	   :line-numbers="cadasterannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in cadasterannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-cadasterannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-cadasterannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editCadasterAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteCadasterAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Urban_Planning_Documents') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadUrbanAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_urbanannexes)"
																	   :filterable="false"
																	   :striped="urbanannex_table_ca.striped"
																	   :editable="urbanannex_table_ca.editable"
																	   :line-numbers="urbanannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in urbanannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-urbanannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-urbanannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editUrbanAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteUrbanAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Plans') }} {{ $t('and') }} {{ $t('Sketches') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadPlanAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_planannexes)"
																	   :filterable="false"
																	   :striped="planannex_table_ca.striped"
																	   :editable="planannex_table_ca.editable"
																	   :line-numbers="planannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in planannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-planannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-planannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editPlanAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deletePlanAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Cession_Documents') }} {{ $t('and') }} {{ $t('Contracts')
													}}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadCessionAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_cessionannexes)"
																	   :filterable="false"
																	   :striped="cessionannex_table_ca.striped"
																	   :editable="cessionannex_table_ca.editable"
																	   :line-numbers="cessionannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in cessionannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-cessionannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-cessionannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editCessionAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteCessionAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

											<div class="section-container">
												<h3>{{ $t('Other_Documents') }}</h3>
												<div style="background-color: #fafafc; padding-left: 2rem; padding-top: 0.5rem; padding-bottom: 1rem; margin-top: 1rem; margin-bottom: 1rem; margin-right: 1rem;">
													<h4>{{ $t('Upload_files') }}</h4>
													<input type="file" @change="uploadOtherAnnexFiles" id="files"
														   name="files[]" accept="image/*" multiple/>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="constraint-table-main"
																	   :source="object_to_array(appraisal_otherannexes)"
																	   :filterable="false"
																	   :striped="otherannex_table_ca.striped"
																	   :editable="otherannex_table_ca.editable"
																	   :line-numbers="otherannex_table_ca.lineNumbers">
																<datatable-column
																		v-for="column in otherannex_table_ca.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<datatable-column id="thumbnail-photographs"
																				  label="Thumbnail"
																				  width="240px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column id="actions-otherannexes"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<template slot="actions-otherannexes" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editOtherAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="deleteOtherAnnex(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="trash-o" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>
																<template slot="thumbnail-photographs" scope="cell">
																	<div>
																		<img :src="cell.row['thumb_url']" width="200px"
																			 height="auto">
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>

										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<!--
						<v-tab :title="appraisal_cost_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Cost de taxació')">{{appraisal_cost_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Appraisal cost')">{{appraisal_cost_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Coste de tasación')">{{appraisal_cost_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<h3>{{ $t('Travel_expenses') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_travel_one_way_hours')
														}} (h)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_travel_one_way_hours"
														   @input="set_appraisal_quote_travel_one_way_hours">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_travel_both_ways_hours')
														}}</label>

													<span>{{ appraisal.quote_travel_both_ways_hours }} {{ $t('hours')
														}}</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_travel_fees_per_hour')
														}} (€/h)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_travel_fees_per_hour"
														   @input="set_appraisal_quote_travel_fees_per_hour">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_car_expenses_one_way')
														}} (€)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_car_expenses_one_way"
														   @input="set_appraisal_quote_car_expenses_one_way">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_car_expenses_both_ways')
														}} (€)</label>

													<span>{{ appraisal.quote_car_expenses_both_ways}} <span
															v-if="appraisal.quote_car_expenses_both_ways"> €
														</span></span>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_total_travel_fees')
														}} (€)</label>

													<span>{{ appraisal.quote_total_travel_fees }} €</span>
												</div>
											</div>

										</div>
										<div class="form-section">
											<h3>{{ $t('Appraisal_fees') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_area_average_unit_price')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_area_average_unit_price"
														   @input="set_appraisal_quote_area_average_unit_price">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_fees')
														}} (€)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_base_fees"
														   @input="set_appraisal_quote_base_fees">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_excess_pct')
														}} (%)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_excess_pct"
														   @input="set_appraisal_quote_excess_pct">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_price')
														}} (€)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_base_price"
														   @input="set_appraisal_quote_base_price">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_price_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.quote_base_price_coef"
														   @input="set_appraisal_quote_base_price_coef">
												</div>
											</div>
										</div>

									</form>
								</div>
							</div>
						</v-tab>
	-->

						<v-tab :title="metadata_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Metadades')">{{metadata_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Metadatos')">{{metadata_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Metadata')">{{metadata_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Description') }}</h3>

											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Appraisal_description')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="appraisal.description"
														   @input="set_appraisal_description">
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
					</vue-tabs>

					<!--
					<div>
						<div @click.prevent="setCurrentTab('Metadades')"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" text="provar canvi de tab" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					-->
					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="level-up" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentAppraisal({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentAppraisal({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>

					<message
							v-if="appraisal.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>


					<!--
					<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import {
        appraisalCalcMixin,
        dateMixin,
        localStorageMixin,
        mathMixin,
        objectsMixin,
        typeCheckMixin
    } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import appraisalPurposeOptions from '../../../options/appraisal_purposes'
    import appraisalTypeOptions from '../../../options/appraisal_types'
    import countryOptions from '../../../options/countries'
    import spanishProvinceOptions from '../../../options/spanish_provinces'
    import property_typeOptions from '../../../options/property_types'
    import quality_of_neighbourhoodOptions from '../../../options/quality_of_neighbourhood'
    import quality_of_situationOptions from '../../../options/quality_of_situation'
    import quality_of_constructionOptions from '../../../options/quality_of_construction'
    import quality_of_realestateOptions from '../../../options/quality_of_realestate'
    import conservation_statusOptions from '../../../options/conservation_statuses'
    import protection_typeOptions from '../../../options/protection_types'
    import protection_regimeOptions from '../../../options/protection_regimes'
    import protection_zoneOptions from '../../../options/protection_zones'
    import usage_typeOptions from '../../../options/usage_types'
    import room_typeOptions from '../../../options/room_types'
    import covered_outdoor_typeOptions from '../../../options/covered_outdoor_types'
    import uncovered_outdoor_typeOptions from '../../../options/uncovered_outdoor_types'
    import selected_areaOptions from '../../../options/selected_areas'
    import plot_occupationOptions from '../../../options/plot_occupations'
    import plot_free_area_usageOptions from '../../../options/plot_free_area_usages'


    import foundationOptions from '../../../options/foundations'
    import structureOptions from '../../../options/structures'
    import roofOptions from '../../../options/roofs'
    import external_enclosuresOptions from '../../../options/external_enclosures'
    import insulationOptions from '../../../options/insulations'
    import external_carpentry_typeOptions from '../../../options/external_carpentry_types'
    import glazingOptions from '../../../options/glazings'
    import quality_of_finishesOptions from '../../../options/quality_of_finishes'
    import pavingOptions from '../../../options/pavings'
    import wallsOptions from '../../../options/walls'
    import ceilingsOptions from '../../../options/ceilings'
    import interior_carpentry_typeOptions from '../../../options/interior_carpentry_types'
    import main_orientationOptions from '../../../options/orientations'
    import main_viewsOptions from '../../../options/views'
    import windows_size_and_quantityOptions from '../../../options/windows_size_and_quantities'
    import noise_levelOptions from '../../../options/noise_levels'

    import territorial_featureOptions from '../../../options/territorial_features'
    import quality_levelOptions from '../../../options/quality_levels'
    import homogeneity_featureOptions from '../../../options/homogeneity_features'
    import accessibility_typeOptions from '../../../options/accessibility_types'
    import degree_typeOptions from '../../../options/degree_types'
    import evolution_speedOptions from '../../../options/evolution_speeds'
    import average_ageOptions from '../../../options/average_ages'
    import levelOptions from '../../../options/level_options'
    import construction_statusOptions from '../../../options/construction_statuses'

	import usage_typeBdEOptions from '../../../options/usage_types_bde'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    import occupancy_statusOptions from '../../../options/occupancy_statuses'

    let fonts = {
        Roboto: {
            normal: 'fonts/Roboto-Regular.ttf',
            bold: 'fonts/Roboto-Medium.ttf',
            italics: 'fonts/Roboto-Italic.ttf',
            bolditalics: 'fonts/Roboto-MediumItalic.ttf'
        }
    }

    export default {
        name: 'appraisal-editor',

        mixins: [
            appraisalCalcMixin,
            dateMixin,
            localStorageMixin,
            mathMixin,
            objectsMixin,
            typeCheckMixin
        ],

        data: () => ({
            tabName: '',
            currentTabTitle: '',
            master_loading: true,
            urban_map_offset: 5,
            urban_map_size: '640x480',
            urban_map_width: 640,
            urban_map_height: 480,
            urban_map_zoom_factor: 0.1,
            editing_room: false,
            editing_room_text_color: 'black',
            editing_room_border_color: 'lightgray',
            editing_covered_outdoor: false,
            editing_covered_outdoor_text_color: 'black',
            editing_covered_outdoor_border_color: 'lightgray',
            editing_uncovered_outdoor: false,
            editing_uncovered_outdoor_text_color: 'black',
            editing_uncovered_outdoor_border_color: 'lightgray',
            creatingCoveredOutdoor: false,
            creatingUncoveredOutdoor: false,
            loadingAppraisalPurpose: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            cadaster_ref_loading: false,
            idescat_info_loading: false,
            muc_info_loading: false,
            muc_map_01_loading: false,
            muc_map_02_loading: false,
            muc_map_03_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            urban_and_surroundings_text: Vue.i18n.translate('Urban_and_surroundings_text'),
            cession_and_rights_text: Vue.i18n.translate('Cession') + ', ' + Vue.i18n.translate('rights') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('protection'),
            surroundings_text: Vue.i18n.translate('Surroundings'),
            technical_values_text: Vue.i18n.translate('Technical_values'),
            total_values_text: Vue.i18n.translate('Total_values'),
            warnings_text: Vue.i18n.translate('Warnings') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('notes'),
            annexes_text: Vue.i18n.translate('Annexes'),
            land_text: Vue.i18n.translate('Terrain'),
            checks_text: Vue.i18n.translate('Checks'),
            General_data_text: Vue.i18n.translate('General_data'),
            Areas_text: Vue.i18n.translate('Areas'),
            Market_text: Vue.i18n.translate('Market'),
            features_text: Vue.i18n.translate('Features'),
            metadata_text: Vue.i18n.translate('Version'),
            quote_text: Vue.i18n.translate('Quote'),
            appraisal_cost_text: Vue.i18n.translate('Appraisal_cost'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            upload_photographs_button_text: Vue.i18n.translate('Upload_photographs'),
            new_room_button_text: Vue.i18n.translate('Add_room'),
            new_constraint_button_text: Vue.i18n.translate('Add_constraint'),
            new_warning_button_text: Vue.i18n.translate('Add_warning'),
            new_note_button_text: Vue.i18n.translate('Add_note'),
            new_covered_outdoor_button_text: Vue.i18n.translate('Add_covered_outdoor'),
            new_uncovered_outdoor_button_text: Vue.i18n.translate('Add_uncovered_outdoor'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            enclosed_checked_area_error_text: Vue.i18n.translate('Low_enclosed_checked_area_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            cover_text: Vue.i18n.translate('Cover'),
            appraisalPurposeValue: null,
            appraisalTypeValue: null,
            land_infrastructure_conservation_statusValue: null,
            occupancy_statusValue: null,
            marketstudy_idValue: null,
            technician_visitingValue: null,
            plot_occupationValue: null,
            plot_free_area_usageValue: null,
            usage_typeValue: null,
            appraisalPurposeOptions,
            appraisalTypeOptions,
            countryOptions,
            spanishProvinceOptions,
            property_typeOptions,
            quality_of_neighbourhoodOptions,
            quality_of_situationOptions,
            quality_of_constructionOptions,
            quality_of_realestateOptions,
            conservation_statusOptions,
            protection_typeOptions,
            protection_regimeOptions,
            protection_zoneOptions,
            usage_typeOptions,
            territorial_featureOptions,
            quality_levelOptions,
            homogeneity_featureOptions,
            accessibility_typeOptions,
            degree_typeOptions,
            evolution_speedOptions,
            average_ageOptions,
            levelOptions,
            room_typeOptions,
            covered_outdoor_typeOptions,
            uncovered_outdoor_typeOptions,
            selected_areaOptions,
            plot_occupationOptions,
            plot_free_area_usageOptions,

            foundationOptions,
            structureOptions,
            roofOptions,
            external_enclosuresOptions,
            insulationOptions,
            external_carpentry_typeOptions,
            glazingOptions,
            quality_of_finishesOptions,
            pavingOptions,
            wallsOptions,
            ceilingsOptions,
            interior_carpentry_typeOptions,
            main_orientationOptions,
            main_viewsOptions,
            windows_size_and_quantityOptions,
            noise_levelOptions,

            construction_statusOptions,

            occupancy_statusOptions,

			usage_typeOptions,
            usage_typeBdEOptions,

			usage_typeBdEValue: null,

            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            property_typeValue: null,
            quality_of_neighbourhoodValue: null,
            quality_of_situationValue: null,
            quality_of_constructionValue: null,
            quality_of_realestateValue: null,
            conservation_statusValue: null,
            protection_typeValue: null,
            protection_regimeValue: null,
            protection_zoneValue: null,
            floors_usage_undergroundValue: null,
            floors_usage_overgroundValue: null,
            groundfloor_usageValue: null,
            surrounding_territorial_featureValue: null,
            surrounding_income_levelValue: null,
            surrounding_homogeneity_featureValue: null,
            surrounding_main_usesValue: null,
            surrounding_densityValue: null,
            surrounding_accessibilityValue: null,
            surrounding_consolidation_degreeValue: null,
            surrounding_occupation_degreeValue: null,
            surrounding_evolution_speedValue: null,
            surrounding_average_ageValue: null,
            surrounding_conservation_statusValue: null,
            surrounding_commercial_facilitiesValue: null,
            surrounding_educational_facilitiesValue: null,
            surrounding_public_parkingValue: null,
            surrounding_medical_assistanceValue: null,
            surrounding_leisureValue: null,
            room_typeValue: null,
            covered_outdoor_typeValue: null,
            uncovered_outdoor_typeValue: null,
            net_selected_areaValue: null,
            enclosed_selected_areaValue: null,
            covered_outdoors_selected_areaValue: null,
            built_selected_areaValue: null,
            common_elements_selected_areaValue: null,
            built_plus_common_elements_selected_areaValue: null,
            land_selected_areaValue: null,
            realestate_foundationValue: null,
            realestate_structureValue: null,
            realestate_roofValue: null,
            realestate_external_enclosuresValue: null,
            realestate_insulationValue: null,
            realestate_external_carpentryValue: null,
            realestate_glazingValue: null,
            realestate_interior_paving_livingValue: null,
            realestate_interior_paving_corridorValue: null,
            realestate_interior_paving_bedroomValue: null,
            realestate_interior_paving_kitchenValue: null,
            realestate_interior_paving_bathroomValue: null,
            realestate_interior_paving_qualityValue: null,
            realestate_interior_walls_livingValue: null,
            realestate_interior_walls_corridorValue: null,
            realestate_interior_walls_bedroomValue: null,
            realestate_interior_walls_kitchenValue: null,
            realestate_interior_walls_bathroomValue: null,
            realestate_interior_walls_qualityValue: null,
            realestate_interior_ceilings_livingValue: null,
            realestate_interior_ceilings_corridorValue: null,
            realestate_interior_ceilings_bedroomValue: null,
            realestate_interior_ceilings_kitchenValue: null,
            realestate_interior_ceilings_bathroomValue: null,
            realestate_interior_ceilings_qualityValue: null,
            realestate_interior_carpentry_livingValue: null,
            realestate_interior_carpentry_corridorValue: null,
            realestate_interior_carpentry_bedroomValue: null,
            realestate_interior_carpentry_kitchenValue: null,
            realestate_interior_carpentry_bathroomValue: null,
            realestate_interior_carpentry_qualityValue: null,
            realestate_main_orientationValue: null,
            realestate_main_viewsValue: null,
            realestate_windows_size_and_quantityValue: null,
            realestate_noise_facadeValue: null,
            realestate_systems_sanitary_fittings_qualityValue: null,
            realestate_systems_taps_qualityValue: null,
            bec_property_typeValue: null,
            bec_numberValue: null,
            construction_statusValue: null,

            room_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'type',
                        label: Vue.i18n.translate('Type'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'netarea',
                        label: Vue.i18n.translate('Net_area'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.total
                        ]
                    },
                ],
                selected: []
            },
            constraint_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Constraint'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            constraint_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Constraint'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            constraint_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Constraint'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            warning_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Warning'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            warning_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Warning'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            warning_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Warning'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            note_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Note'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            note_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Note'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            note_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Note'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            covered_outdoor_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'type',
                        label: Vue.i18n.translate('Type'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'netarea',
                        label: Vue.i18n.translate('Net_area'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.total
                        ]
                    },
                ],
                selected: []
            },
            uncovered_outdoor_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'type',
                        label: Vue.i18n.translate('Type'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'netarea',
                        label: Vue.i18n.translate('Net_area'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.total
                        ]
                    },
                ],
                selected: []
            },
            photograph_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            photograph_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            photograph_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            registryannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            registryannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            registryannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            urbanannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            urbanannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            urbanannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            cadasterannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            cadasterannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            cadasterannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            planannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            planannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            planannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            cessionannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            cessionannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            cessionannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

            otherannex_table_ca: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_ca',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            otherannex_table_en: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_en',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            otherannex_table_es: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'name_es',
                        label: Vue.i18n.translate('Image_footer'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'filename',
                        label: Vue.i18n.translate('File_name'),
                        width: 60,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },

        }),

        created () {

            this.FETCH_APPRAISAL_ROOMS({path: 'appraisal_rooms' + '/' + this.appraisal.id + '/'}).then(() => {
                this.FETCH_APPRAISAL_COVERED_OUTDOORS({path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                    this.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                        this.FETCH_APPRAISAL_BEC_PROPERTIES({path: 'becproperties' + '/'}).then(() => {
                            this.FETCH_APPRAISAL_CONSTRAINTS({path: 'appraisal_constraints' + '/' + this.appraisal.id + '/'}).then(() => {
                                this.FETCH_APPRAISAL_WARNINGS({path: 'appraisal_warnings' + '/' + this.appraisal.id + '/'}).then(() => {
                                    this.FETCH_APPRAISAL_NOTES({path: 'appraisal_notes' + '/' + this.appraisal.id + '/'}).then(() => {
                                        this.FETCH_APPRAISAL_PHOTOGRAPHS({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs'}).then(() => {
                                            this.FETCH_APPRAISAL_REGISTRYANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes'}).then(() => {
                                                this.FETCH_APPRAISAL_CADASTERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes'}).then(() => {
                                                    this.FETCH_APPRAISAL_URBANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes'}).then(() => {
                                                        this.FETCH_APPRAISAL_PLANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes'}).then(() => {
                                                            this.FETCH_APPRAISAL_CESSIONANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes'}).then(() => {
                                                                this.FETCH_APPRAISAL_OTHERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes'}).then(() => {
                                                                    this.FETCH_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.realestate.id + '/'}).then(() => {
                                                                        this.FETCH_APPRAISERS().then(() => {
                                                                            this.master_loading = false
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
            // Agafem el mateix que hi hagi a realestate
            this.SET_APPRAISAL_PROPERTY_TYPE(this.realestate.property_type)

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'appraisal',
                'appraisal_bec_prices',
                'appraisal_bec_properties',
                'appraisal_rooms',
                'appraisal_covered_outdoors',
                'appraisal_uncovered_outdoors',
                'appraisalfile',
                'appraisers',
                'appraisalreport',
                'appraisalreport_realestates',
                'appraisal_rooms',
                'currentLocale',
                'realestate',
                'realestate_appraisals',
                'appraisal_constraints',
                'appraisal_warnings',
                'appraisal_notes',
                'appraisal_photographs',
                'appraisal_registryannexes',
                'appraisal_cadasterannexes',
                'appraisal_urbanannexes',
                'appraisal_planannexes',
                'appraisal_cessionannexes',
                'appraisal_otherannexes',
                'realestate_marketstudies',
                'photograph',
				'valuation_prices'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_APPRAISAL',
                    'CREATE_NEW_ROOM',
                    'CREATE_NEW_COVERED_OUTDOOR',
                    'CREATE_NEW_UNCOVERED_OUTDOOR',
                    'FETCH_APPRAISAL_BEC_PRICES',
                    'FETCH_APPRAISAL_BEC_PROPERTIES',
                    'FETCH_APPRAISAL_ROOMS',
                    'FETCH_APPRAISAL_COVERED_OUTDOORS',
                    'FETCH_APPRAISAL_UNCOVERED_OUTDOORS',
                    'FETCH_APPRAISAL_CONSTRAINTS',
                    'FETCH_APPRAISAL_WARNINGS',
                    'FETCH_APPRAISAL_NOTES',
                    'FETCH_APPRAISERS',
                    'FETCH_REALESTATE_MARKETSTUDIES',
                    'REQUEST_MUC_INFO',
                    'REQUEST_IDESCAT_INFO_BY_CODE_INE',
                    'REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX',
                    'REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX',
                    'REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX',
                    'RESET_APPRAISAL',
                    'RESET_ROOM',
                    'RESET_COVERED_OUTDOOR',
                    'RESET_UNCOVERED_OUTDOOR',
                    'RESET_CONSTRAINT',
                    'RESET_WARNING',
                    'RESET_NOTE',
                    'CREATE_NEW_CONSTRAINT',
                    'CREATE_NEW_WARNING',
                    'CREATE_NEW_NOTE',
                    'DELETE_CONSTRAINT',
                    'DELETE_WARNING',
                    'DELETE_NOTE',
                    'DELETE_ROOM',
                    'DELETE_COVERED_OUTDOOR',
                    'DELETE_UNCOVERED_OUTDOOR',
                    'SET_CONSTRAINT',
                    'SET_WARNING',
                    'SET_NOTE',
                    'SET_APPRAISAL',
                    'SET_APPRAISAL_APPRAISALDATE',
                    'SET_APPRAISAL_VISITDATE',
                    'SET_APPRAISAL_DESCRIPTION',
                    'SET_APPRAISAL_PURPOSE',
                    'SET_APPRAISAL_PURPOSE_NOTES',
                    'SET_APPRAISAL_REDUCTION_PCT',
                    'SET_APPRAISAL_TYPE',
                    'SET_APPRAISAL_ADOPTED_AREA',
                    'SET_APPRAISAL_LIFT',
                    'SET_APPRAISAL_ADOPTED_AGE',
                    'SET_APPRAISAL_PROPERTY_TYPE',
                    'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD',
                    'SET_APPRAISAL_QUALITY_OF_SITUATION',
                    'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION',
                    'SET_APPRAISAL_QUALITY_OF_REALESTATE',
                    'SET_APPRAISAL_CONSERVATION_STATUS',
                    'SET_APPRAISAL_MATERIAL_EXECUTION_COST',
                    'SET_APPRAISAL_MEC_ADJUSTMENT_COEF',
                    'SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT',
                    'SET_APPRAISAL_BC_PCT',
                    'SET_APPRAISAL_GC_PCT',
                    'SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT',

                    'UPDATE_APPRAISAL',
                    'UPDATE_APPRAISALREPORT',
                    'UPDATE_REALESTATE',

                    'SET_APPRAISAL_CESSION_BOOLEAN',
                    'SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME',
                    'SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME',
                    'SET_APPRAISAL_CESSION_NET_YEARLY_INCOME',
                    'SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS',
                    'SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS',
                    'SET_APPRAISAL_CESSION_CONTRACT_START_DATE',
                    'SET_APPRAISAL_LANDLORD_EXPENSES_PCT',
                    'SET_APPRAISAL_TENANT_AGE_YEARS',
                    'SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS',
                    'SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS',
                    'SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN',
                    'SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS',
                    'SET_APPRAISAL_PROTECTION_BOOLEAN',
                    'SET_APPRAISAL_PROTECTION_TYPE',
                    'SET_APPRAISAL_PROTECTION_REGIME',
                    'SET_APPRAISAL_PROTECTION_ZONE',
                    'SET_APPRAISAL_MAX_LEGAL_PRICE',
                    'SET_APPRAISAL_MAX_LEGAL_AREA',

                    'SET_APPRAISAL_URBAN_PLANNING_TYPE',
                    'SET_APPRAISAL_URBAN_PLANNING_FILE',
                    'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION',
                    'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION',
                    'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION',
                    'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION',
                    'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION',
                    'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION',
                    'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION',
                    'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION',

                    'SET_APPRAISAL_LAND_REGISTRY_AREA',
                    'SET_APPRAISAL_LAND_CADASTRAL_AREA',
                    'SET_APPRAISAL_LAND_CHECKED_AREA',
                    'SET_APPRAISAL_LAND_ADOPTED_AREA',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS',
                    'SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW',
                    'SET_APPRAISAL_LAND_AREA_NOTES',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT',
                    'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY',

                    'SET_APPRAISAL_PLOT_OCCUPATION',
                    'SET_APPRAISAL_PLOT_FREE_AREA_USAGE',
                    'SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND',
                    'SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND',
                    'SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER',
                    'SET_APPRAISAL_ENTRANCE_HALL',
                    'SET_APPRAISAL_DOORMAN_SPACE',
                    'SET_APPRAISAL_STAIRCASE',
                    'SET_APPRAISAL_SWIMMING_POOL',
                    'SET_APPRAISAL_GARDENED_AREAS',
                    'SET_APPRAISAL_SPORTS_FACILITIES',
                    'SET_APPRAISAL_COMMUNITY_ROOM',
                    'SET_APPRAISAL_STORAGE_ROOM',
                    'SET_APPRAISAL_COMMUNITY_PARKING',
                    'SET_APPRAISAL_FACILITIES_OTHERS',
                    'SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND',
                    'SET_APPRAISAL_FLOORS_USAGE_OVERGROUND',
                    'SET_APPRAISAL_GROUNDFLOOR_USAGE',

                    'SET_APPRAISAL_COMMUNICATIONS_AIRPORT',
                    'SET_APPRAISAL_COMMUNICATIONS_HARBOUR',
                    'SET_APPRAISAL_COMMUNICATIONS_TRAIN',
                    'SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND',
                    'SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN',

                    'SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES',
                    'SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE',
                    'SET_APPRAISAL_SURROUNDING_INCOME_LEVEL',
                    'SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE',
                    'SET_APPRAISAL_SURROUNDING_MAIN_USES',
                    'SET_APPRAISAL_SURROUNDING_DENSITY',
                    'SET_APPRAISAL_SURROUNDING_ACCESSIBILITY',
                    'SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE',
                    'SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE',
                    'SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED',
                    'SET_APPRAISAL_SURROUNDING_AVERAGE_AGE',
                    'SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS',
                    'SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES',
                    'SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES',
                    'SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING',
                    'SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE',
                    'SET_APPRAISAL_SURROUNDING_LEISURE',

                    'SET_APPRAISAL_CADASTRAL_USAGE',
                    'SET_APPRAISAL_CADASTRAL_FLOOR',
                    'SET_APPRAISAL_CADASTRAL_DOOR',
                    'SET_APPRAISAL_CADASTRAL_BLOCK',
                    'SET_APPRAISAL_CADASTRAL_STAIRCASE',
                    'SET_APPRAISAL_REGISTRY_NAME',
                    'SET_APPRAISAL_REGISTRY_SECTION',
                    'SET_APPRAISAL_REGISTRY_VOLUME',
                    'SET_APPRAISAL_REGISTRY_BOOK',
                    'SET_APPRAISAL_REGISTRY_PAGE',
                    'SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER',
                    'SET_APPRAISAL_REGISTRY_IDUFIR',
                    'SET_APPRAISAL_REGISTRY_OWNER',
                    'SET_APPRAISAL_REGISTRY_PROPERTY_COEF',
                    'SET_APPRAISAL_NET_CADASTRAL_AREA',
                    'SET_APPRAISAL_NET_REGISTRY_AREA',
                    'SET_APPRAISAL_NET_CHECKED_AREA',
                    'SET_APPRAISAL_NET_ADOPTED_AREA',
                    'SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA',
                    'SET_APPRAISAL_ENCLOSED_REGISTRY_AREA',
                    'SET_APPRAISAL_ENCLOSED_CHECKED_AREA',
                    'SET_APPRAISAL_ENCLOSED_ADOPTED_AREA',
                    'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA',
                    'SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA',
                    'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA',
                    'SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA',
                    'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA',
                    'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA',
                    'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA',
                    'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA',
                    'SET_APPRAISAL_BUILT_CADASTRAL_AREA',
                    'SET_APPRAISAL_BUILT_REGISTRY_AREA',
                    'SET_APPRAISAL_BUILT_CHECKED_AREA',
                    'SET_APPRAISAL_BUILT_ADOPTED_AREA',
                    'SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA',
                    'SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA',
                    'SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA',
                    'SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA',
                    'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA',
                    'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA',
                    'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA',
                    'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA',


                    'SET_APPRAISAL_ROOMS',
                    'UPDATE_APPRAISAL_ROOMS',

                    'SET_APPRAISAL_COVERED_OUTDOORS',
                    'UPDATE_APPRAISAL_COVERED_OUTDOORS',

                    'SET_APPRAISAL_UNCOVERED_OUTDOORS',
                    'UPDATE_APPRAISAL_UNCOVERED_OUTDOORS',

                    'SET_APPRAISAL_BATHROOMS_NUMBER',
                    'SET_APPRAISAL_BEDROOMS_NUMBER',

                    'SET_APPRAISAL_NET_SELECTED_AREA',
                    'SET_APPRAISAL_ENCLOSED_SELECTED_AREA',
                    'SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA',
                    'SET_APPRAISAL_BUILT_SELECTED_AREA',
                    'SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA',
                    'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA',
                    'SET_APPRAISAL_LAND_SELECTED_AREA',

                    'SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER',
                    'SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_GAS',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_TV',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION',
                    'SET_APPRAISAL_REALESTATE_FOUNDATION',
                    'SET_APPRAISAL_REALESTATE_STRUCTURE',
                    'SET_APPRAISAL_REALESTATE_ROOF',
                    'SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES',
                    'SET_APPRAISAL_REALESTATE_INSULATION',
                    'SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY',
                    'SET_APPRAISAL_REALESTATE_GLAZING',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM',
                    'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY',
                    'SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION',
                    'SET_APPRAISAL_REALESTATE_MAIN_VIEWS',
                    'SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY',
                    'SET_APPRAISAL_REALESTATE_NOISE_FACADE',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY',
                    'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY',

                    'SET_APPRAISAL_BEC_ADJUSTMENT_COEF',
                    'SET_APPRAISAL_BEC_PROPERTY_TYPE',
                    'SET_APPRAISAL_BEC_NUMBER',
                    'SET_APPRAISAL_CONSTRUCTION_STATUS',

                    'SET_APPRAISAL_ADJUSTED_BEC_PRICE',
                    'SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT',
                    'SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST',
                    'SET_APPRAISAL_CONSTRUCTION_COST_NOTES',

                    'SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR',
                    'SET_APPRAISAL_CONSTRUCTION_YEAR',
                    'SET_APPRAISAL_LAST_RENOVATION_YEAR',

                    'SET_APPRAISAL_NUCLEUS_POPULATION',
                    'SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY',
                    'SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH',
                    'SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT',
                    'SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT',
                    'SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT',
                    'SET_APPRAISAL_OCCUPATION_SERVICES_PCT',
                    'SET_APPRAISAL_OCCUPATION_TOTAL_PCT',
                    'SET_APPRAISAL_NUCLEUS_TYPE',
                    'SET_APPRAISAL_OCCUPATION_DESCRIPTION',
                    'SET_APPRAISAL_NUCLEUS_AREA',

                    'SET_APPRAISAL_CHECKS_OTHER',
                    'SET_APPRAISAL_DOCS_OTHER',
                    'SET_APPRAISAL_CHECKS_CADASTRAL_DATA',
                    'SET_APPRAISAL_CHECKS_CONSERVATION_STATUS',
                    'SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE',
                    'SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN',
                    'SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING',
                    'SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE',
                    'SET_APPRAISAL_CHECKS_INTERIOR_VISIT',
                    'SET_APPRAISAL_CHECKS_OCCUPANCY',
                    'SET_APPRAISAL_CHECKS_REGISTRY_DATA',
                    'SET_APPRAISAL_CHECKS_SERVITUDES',
                    'SET_APPRAISAL_CHECKS_SUBSIDY_STATUS',
                    'SET_APPRAISAL_CHECKS_URBAN_PLANNING',
                    'SET_APPRAISAL_DOCS_APPROVED_PROJECT',
                    'SET_APPRAISAL_DOCS_CADASTRAL_DATA',
                    'SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE',
                    'SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE',
                    'SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT',
                    'SET_APPRAISAL_DOCS_OCCUPANCY_STATUS',
                    'SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT',
                    'SET_APPRAISAL_DOCS_PROPERTY_SKETCH',
                    'SET_APPRAISAL_DOCS_PROPERTY_TITLES',
                    'SET_APPRAISAL_DOCS_SITUATION_PLAN',
                    'SET_APPRAISAL_DOCS_SUBSIDY_STATUS',
                    'SET_APPRAISAL_DOCS_TENYEAR_INSURANCE',
                    'SET_APPRAISAL_DOCS_URBAN_PLAN',
                    'SET_APPRAISAL_USEFUL_LIFE_YEARS',

                    'SET_APPRAISAL_PROPERTY_TITLE',
                    'SET_APPRAISAL_USAGE_ASSIGNED',
                    'SET_APPRAISAL_INSPECTION_REALIZED',
                    'SET_APPRAISAL_ECONOMICAL_ACTIVITY',
                    'SET_APPRAISAL_OCCUPANCY_STATUS',

                    'SET_APPRAISAL_MARKETSTUDY_ID',

                    'SET_APPRAISAL_TECHNICIAN_VISITING',

                    'DELETE_PHOTOGRAPH',
                    'FETCH_APPRAISAL_PHOTOGRAPHS',
                    'SET_PHOTOGRAPH',
                    'SET_PHOTOGRAPH_IS_COVER_PHOTO',
                    'UPDATE_PHOTOGRAPH',
                    'UPLOAD_PHOTOGRAPH_FILE',
                    'UPLOAD_PHOTOGRAPH_FILES',

                    'DELETE_REGISTRYANNEX',
                    'FETCH_APPRAISAL_REGISTRYANNEXES',
                    'SET_REGISTRYANNEX',
                    'UPLOAD_REGISTRYANNEX_FILE',
                    'UPLOAD_REGISTRYANNEX_FILES',

                    'DELETE_CADASTERANNEX',
                    'FETCH_APPRAISAL_CADASTERANNEXES',
                    'SET_CADASTERANNEX',
                    'UPLOAD_CADASTERANNEX_FILE',
                    'UPLOAD_CADASTERANNEX_FILES',

                    'DELETE_URBANANNEX',
                    'FETCH_APPRAISAL_URBANANNEXES',
                    'SET_URBANANNEX',
                    'UPLOAD_URBANANNEX_FILE',
                    'UPLOAD_URBANANNEX_FILES',

                    'DELETE_PLANANNEX',
                    'FETCH_APPRAISAL_PLANANNEXES',
                    'SET_PLANANNEX',
                    'UPLOAD_PLANANNEX_FILE',
                    'UPLOAD_PLANANNEX_FILES',

                    'DELETE_CESSIONANNEX',
                    'FETCH_APPRAISAL_CESSIONANNEXES',
                    'SET_CESSIONANNEX',
                    'UPLOAD_CESSIONANNEX_FILE',
                    'UPLOAD_CESSIONANNEX_FILES',

                    'DELETE_OTHERANNEX',
                    'FETCH_APPRAISAL_OTHERANNEXES',
                    'SET_OTHERANNEX',
                    'UPLOAD_OTHERANNEX_FILE',
                    'UPLOAD_OTHERANNEX_FILES',

                    'SET_APPRAISALREPORT_COVER_PHOTO_URL',

                    'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X',
                    'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y',
                    'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM',
                    'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X',
                    'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y',
                    'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM',
                    'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X',
                    'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y',
                    'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM',

                    'SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS',
                    'SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS',
                    'SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR',
                    'SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY',
                    'SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS',
                    'SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES',
                    'SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE',
                    'SET_APPRAISAL_QUOTE_BASE_FEES',
                    'SET_APPRAISAL_QUOTE_EXCESS_PCT',
                    'SET_APPRAISAL_QUOTE_BASE_PRICE',
                    'SET_APPRAISAL_QUOTE_BASE_PRICE_COEF',

					'SET_APPRAISAL_I_PCT',

					'SET_REALESTATE_INVOICE_BASE_FEES',
                    'SET_REALESTATE_INVOICE_EXCESS_PCT',
                    'SET_REALESTATE_INVOICE_BASE_PRICE',
                    'SET_REALESTATE_INVOICE_BASE_PRICE_COEF',
                    'SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO',
                    'SET_REALESTATE_INVOICE_PRICE_INCL_TRAVEL_EXPENSES',

					'SET_APPRAISAL_USAGE_TYPE',

					'SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER',


                ]),
            set_appraisal_i_pct: _.debounce(function(e){
                this.SET_APPRAISAL_I_PCT(Number(e.target.value))
                this.recalcAppraisal()
            }, 500),
            set_appraisal_bc_pct: _.debounce(function(e){
                this.SET_APPRAISAL_BC_PCT(Number(e.target.value))
                this.recalcAppraisal()
            }, 1000),
            set_appraisal_gc_pct: _.debounce(function(e){
                this.SET_APPRAISAL_GC_PCT(Number(e.target.value))
                this.recalcAppraisal()
            }, 1000),
            set_appraisal_appraisaldate: _.debounce(function (e) {
                this.SET_APPRAISAL_APPRAISALDATE(e.target.value).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_visitdate: _.debounce(function (e) {
                this.SET_APPRAISAL_VISITDATE(e.target.value).then(() => {
                })
            }, 1000),
            set_appraisal_technician_visiting: _.debounce(function (e) {
                this.SET_APPRAISAL_TECHNICIAN_VISITING(e)
            }, 1000),
            set_appraisal_description: _.debounce(function (e) {
                this.SET_APPRAISAL_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_reduction_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_REDUCTION_PCT(Number(e.target.value)).then(() => {
                    this.recalcMarketAndAppraisals()
                    this.recalcAppraisal()

                })
            }, 1000),
            set_appraisal_total_construction_progress_pct: _.debounce(function(e){
                this.SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT(Number(e.target.value)).then(() => {
                    // this.recalcMarketAndAppraisals()
                    this.recalcAppraisal()

                })
            }, 1000),
            set_appraisal_purpose: _.debounce(function (e) {
                this.master_loading = true
                let reduction_pct = e.default_reduction_pct
                /*
				if(this.appraisal.adjustment_coef){
					reduction_pct = this.appraisal.adjustment_coef
				}
				*/
                this.SET_APPRAISAL_REDUCTION_PCT(reduction_pct).then(
                    this.SET_APPRAISAL_PURPOSE(e).then((res) => {
                        this.SET_APPRAISAL_PURPOSE_NOTES(e.default_notes.name_ca).then((res) => {
                            this.master_loading = false
                            this.recalcMarketAndAppraisals()
                            this.recalcAppraisal()

                        })
                    })
                )
            }, 0),
            set_appraisal_purpose_notes: _.debounce(function (e) {
                this.SET_APPRAISAL_PURPOSE_NOTES(e.target.value)
            }, 1000),
            set_appraisal_type: _.debounce(function (e) {
                this.SET_APPRAISAL_TYPE(e)
            }, 1000),
            set_appraisal_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AREA(Number(e.target.value)).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_landlord_expenses_pct: _.debounce(function (e) {
                let expenses_pct = Number(e.target.value)
                if (expenses_pct > 100) {
                    expenses_pct = 100
                } else if (expenses_pct < 0) {
                    expenses_pct = 0
                } else if (!expenses_pct) {
                    expenses_pct = 70
                }
                let yearly_income = this.appraisal.cession_gross_yearly_income
                if (!yearly_income) {
                    yearly_income = 0
                }
                let net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100))
                this.SET_APPRAISAL_LANDLORD_EXPENSES_PCT(expenses_pct).then(() => {
                    this.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(() => {
                        this.recalcAppraisal()
                    })
                })
            }, 1000),
            set_appraisal_market_value_appraiser_adjustment_pct: _.debounce(function(e){
                this.SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT(Number(e.target.value))
                this.recalcAppraisal()
            }, 1000),
            set_appraisal_lift: _.debounce(function (e) {
                this.SET_APPRAISAL_LIFT(e.target.value).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_adopted_age: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AGE(Number(e.target.value)).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_property_type: _.debounce(function (e) {
                this.SET_APPRAISAL_PROPERTY_TYPE(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_quality_of_neighbourhood: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_quality_of_situation: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_SITUATION(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_quality_of_construction: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_CONSTRUCTION(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_quality_of_realestate: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_REALESTATE(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_conservation_status: _.debounce(function (e) {
                this.SET_APPRAISAL_CONSERVATION_STATUS(e).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_material_execution_cost: _.debounce(function (e) {
                this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(e.target.value).then(() => {
                    this.calc_construction_cost()
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_mec_adjustment_coef: _.debounce(function (e) {
                this.SET_APPRAISAL_MEC_ADJUSTMENT_COEF(e.target.value).then(() => {
                    this.calc_construction_cost()
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_cession_boolean: _.debounce(function (e) {
                this.SET_APPRAISAL_CESSION_BOOLEAN(this.appraisal.cession_boolean).then(() => {
                    this.recalcAppraisal()
                })
            }, 0),
            set_appraisal_right_of_use_boolean: _.debounce(function (e) {
                this.SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN(this.appraisal.right_of_use_boolean).then(() => {
                    this.recalcAppraisal()
                })
            }, 0),
            set_appraisal_cession_gross_monthly_income: _.debounce(function (e) {
                let monthly_income = Number(e.target.value)
                let yearly_income = this.roundToTwo(monthly_income * 12)
                let expenses_pct = this.appraisal.landlord_expenses_pct
                if (!expenses_pct) {
                    expenses_pct = 70
                }
                let net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100))
                this.SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME(monthly_income).then(() => {
                    this.SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME(yearly_income)
                    this.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(() => {
                        this.recalcAppraisal()
                    })
                })
            }, 500),
            set_appraisal_cession_gross_yearly_income: _.debounce(function (e) {
                let yearly_income = Number(e.target.value)
                let monthly_income = this.roundToTwo(yearly_income / 12)
                let expenses_pct = this.appraisal.landlord_expenses_pct
                if (!expenses_pct) {
                    expenses_pct = 70
                }
                let net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100))
                this.SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME(Number(yearly_income)).then(() => {
                    this.SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME(monthly_income)
                    this.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(() => {
                        this.recalcAppraisal()
                    })
                })
            }, 500),
            set_appraisal_cession_net_yearly_income: _.debounce(function (e) {
                this.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 500),
            set_appraisal_cession_contract_period_years: _.debounce(function (e) {
                this.SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS(Number(e.target.value)).then(() => {
                    this.set_appraisal_cession_contract_remaining_years()
                })
            }, 500),
            set_appraisal_cession_contract_remaining_years: _.debounce(function (e) {
                let a = moment(this.appraisal.appraisaldate)
                let b = moment(this.appraisal.cession_contract_start_date).add(this.appraisal.cession_contract_period_years, 'years')
                let diff_years = this.roundToTwo(b.diff(a, 'years', true))
                this.SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS(diff_years).then(() => {
                    this.recalcAppraisal()
                })
            }, 500),
            set_appraisal_cession_contract_start_date: _.debounce(function (e) {
                this.SET_APPRAISAL_CESSION_CONTRACT_START_DATE(e.target.value).then(() => {
                    this.set_appraisal_cession_contract_remaining_years()
                })
            }, 500),
            set_appraisal_tenant_age_years: _.debounce(function (e) {
                let age = Number(e.target.value)
                let life_expectancy = this.appraisal.tenant_life_expectancy_years
                if (!life_expectancy) {
                    life_expectancy = 80
                }
                let remaining_years = life_expectancy - age

                this.SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS(life_expectancy)
                this.SET_APPRAISAL_TENANT_AGE_YEARS(age)
                this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(remaining_years).then(() => {
                    this.recalcAppraisal()
                })
            }, 500),
            set_appraisal_tenant_life_expectancy_years: _.debounce(function (e) {
                let life_expectancy = Number(e.target.value)

				console.log('life_expectancy: ')
				console.log(life_expectancy)

                let age = this.appraisal.tenant_age_years
                if (!age) {
                    age = 35
                }

                console.log('age: ')
				console.log(age)

                let remaining_years = life_expectancy - age

				console.log('remaining_years: ')
				console.log(remaining_years)

                this.SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS(life_expectancy)
                this.SET_APPRAISAL_TENANT_AGE_YEARS(age)
                this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(remaining_years).then(() => {
                    this.recalcAppraisal()
                })
            }, 500),
            set_appraisal_tenant_remaining_life_expectancy_years: _.debounce(function (e) {
                this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 500),
            set_appraisal_useful_life_years: _.debounce(function (e) {
                this.SET_APPRAISAL_USEFUL_LIFE_YEARS(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_remaining_useful_life_years: _.debounce(function (e) {
                this.SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_usufructuary_age_years: _.debounce(function (e) {
                this.SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_protection_boolean: _.debounce(function (e) {
                this.SET_APPRAISAL_PROTECTION_BOOLEAN(this.appraisal.protection_boolean).then(() => {
                    this.recalcAppraisal()
                })
            }, 0),
            set_appraisal_protection_type: _.debounce(function (e) {
                this.SET_APPRAISAL_PROTECTION_TYPE(e)
            }, 1000),
            set_appraisal_protection_regime: _.debounce(function (e) {
                this.SET_APPRAISAL_PROTECTION_REGIME(e)
            }, 1000),
            set_appraisal_protection_zone: _.debounce(function (e) {
                this.SET_APPRAISAL_PROTECTION_ZONE(e)
            }, 1000),
            set_appraisal_max_legal_price: _.debounce(function (e) {
                this.SET_APPRAISAL_MAX_LEGAL_PRICE(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_max_legal_area: _.debounce(function (e) {
                this.SET_APPRAISAL_MAX_LEGAL_AREA(Number(e.target.value)).then(() => {
                    this.recalcAppraisal()
                })
            }, 1000),
            set_appraisal_urban_planning_type: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_TYPE(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_file: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_FILE(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_council_qualification: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_council_qualification_description: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_council_classification: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_council_classification_description: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_regional_qualification: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_regional_qualification_description: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_regional_classification: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION(e.target.value)
            }, 1000),
            set_appraisal_urban_planning_regional_classification_description: _.debounce(function (e) {
                this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_land_registry_area: _.debounce(function (e) {
                let registry_area = Number(e.target.value)
                let cadastral_area = this.appraisal.land_cadastral_area
                let checked_area = this.appraisal.land_checked_area
                let adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area)

                this.SET_APPRAISAL_LAND_REGISTRY_AREA(registry_area)
                this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area)
            }, 1000),
            set_appraisal_land_cadastral_area: _.debounce(function (e) {
                let registry_area = this.appraisal.land_registry_area
                let cadastral_area = Number(e.target.value)
                let checked_area = this.appraisal.land_checked_area
                let adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area)

                this.SET_APPRAISAL_LAND_CADASTRAL_AREA(cadastral_area)
                this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area)

            }, 1000),
            set_appraisal_land_checked_area: _.debounce(function (e) {
                let registry_area = this.appraisal.land_registry_area
                let cadastral_area = this.appraisal.land_cadastral_area
                let checked_area = Number(e.target.value)
                let adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area)

                this.SET_APPRAISAL_LAND_CHECKED_AREA(checked_area)
                this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area)
            }, 1000),
            set_appraisal_land_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_ADOPTED_AREA(Number(e.target.value))
            }, 1000),
            set_room_description: _.debounce(function (e, f) {
                // this.master_loading = true
                this.editing_room = true
                this.editing_room_text_color = 'whitesmoke'
                this.editing_room_border_color = 'whitesmoke'
                let description = e.target.value
                let obj = this.appraisal_rooms
                let id = f['id']
                obj[id]['description'] = description

                this.UPDATE_APPRAISAL_ROOMS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.master_loading = false
                    this.editing_room = false
                    this.editing_room_text_color = 'black'
                    this.editing_room_border_color = 'lightgray'
                })
            }, 0),
            set_room_type: _.debounce(function (e, f) {
                // this.master_loading = true
                this.editing_room = true
                this.editing_room_text_color = 'whitesmoke'
                this.editing_room_border_color = 'whitesmoke'
                let type = e
                let obj = this.appraisal_rooms
                let id = f['id']
                obj[id]['type'] = type

                this.UPDATE_APPRAISAL_ROOMS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.calc_rooms_number(this.object_to_array(obj))
                    this.master_loading = false
                    this.editing_room = false
                    this.editing_room_text_color = 'black'
                    this.editing_room_border_color = 'lightgray'
                })
            }, 0),
            set_room_netarea: _.debounce(function (e, f) {
                // this.master_loading = true
                this.editing_room = true
                this.editing_room_text_color = 'whitesmoke'
                this.editing_room_border_color = 'whitesmoke'
                let value = e.target.value
                if (!value) {
                    value = 0
                }
                let netarea = Number(value)
                let obj = this.appraisal_rooms
                let id = f['id']
                obj[id]['netarea'] = netarea

                this.UPDATE_APPRAISAL_ROOMS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.calc_net_area(this.object_to_array(obj))
                    this.calc_adopted_areas()
                    this.master_loading = false
                    this.editing_room = false
                    this.editing_room_text_color = 'black'
                    this.editing_room_border_color = 'lightgray'
                })
            }, 0),
            set_covered_outdoor_description: _.debounce(function (e, f) {
                this.editing_covered_outdoor = true
                this.editing_covered_outdoor_text_color = 'whitesmoke'
                this.editing_covered_outdoor_border_color = 'whitesmoke'

                let description = e.target.value
                let obj = this.appraisal_covered_outdoors
                let id = f['id']
                obj[id]['description'] = description

                this.UPDATE_APPRAISAL_COVERED_OUTDOORS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.master_loading = false
                    this.editing_covered_outdoor = false
                    this.editing_covered_outdoor_text_color = 'black'
                    this.editing_covered_outdoor_border_color = 'lightgray'
                })
            }, 0),
            set_covered_outdoor_type: _.debounce(function (e, f) {
                this.editing_covered_outdoor = true
                this.editing_covered_outdoor_text_color = 'whitesmoke'
                this.editing_covered_outdoor_border_color = 'whitesmoke'

                let type = e
                let obj = this.appraisal_covered_outdoors
                let id = f['id']
                obj[id]['type'] = type

                this.SET_APPRAISAL_COVERED_OUTDOORS(obj).then((res) => {
                })
            }, 0),
            set_covered_outdoor_netarea: _.debounce(function (e, f) {
                this.editing_covered_outdoor = true
                this.editing_covered_outdoor_text_color = 'whitesmoke'
                this.editing_covered_outdoor_border_color = 'whitesmoke'

                let value = e.target.value
                if (!value) {
                    value = 0
                }
                let netarea = Number(value)
                let obj = this.appraisal_covered_outdoors
                let id = f['id']
                obj[id]['netarea'] = netarea

                this.UPDATE_APPRAISAL_COVERED_OUTDOORS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.calc_covered_outdoors_net_area(this.object_to_array(obj))
                    this.calc_adopted_areas()
                    this.master_loading = false
                    this.editing_covered_outdoor = false
                    this.editing_covered_outdoor_text_color = 'black'
                    this.editing_covered_outdoor_border_color = 'lightgray'
                })

            }, 0),
            set_uncovered_outdoor_description: _.debounce(function (e, f) {
                this.editing_uncovered_outdoor = true
                this.editing_uncovered_outdoor_text_color = 'whitesmoke'
                this.editing_uncovered_outdoor_border_color = 'whitesmoke'

                let description = e.target.value
                let obj = this.appraisal_uncovered_outdoors
                let id = f['id']
                obj[id]['description'] = description

                this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.master_loading = false
                    this.editing_uncovered_outdoor = false
                    this.editing_uncovered_outdoor_text_color = 'black'
                    this.editing_uncovered_outdoor_border_color = 'lightgray'
                })
            }, 0),
            set_uncovered_outdoor_type: _.debounce(function (e, f) {
                this.editing_uncovered_outdoor = true
                this.editing_uncovered_outdoor_text_color = 'whitesmoke'
                this.editing_uncovered_outdoor_border_color = 'whitesmoke'

                let type = e
                let obj = this.appraisal_uncovered_outdoors
                let id = f['id']
                obj[id]['type'] = type

                this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.master_loading = false
                    this.editing_uncovered_outdoor = false
                    this.editing_uncovered_outdoor_text_color = 'black'
                    this.editing_uncovered_outdoor_border_color = 'lightgray'
                })
            }, 0),
            set_uncovered_outdoor_netarea: _.debounce(function (e, f) {
                this.editing_uncovered_outdoor = true
                this.editing_uncovered_outdoor_text_color = 'whitesmoke'
                this.editing_uncovered_outdoor_border_color = 'whitesmoke'

                let value = e.target.value
                if (!value) {
                    value = 0
                }
                let netarea = Number(value)
                let obj = this.appraisal_uncovered_outdoors
                let id = f['id']
                obj[id]['netarea'] = netarea

                this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({appraisal_id: this.appraisal.id, object: obj}).then((res) => {
                    this.calc_uncovered_outdoors_net_area(this.object_to_array(obj))
                    this.calc_adopted_areas()
                    this.master_loading = false
                    this.editing_uncovered_outdoor = false
                    this.editing_uncovered_outdoor_text_color = 'black'
                    this.editing_uncovered_outdoor_border_color = 'lightgray'
                })
            }, 0),
            set_appraisal_bathrooms_number: _.debounce(function (e) {
                this.SET_APPRAISAL_BATHROOMS_NUMBER(Number(e.target.value))
            }, 1000),
            set_appraisal_bedrooms_number: _.debounce(function (e) {
                this.SET_APPRAISAL_BEDROOMS_NUMBER(Number(e.target.value))
            }, 1000),
            set_appraisal_net_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NET_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_enclosed_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ENCLOSED_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_covered_outdoors_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_common_elements_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_plus_common_elements_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA(e)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_land_selected_area: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_SELECTED_AREA(e)

                let registry_area = this.appraisal.land_registry_area
                let cadastral_area = this.appraisal.land_cadastral_area
                let checked_area = this.appraisal.land_checked_area
                let adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area)
                this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area)

            }, 0),
            set_appraisal_bec_adjustment_coef: _.debounce(function (e) {
                let bec_price = this.appraisal.bec_number.total
                let coef = Number(e.target.value)
                let adjusted_bec_price = this.roundToTwo(bec_price * coef)
                let desp_pct = this.appraisal.expenses_and_industrial_benefit_bec_pct
                let mec = this.roundToTwo(adjusted_bec_price / ( 1 + (desp_pct / 100)))
                let mec_coef = this.appraisal.mec_adjustment_coef
                let adopted_mec = this.roundToTwo(mec * mec_coef)

                this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price)
                this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec)
                this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec)

                this.SET_APPRAISAL_BEC_ADJUSTMENT_COEF(coef)
                    .then(() => {
                        this.calc_construction_cost()
                        this.recalcAppraisal()
                    })
            }, 1000),
            set_appraisal_bec_property_type: _.debounce(function (e) {
                this.SET_APPRAISAL_BEC_NUMBER(null)
                this.master_loading = true
                this.SET_APPRAISAL_BEC_PROPERTY_TYPE(e).then(() => {
                    this.FETCH_APPRAISAL_BEC_PRICES({path: 'becproperty_becprices' + '/' + this.appraisal.bec_property_type.id}).then(() => {
                        this.master_loading = false
                    })
                })
            }, 0),
            set_appraisal_bec_number: _.debounce(function (e) {
                this.SET_APPRAISAL_BEC_NUMBER(e)
                    .then(() => {
                        this.calc_construction_cost()
                        this.recalcAppraisal()
                    })

            }, 1000),
            set_appraisal_construction_status: _.debounce(function (e) {
                this.SET_APPRAISAL_CONSTRUCTION_STATUS(e)
            }, 1000),
            set_appraisal_quote_travel_one_way_hours: _.debounce(function (e) {

                let hours = Number(e.target.value)
                this.SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS(hours)

                if (hours > 0) {
                    this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(hours * 2)
                } else if (hours === 0 || !hours) {
                    this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(0)

                }
                this.set_appraisal_quote_total_travel_fees()

            }, 1000),
            set_appraisal_quote_travel_both_ways_hours: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_travel_fees_per_hour: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR(Number(e.target.value))
                this.set_appraisal_quote_total_travel_fees()
            }, 1000),
            set_appraisal_quote_car_expenses_one_way: _.debounce(function (e) {

                let expenses = Number(e.target.value)
                this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY(expenses)

                if (expenses > 0) {
                    this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(expenses * 2)
                } else if (expenses === 0 || !expenses) {
                    this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(0)
                }

                this.set_appraisal_quote_total_travel_fees()
            }, 1000),
            set_appraisal_quote_car_expenses_both_ways: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_total_travel_fees: _.debounce(function (e) {

                let travel_expenses = this.appraisal.quote_car_expenses_both_ways

				let hours = this.appraisal.quote_travel_both_ways_hours

				if(!this.appraisal.quote_travel_both_ways_hours){
                    hours = 0
				}

				let hourly_fees = this.appraisal.quote_travel_fees_per_hour

                if(! this.appraisal.quote_travel_fees_per_hour){
                    hourly_fees = 0
                }
				let travel_fees = hours * hourly_fees
				let total = travel_expenses + travel_fees

                this.SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES(total)
            }, 1000),
            set_appraisal_quote_area_average_unit_price: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_base_fees: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_BASE_FEES(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_excess_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_EXCESS_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_base_price: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_BASE_PRICE(Number(e.target.value))
            }, 1000),
            set_appraisal_quote_base_price_coef: _.debounce(function (e) {
                this.SET_APPRAISAL_QUOTE_BASE_PRICE_COEF(Number(e.target.value))
            }, 1000),
            onOpenCadastralFile: function () {
                console.log('opening cadastral file...')
                // const url = 'https://www.whatismyreferer.com/'
                const refcat = this.realestate.cadastral_reference
                if (refcat.length < 20) {
                    alert('La referència cadastral té menys de 20 posicions. Revisar')
                }
                const url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCConCiud.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&UrbRus=U&RefC=' + refcat + '&Apenom=&esBice=&RCBice1=&RCBice2=&DenoBice='
                console.log(url)
                const win = window.open(url, '_blank')
                win.focus()
            },
            onOpenMarketStudy: function () {
                if (this.appraisal.dirty) {
                    const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                    if (result) {
                        this.$router.push({
                            name: 'marketstudy-editor',
                            query: {id: this.appraisal.marketstudy_id, appraisal_id: this.appraisal.id}
                        })
                    } else {
                        return false

                    }
                } else {
                    this.$router.push({
                        name: 'marketstudy-editor',
                        query: {id: this.appraisal.marketstudy_id, appraisal_id: this.appraisal.id}
                    })
                }
            },
            calc_construction_cost: function () {
                let bec_price = this.appraisal.bec_number.total
                let coef = this.appraisal.bec_adjustment_coef
                let adjusted_bec_price = this.roundToTwo(bec_price * coef)
                let desp_pct = this.appraisal.expenses_and_industrial_benefit_bec_pct
                let mec = this.roundToTwo(adjusted_bec_price / ( 1 + (desp_pct / 100)))
                let mec_coef = this.appraisal.mec_adjustment_coef
                let adopted_mec = this.roundToTwo(mec * mec_coef)

                this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price)
                this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec)
                this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec)
            },
            calc_rooms_number: function (rooms_array) {

                let total_bathrooms = 0
                let total_bedrooms = 0

                for (let i = 0; i < rooms_array.length; i++) {
                    if (rooms_array[i].type) {
                        let type = rooms_array[i].type.code_ca
                        if (type === 'CH') {
                            total_bathrooms = total_bathrooms + 1
                        } else if (type === 'H') {
                            total_bedrooms = total_bedrooms + 1
                        }
                    }
                }
                this.SET_APPRAISAL_BATHROOMS_NUMBER(total_bathrooms)
                this.SET_APPRAISAL_BEDROOMS_NUMBER(total_bedrooms)

            },
            check_adopted_area (registry_area, cadastral_area, checked_area, selected_area) {

                let adopted_area = 0

                if (selected_area === 'Registral') {
                    // console.log('A')
                    adopted_area = registry_area
                } else if (selected_area === 'Cadastral') {
                    // console.log('B')
                    adopted_area = cadastral_area
                } else if (selected_area === 'Comprovada') {
                    // console.log('C')
                    adopted_area = checked_area
                } else {
                    if (!checked_area) {
                        checked_area = 0
                    }

                    if (!registry_area) {
                        registry_area = 0
                    }

                    if (!checked_area) {
                        checked_area = 0
                    }

                    if (registry_area > 0 && registry_area < checked_area * 0.8) {
                        if (cadastral_area > 0 && cadastral_area < checked_area * 0.8) {
                            if (registry_area < cadastral_area) {
                                // console.log('D11')
                                adopted_area = registry_area
                            } else {
                                // console.log('D12')
                                adopted_area = cadastral_area
                            }
                        }
                        // console.log('D1')
                        adopted_area = registry_area
                    } else if (cadastral_area > 0 && cadastral_area < checked_area * 0.8) {
                        // console.log('D2')
                        adopted_area = cadastral_area
                    } else if (checked_area === 0) {
                        if (cadastral_area > 0 && registry_area > 0) {
                            if (cadastral_area < registry_area) {
                                // console.log('D31')

                                adopted_area = cadastral_area
                            } else {
                                // console.log('D32')

                                adopted_area = registry_area
                            }
                        } else if (cadastral_area > 0 && registry_area === 0) {
                            // console.log('D4')

                            adopted_area = cadastral_area
                        } else if (registry_area > 0 && cadastral_area === 0) {
                            // console.log('D5')

                            adopted_area = registry_area
                        }
                        // console.log('D6')
                        adopted_area = cadastral_area
                    } else {
                        // console.log('D7')
                        adopted_area = checked_area
                    }
                }
                // console.log('-----')
                // console.log('///***/// adopted_area:')
                // console.log(adopted_area)
                return adopted_area
            },
            calc_adopted_areas: function () {
                let net_registry_area = this.appraisal.net_registry_area
                let net_cadastral_area = this.appraisal.net_cadastral_area
                let net_checked_area = this.appraisal.net_checked_area
                let net_selected_area = 'Auto'
                if (this.appraisal.net_selected_area) {
                    net_selected_area = this.appraisal.net_selected_area.name_ca
                }
                let net_adopted_area = this.check_adopted_area(net_registry_area, net_cadastral_area, net_checked_area, net_selected_area)

                let enclosed_registry_area = this.appraisal.enclosed_registry_area
                let enclosed_cadastral_area = this.appraisal.enclosed_cadastral_area
                let enclosed_checked_area = this.appraisal.enclosed_checked_area
                let enclosed_selected_area = 'Auto'
                if (this.appraisal.enclosed_selected_area) {
                    enclosed_selected_area = this.appraisal.enclosed_selected_area.name_ca
                }
                let enclosed_adopted_area = this.check_adopted_area(enclosed_registry_area, enclosed_cadastral_area, enclosed_checked_area, enclosed_selected_area)

                let covered_terraces_total_registry_area = this.appraisal.covered_terraces_total_registry_area
                let covered_terraces_total_cadastral_area = this.appraisal.covered_terraces_total_cadastral_area
                let covered_terraces_total_checked_area = this.appraisal.covered_terraces_total_checked_area
                let covered_terraces_total_selected_area = 'Auto'
                if (this.appraisal.covered_outdoors_selected_area) {
                    covered_terraces_total_selected_area = this.appraisal.covered_outdoors_selected_area.name_ca
                }
                let covered_terraces_total_adopted_area = this.check_adopted_area(covered_terraces_total_registry_area, covered_terraces_total_cadastral_area, covered_terraces_total_checked_area, covered_terraces_total_selected_area)

                let built_registry_area = this.appraisal.built_registry_area
                let built_cadastral_area = this.appraisal.built_cadastral_area
                let built_checked_area = this.roundToTwo(this.appraisal.enclosed_checked_area + (this.appraisal.covered_terraces_total_checked_area / 2))

                this.SET_APPRAISAL_BUILT_CHECKED_AREA(built_checked_area)

                let built_selected_area = 'Auto'
                if (this.appraisal.built_selected_area) {
                    built_selected_area = this.appraisal.built_selected_area.name_ca
                }
                let built_adopted_area = this.check_adopted_area(built_registry_area, built_cadastral_area, built_checked_area, built_selected_area)

                let common_elements_registry_area = this.appraisal.common_elements_registry_area
                let common_elements_cadastral_area = this.appraisal.common_elements_cadastral_area
                let common_elements_checked_area = this.appraisal.common_elements_checked_area
                let common_elements_selected_area = 'Auto'
                if (this.appraisal.common_elements_selected_area) {
                    common_elements_selected_area = this.appraisal.common_elements_selected_area.name_ca
                }
                let common_elements_adopted_area = this.check_adopted_area(common_elements_registry_area, common_elements_cadastral_area, common_elements_checked_area, common_elements_selected_area)

                let built_plus_common_elements_registry_area = this.appraisal.built_plus_common_elements_registry_area
                let built_plus_common_elements_cadastral_area = this.appraisal.built_plus_common_elements_cadastral_area
                let built_plus_common_elements_checked_area = this.appraisal.built_plus_common_elements_checked_area
                let built_plus_common_elements_selected_area = 'Auto'
                if (this.appraisal.built_plus_common_elements_selected_area) {
                    built_plus_common_elements_selected_area = this.appraisal.built_plus_common_elements_selected_area.name_ca
                }

                let built_plus_common_elements_adopted_area = 0

                if (built_plus_common_elements_selected_area === 'Auto') {
                    built_plus_common_elements_adopted_area = built_adopted_area + common_elements_adopted_area
                } else {
                    built_plus_common_elements_adopted_area = this.check_adopted_area(built_plus_common_elements_registry_area, built_plus_common_elements_cadastral_area, built_plus_common_elements_checked_area, built_plus_common_elements_selected_area)
                }

                this.SET_APPRAISAL_NET_ADOPTED_AREA(net_adopted_area)
                this.SET_APPRAISAL_ENCLOSED_ADOPTED_AREA(enclosed_adopted_area)
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA(covered_terraces_total_adopted_area)
                this.SET_APPRAISAL_BUILT_ADOPTED_AREA(built_adopted_area)
                this.SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA(common_elements_adopted_area)
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA(built_plus_common_elements_adopted_area)

                this.SET_APPRAISAL_ADOPTED_AREA(built_adopted_area)

                this.recalcAppraisal()
            },
            calc_net_area: function (rooms_array) {
                let partial = 0
                let total_checked = 0

                for (let i = 0; i < rooms_array.length; i++) {

                    partial = rooms_array[i].netarea
                    total_checked = total_checked + partial
                }
                console.log('net areas total: ')
                console.log(total_checked)
                this.SET_APPRAISAL_NET_CHECKED_AREA(total_checked)

            },
            calc_covered_outdoors_net_area: function (rooms_array) {
                let partial = 0
                let total_checked = 0

                for (let i = 0; i < rooms_array.length; i++) {

                    partial = rooms_array[i].netarea
                    total_checked = total_checked + partial
                }
                console.log('covered outdoors total: ')
                console.log(total_checked)
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA(total_checked)

            },
            calc_uncovered_outdoors_net_area: function (rooms_array) {
                let partial = 0
                let total_checked = 0

                for (let i = 0; i < rooms_array.length; i++) {

                    partial = rooms_array[i].netarea
                    total_checked = total_checked + partial
                }

                console.log('uncovered outdoors total: ')
                console.log(total_checked)
                this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA(total_checked)

            },
            calc_land_adopted_area: function (registry_area, cadastral_area, checked_area) {

                let method = this.appraisal.land_selected_area
                let adopted_area = 0

                if (method.name_en === 'Auto') {
                    if (!registry_area) {
                        registry_area = 0
                    }

                    if (!cadastral_area) {
                        cadastral_area = 0
                    }

                    if (!checked_area) {
                        checked_area = 0
                    }

                    if (registry_area === 0) {
                        adopted_area = checked_area
                    } else if (checked_area === 0) {
                        adopted_area = registry_area
                    } else if (registry_area < (checked_area * 0.8)) {
                        adopted_area = registry_area
                    } else {
                        adopted_area = checked_area
                    }

                    if (checked_area === 0) {

                        if (registry_area <= cadastral_area && registry_area > 0) {
                            adopted_area = registry_area
                        } else if (cadastral_area < registry_area && cadastral_area > 0) {
                            adopted_area = cadastral_area
                        } else if (cadastral_area > registry_area) {
                            adopted_area = cadastral_area
                        } else {
                            adopted_area = registry_area
                        }

                    } else {
                        if (registry_area < (checked_area * 0.8)) {
                            adopted_area = registry_area
                        } else if (cadastral_area < (checked_area * 0.8)) {
                            adopted_area = cadastral_area
                        } else {
                            adopted_area = checked_area
                        }

                    }
                } else if (method.name_en === 'Registry') {
                    adopted_area = registry_area

                } else if (method.name_en === 'Cadastral') {
                    adopted_area = cadastral_area

                } else if (method.name_en === 'Checked') {
                    adopted_area = checked_area
                }

                return adopted_area
            },
            set_appraisal_land_infrastructure_paving_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_paving = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_sewage_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_sewage = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_public_lighting_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_public_lighting = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_water_supply_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_water_supply = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_electricity_supply_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_electricity_supply = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_piped_gas_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_piped_gas = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_telephone_service_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_telephone_service = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            set_appraisal_land_infrastructure_gardened_areas_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT(Number(e.target.value))
                if (Number(e.target.value) > 0) {
                    this.appraisal.land_infrastructure_gardened_areas = true
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 1000),
            calc_land_infrastructure_total_execution_pct: function () {
                let values = []
                let paving = this.appraisal.land_infrastructure_paving_execution_pct
                if (!paving) {
                    paving = 0
                }
                let sewage = this.appraisal.land_infrastructure_sewage_execution_pct
                if (!sewage) {
                    sewage = 0
                }
                let public_lighting = this.appraisal.land_infrastructure_public_lighting_execution_pct
                if (!public_lighting) {
                    public_lighting = 0
                }
                let water_supply = this.appraisal.land_infrastructure_water_supply_execution_pct
                if (!water_supply) {
                    water_supply = 0
                }
                let electricity_supply = this.appraisal.land_infrastructure_electricity_supply_execution_pct
                if (!electricity_supply) {
                    electricity_supply = 0
                }
                let piped_gas = this.appraisal.land_infrastructure_piped_gas_execution_pct
                if (!piped_gas) {
                    piped_gas = 0
                }
                let telephone_service = this.appraisal.land_infrastructure_telephone_service_execution_pct
                if (!telephone_service) {
                    telephone_service = 0
                }
                let gardened_areas = this.appraisal.land_infrastructure_gardened_areas_execution_pct
                if (!gardened_areas) {
                    gardened_areas = 0
                }
                values.push(paving, sewage, public_lighting, water_supply, electricity_supply, piped_gas, telephone_service, gardened_areas)

                let sum = 0
                for (let i = 0; i < values.length; i++) {
                    sum += Number(values[i])
                }

                let average = this.roundToTwo(sum / values.length)

                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT(average)

                let repercussion_cost = this.appraisal.land_infrastructure_repercussion_cost

                if (!repercussion_cost) {
                    repercussion_cost = 150
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST(repercussion_cost)
                }

                let pending = this.roundToTwo(repercussion_cost * ((100 - average) / 100))

                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT(pending)

            },
            set_appraisal_land_infrastructure_total_execution_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_land_infrastructure_repercussion_cost: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST(Number(e.target.value))
            }, 1000),
            set_appraisal_land_infrastructure_pending_investment: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT(Number(e.target.value))
            }, 1000),
            set_appraisal_land_infrastructure_paving: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_paving
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_paving_execution_pct === 0) {
                        this.appraisal.land_infrastructure_paving_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_sewage: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_sewage
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_sewage_execution_pct === 0) {
                        this.appraisal.land_infrastructure_sewage_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_public_lighting: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_public_lighting
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_public_lighting_execution_pct === 0) {
                        this.appraisal.land_infrastructure_public_lighting_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_water_supply: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_water_supply
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_water_supply_execution_pct === 0) {
                        this.appraisal.land_infrastructure_water_supply_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_electricity_supply: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_electricity_supply
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_electricity_supply_execution_pct === 0) {
                        this.appraisal.land_infrastructure_electricity_supply_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_piped_gas: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_piped_gas
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_piped_gas_execution_pct === 0) {
                        this.appraisal.land_infrastructure_piped_gas_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_telephone_service: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_telephone_service
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_telephone_service_execution_pct === 0) {
                        this.appraisal.land_infrastructure_telephone_service_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_infrastructure_gardened_areas: _.debounce(function (e) {
                let existing = this.appraisal.land_infrastructure_gardened_areas
                if (!existing) {
                    this.SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT(0)
                } else {
                    if (this.appraisal.land_infrastructure_gardened_areas_execution_pct === 0) {
                        this.appraisal.land_infrastructure_gardened_areas_execution_pct = 100
                    }
                }
                this.calc_land_infrastructure_total_execution_pct()
            }, 0),
            set_appraisal_land_is_plot_according_to_law: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW(e.target.value)
            }, 0),
            set_appraisal_land_area_notes: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_AREA_NOTES(e.target.value)
            }, 1000),
            set_appraisal_land_infrastructure_notes: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES(e.target.value)
            }, 1000),
            set_appraisal_land_infrastructure_conservation_status: _.debounce(function (e) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS(e)
            }, 1000),
            set_appraisal_plot_occupation: _.debounce(function (e) {
                // this.SET_APPRAISAL_PLOT_OCCUPATION(e.target.value)
                this.SET_APPRAISAL_PLOT_OCCUPATION(e)
            }, 1000),
            set_appraisal_plot_free_area_usage: _.debounce(function (e) {
                // this.SET_APPRAISAL_PLOT_FREE_AREA_USAGE(e.target.value)
                this.SET_APPRAISAL_PLOT_FREE_AREA_USAGE(e)
            }, 1000),
            set_appraisal_floors_number_underground: _.debounce(function (e) {
                this.SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND(Number(e.target.value))
            }, 1000),
            set_appraisal_floors_number_overground: _.debounce(function (e) {
                this.SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND(Number(e.target.value))
            }, 1000),
            set_appraisal_parking_spots_included_number: _.debounce(function(e){
                this.SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER(Number(e.target.value))
            }, 1000),
            set_appraisal_entrance_hall: _.debounce(function (e) {

            }, 0),
            set_appraisal_doorman_space: _.debounce(function (e) {

            }, 0),
            set_appraisal_staircase: _.debounce(function (e) {

            }, 0),
            set_appraisal_swimming_pool: _.debounce(function (e) {

            }, 0),
            set_appraisal_gardened_areas: _.debounce(function (e) {

            }, 0),
            set_appraisal_sports_facilities: _.debounce(function (e) {

            }, 0),
            set_appraisal_community_room: _.debounce(function (e) {

            }, 0),
            set_appraisal_storage_room: _.debounce(function (e) {

            }, 0),
            set_appraisal_community_parking: _.debounce(function (e) {

            }, 0),
            set_appraisal_facilities_others: _.debounce(function (e) {
                this.SET_APPRAISAL_FACILITIES_OTHERS(e.target.value)
            }, 1000),
            set_appraisal_floors_usage_underground: _.debounce(function (e) {
                this.SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND(e)
            }, 1000),
            set_appraisal_floors_usage_overground: _.debounce(function (e) {
                this.SET_APPRAISAL_FLOORS_USAGE_OVERGROUND(e)
            }, 1000),
            set_appraisal_groundfloor_usage: _.debounce(function (e) {
                this.SET_APPRAISAL_GROUNDFLOOR_USAGE(e)
            }, 1000),
            set_appraisal_communications_airport: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMUNICATIONS_AIRPORT(e.target.value)
            }, 1000),
            set_appraisal_communications_harbour: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMUNICATIONS_HARBOUR(e.target.value)
            }, 1000),
            set_appraisal_communications_train: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMUNICATIONS_TRAIN(e.target.value)
            }, 1000),
            set_appraisal_public_transport_urban_underground: _.debounce(function (e) {
                this.SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND(e.target.value)
            }, 1000),
            set_appraisal_public_transport_interurban: _.debounce(function (e) {
                this.SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN(e.target.value)
            }, 1000),
            set_appraisal_surrounding_facilities_notes: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES(e.target.value)
            }, 1000),
            set_appraisal_surrounding_territorial_feature: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE(e)
            }, 1000),
            set_appraisal_surrounding_income_level: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_INCOME_LEVEL(e)
            }, 1000),
            set_appraisal_surrounding_homogeneity_feature: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE(e)
            }, 1000),
            set_appraisal_surrounding_main_uses: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_MAIN_USES(e)
            }, 1000),
            set_appraisal_surrounding_density: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_DENSITY(e)
            }, 1000),
            set_appraisal_surrounding_accessibility: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_ACCESSIBILITY(e)
            }, 1000),
            set_appraisal_surrounding_consolidation_degree: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE(e)
            }, 1000),
            set_appraisal_surrounding_occupation_degree: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE(e)
            }, 1000),
            set_appraisal_surrounding_evolution_speed: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED(e)
            }, 1000),
            set_appraisal_surrounding_average_age: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_AVERAGE_AGE(e)
            }, 1000),
            set_appraisal_surrounding_conservation_status: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS(e)
            }, 1000),
            set_appraisal_surrounding_commercial_facilities: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES(e)
            }, 1000),
            set_appraisal_surrounding_educational_facilities: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES(e)
            }, 1000),
            set_appraisal_surrounding_public_parking: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING(e)
            }, 1000),
            set_appraisal_surrounding_medical_assistance: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE(e)
            }, 1000),
            set_appraisal_surrounding_leisure: _.debounce(function (e) {
                this.SET_APPRAISAL_SURROUNDING_LEISURE(e)
            }, 1000),
            set_appraisal_cadastral_usage: _.debounce(function (e) {
                this.SET_APPRAISAL_CADASTRAL_USAGE(e.target.value)
            }, 1000),
            set_appraisal_cadastral_floor: _.debounce(function (e) {
                this.SET_APPRAISAL_CADASTRAL_FLOOR(e.target.value)
            }, 1000),
            set_appraisal_cadastral_door: _.debounce(function (e) {
                this.SET_APPRAISAL_CADASTRAL_DOOR(e.target.value)
            }, 1000),
            set_appraisal_cadastral_block: _.debounce(function (e) {
                this.SET_APPRAISAL_CADASTRAL_BLOCK(e.target.value)
            }, 1000),
            set_appraisal_cadastral_staircase: _.debounce(function (e) {
                this.SET_APPRAISAL_CADASTRAL_STAIRCASE(e.target.value)
            }, 1000),
            set_appraisal_registry_name: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_NAME(e.target.value)
            }, 1000),
            set_appraisal_registry_section: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_SECTION(e.target.value)
            }, 1000),
            set_appraisal_registry_volume: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_VOLUME(e.target.value)
            }, 1000),
            set_appraisal_registry_book: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_BOOK(e.target.value)
            }, 1000),
            set_appraisal_registry_page: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_PAGE(e.target.value)
            }, 1000),
            set_appraisal_registry_real_estate_number: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER(e.target.value)
            }, 1000),
            set_appraisal_registry_idufir: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_IDUFIR(e.target.value)
            }, 1000),
            set_appraisal_registry_owner: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_OWNER(e.target.value)
            }, 1000),
            set_appraisal_registry_property_coef: _.debounce(function (e) {
                this.SET_APPRAISAL_REGISTRY_PROPERTY_COEF(Number(e.target.value))
            }, 1000),
            set_appraisal_net_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NET_CADASTRAL_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_net_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NET_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_net_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NET_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_net_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NET_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_enclosed_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_enclosed_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ENCLOSED_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_enclosed_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ENCLOSED_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_enclosed_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ENCLOSED_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_covered_terraces_total_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_covered_terraces_total_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_covered_terraces_total_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_covered_terraces_total_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_uncovered_terraces_total_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA(Number(e.target.value))
            }, 1000),
            set_appraisal_uncovered_terraces_total_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA(Number(e.target.value))
            }, 1000),
            set_appraisal_uncovered_terraces_total_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA(Number(e.target.value))
            }, 1000),
            set_appraisal_uncovered_terraces_total_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA(Number(e.target.value))
            }, 1000),
            set_appraisal_built_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_CADASTRAL_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_common_elements_cadastral_area: _.debounce(function (e) {
                let ce_area = Number(e.target.value)
                let b_area = this.appraisal.built_cadastral_area
                let b_plus_ce_area = ce_area + b_area
                this.SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA(ce_area)
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA(b_plus_ce_area)
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_common_elements_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_common_elements_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_common_elements_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_plus_common_elements_cadastral_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_plus_common_elements_registry_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_plus_common_elements_checked_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_built_plus_common_elements_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA(Number(e.target.value))
                this.calc_adopted_areas()
            }, 1000),
            set_appraisal_realestate_rooms_to_exterior_number: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER(Number(e.target.value))
            }, 1000),
            set_appraisal_realestate_day_night_zoning: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_door_opener: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_fitted_cupboards: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_gas: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_sanitary_fittings: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_taps: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_hot_water: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_heating: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_air_conditioning: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_tv: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_telephone: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_fire_prevention: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_systems_intrusion_prevention: _.debounce(function (e) {

            }, 0),
            set_appraisal_realestate_foundation: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_FOUNDATION(e)
            }, 0),
            set_appraisal_realestate_structure: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_STRUCTURE(e)
            }, 0),
            set_appraisal_realestate_roof: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_ROOF(e)
            }, 0),
            set_appraisal_realestate_external_enclosures: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES(e)
            }, 0),
            set_appraisal_realestate_insulation: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INSULATION(e)
            }, 0),
            set_appraisal_realestate_external_carpentry: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY(e)
            }, 0),
            set_appraisal_realestate_glazing: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_GLAZING(e)
            }, 0),
            set_appraisal_realestate_interior_paving_living: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING(e)

                if (!this.appraisal.realestate_interior_paving_corridor) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR(e)
                }
                if (!this.appraisal.realestate_interior_paving_bedroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM(e)
                }
                if (!this.appraisal.realestate_interior_paving_kitchen) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN(e)
                }
                if (!this.appraisal.realestate_interior_paving_bathroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM(e)
                }

            }, 0),
            set_appraisal_realestate_interior_paving_corridor: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR(e)
            }, 0),
            set_appraisal_realestate_interior_paving_bedroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM(e)
            }, 0),
            set_appraisal_realestate_interior_paving_kitchen: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN(e)
            }, 0),
            set_appraisal_realestate_interior_paving_bathroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM(e)
            }, 0),
            set_appraisal_realestate_interior_paving_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY(e)
            }, 0),
            set_appraisal_realestate_interior_walls_living: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING(e)

                if (!this.appraisal.realestate_interior_walls_corridor) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR(e)
                }
                if (!this.appraisal.realestate_interior_walls_bedroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM(e)
                }
                if (!this.appraisal.realestate_interior_walls_kitchen) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN(e)
                }
                if (!this.appraisal.realestate_interior_walls_bathroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM(e)
                }

            }, 0),
            set_appraisal_realestate_interior_walls_corridor: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR(e)
            }, 0),
            set_appraisal_realestate_interior_walls_bedroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM(e)
            }, 0),
            set_appraisal_realestate_interior_walls_kitchen: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN(e)
            }, 0),
            set_appraisal_realestate_interior_walls_bathroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM(e)
            }, 0),
            set_appraisal_realestate_interior_walls_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY(e)
            }, 0),
            set_appraisal_realestate_interior_ceilings_living: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING(e)

                if (!this.appraisal.realestate_interior_ceilings_corridor) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR(e)
                }
                if (!this.appraisal.realestate_interior_ceilings_bedroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM(e)
                }
                if (!this.appraisal.realestate_interior_ceilings_kitchen) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN(e)
                }
                if (!this.appraisal.realestate_interior_ceilings_bathroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM(e)
                }

            }, 0),
            set_appraisal_realestate_interior_ceilings_corridor: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR(e)
            }, 0),
            set_appraisal_realestate_interior_ceilings_bedroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM(e)
            }, 0),
            set_appraisal_realestate_interior_ceilings_kitchen: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN(e)
            }, 0),
            set_appraisal_realestate_interior_ceilings_bathroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM(e)
            }, 0),
            set_appraisal_realestate_interior_ceilings_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY(e)
            }, 0),
            set_appraisal_realestate_interior_carpentry_living: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING(e)

                if (!this.appraisal.realestate_interior_carpentry_corridor) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR(e)
                }
                if (!this.appraisal.realestate_interior_carpentry_bedroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM(e)
                }
                if (!this.appraisal.realestate_interior_carpentry_kitchen) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN(e)
                }
                if (!this.appraisal.realestate_interior_carpentry_bathroom) {
                    this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM(e)
                }

            }, 0),
            set_appraisal_realestate_interior_carpentry_corridor: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR(e)
            }, 0),
            set_appraisal_realestate_interior_carpentry_bedroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM(e)
            }, 0),
            set_appraisal_realestate_interior_carpentry_kitchen: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN(e)
            }, 0),
            set_appraisal_realestate_interior_carpentry_bathroom: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM(e)
            }, 0),
            set_appraisal_realestate_interior_carpentry_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY(e)
            }, 0),
            set_appraisal_realestate_main_orientation: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION(e)
            }, 0),
            set_appraisal_realestate_main_views: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_MAIN_VIEWS(e)
            }, 0),
            set_appraisal_realestate_windows_size_and_quantity: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY(e)
            }, 0),
            set_appraisal_realestate_noise_facade: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_NOISE_FACADE(e)
            }, 0),
            set_appraisal_realestate_systems_sanitary_fittings_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY(e)
            }, 0),
            set_appraisal_realestate_systems_taps_quality: _.debounce(function (e) {
                this.SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY(e)
            }, 0),
            set_appraisal_adjusted_bec_price: _.debounce(function (e) {
                this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(Number(e.target.value))
            }, 1000),
            set_appraisal_expenses_and_industrial_benefit_bec_pct: _.debounce(function (e) {

                console.log('hola! ')
                let bec_price = this.appraisal.bec_number.total
                let coef = this.appraisal.bec_adjustment_coef
                let adjusted_bec_price = this.roundToTwo(bec_price * coef)
                let desp_pct = Number(e.target.value)
                let mec = this.roundToTwo(adjusted_bec_price / ( 1 + (desp_pct / 100)))
                let mec_coef = this.appraisal.mec_adjustment_coef
                let adopted_mec = this.roundToTwo(mec * mec_coef)

				this.SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT(desp_pct)

                this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price)
                this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec)
                this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec)

                this.SET_APPRAISAL_BEC_ADJUSTMENT_COEF(coef)
                    .then(() => {
                        this.calc_construction_cost()
                        this.recalcAppraisal()
                    })
            }, 1000),
            set_appraisal_adopted_material_execution_cost: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(Number(e.target.value))
            }, 1000),
            set_appraisal_construction_cost_notes: _.debounce(function (e) {
                this.SET_APPRAISAL_CONSTRUCTION_COST_NOTES(e.target.value)
            }, 1000),
            set_appraisal_cadastral_construction_year: _.debounce(function (e) {
                let cadastral_construction_year = Number(e.target.value)
                this.SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR(cadastral_construction_year)

                let construction_year = null
                let last_renovation_year = null

                if (!this.appraisal.construction_year) {
                    construction_year = cadastral_construction_year

                } else {
                    construction_year = this.appraisal.construction_year
                }

                this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year)

                if (this.appraisal.last_renovation_year) {
                    last_renovation_year = this.appraisal.last_renovation_year

                    if (last_renovation_year < construction_year) {
                        last_renovation_year = construction_year
                    }
                } else {
                    last_renovation_year = construction_year
                }

                this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))
                this.SET_APPRAISAL_ADOPTED_AGE(average).then(() => {
                    this.recalcMarketAndAppraisals()
                })

            }, 1000),
            set_appraisal_construction_year: _.debounce(function (e) {
                let construction_year = Number(e.target.value)
                this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year)

                let last_renovation_year = construction_year

                if (this.appraisal.last_renovation_year) {
                    last_renovation_year = this.appraisal.last_renovation_year

                    if (last_renovation_year < construction_year) {
                        last_renovation_year = construction_year
                    }
                }

                this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))
                this.SET_APPRAISAL_ADOPTED_AGE(average).then(() => {
                    this.recalcMarketAndAppraisals()
                })

            }, 1000),
            set_appraisal_last_renovation_year: _.debounce(function (e) {
                let last_renovation_year = Number(e.target.value)
                this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year)

                let construction_year = null
                let cadastral_construction_year = this.appraisal.cadastral_construction_year

                if (this.appraisal.construction_year) {
                    construction_year = this.appraisal.construction_year
                } else {
                    construction_year = cadastral_construction_year
                }

                this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))
                this.SET_APPRAISAL_ADOPTED_AGE(average).then(() => {
                    this.recalcMarketAndAppraisals()
                })
            }, 1000),
            set_appraisal_nucleus_population: _.debounce(function (e) {
                this.SET_APPRAISAL_NUCLEUS_POPULATION(Number(e.target.value))
            }, 1000),
            set_appraisal_nucleus_population_density: _.debounce(function (e) {
                this.SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY(Number(e.target.value))
            }, 1000),
            set_appraisal_nucleus_population_growth: _.debounce(function (e) {
                this.SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH(Number(e.target.value))
            }, 1000),
            set_appraisal_occupation_agriculture_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_occupation_industry_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_occupation_construction_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_occupation_services_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_SERVICES_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_occupation_total_pct: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_TOTAL_PCT(Number(e.target.value))
            }, 1000),
            set_appraisal_nucleus_type: _.debounce(function (e) {
                this.SET_APPRAISAL_NUCLEUS_TYPE(e.target.value)
            }, 1000),
            set_appraisal_occupation_description: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPATION_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisal_nucleus_area: _.debounce(function (e) {
                this.SET_APPRAISAL_NUCLEUS_AREA(Number(e.target.value))
            }, 1000),
            set_appraisal_checks_other: _.debounce(function (e) {
                this.SET_APPRAISAL_CHECKS_OTHER(e.target.value)
            }, 1000),
            set_appraisal_docs_other: _.debounce(function (e) {
                this.SET_APPRAISAL_DOCS_OTHER(e.target.value)
            }, 1000),
            set_appraisal_checks_cadastral_data: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_conservation_status: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_expropriation_procedure: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_expropriation_plan: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_expropriation_admin_ruling: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_expropriation_file: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_interior_visit: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_occupancy: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_registry_data: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_servitudes: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_subsidy_status: _.debounce(function (e) {

            }, 0),
            set_appraisal_checks_urban_planning: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_approved_project: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_cadastral_data: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_construction_license: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_construction_last_certificate: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_construction_contract: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_occupancy_status: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_photographic_report: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_property_sketch: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_property_titles: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_situation_plan: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_subsidy_status: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_tenyear_insurance: _.debounce(function (e) {

            }, 0),
            set_appraisal_docs_urban_plan: _.debounce(function (e) {

            }, 0),
            set_appraisal_property_title: _.debounce(function (e) {
                this.SET_APPRAISAL_PROPERTY_TITLE(e.target.value)
            }, 1000),
            set_appraisal_usage_assigned: _.debounce(function (e) {
                this.SET_APPRAISAL_USAGE_ASSIGNED(e.target.value)
            }, 1000),
            set_appraisal_inspection_realized: _.debounce(function (e) {
                this.SET_APPRAISAL_INSPECTION_REALIZED(e.target.value)
            }, 1000),
            set_appraisal_economical_activity: _.debounce(function (e) {
                this.SET_APPRAISAL_ECONOMICAL_ACTIVITY(e.target.value)
            }, 1000),
            set_appraisal_occupancy_status: _.debounce(function (e) {
                this.SET_APPRAISAL_OCCUPANCY_STATUS(e)
            }, 1000),
            set_appraisal_marketstudy_id: _.debounce(function (e) {
                let marketstudy_id = e.id
                let market_value = this.check_undefined_get_number(e.market_value)
                let market_unit_value = this.check_undefined_get_number(e.market_unit_value)
                this.SET_APPRAISAL_MARKETSTUDY_ID(marketstudy_id).then(() => {
                    console.log('selected marketstudy: ')
                    console.log(this.realestate_marketstudies[marketstudy_id])
                    this.appraisal = this.calcAppraisal(this.appraisal, marketstudy_id, market_value, market_unit_value)
                })
            }, 1000),
            set_appraisal_cover_photo: _.debounce(function (e, f) {
                let boolean = e
                let photo_id = f['id']
                let photo_url = f['url']

                let appraisal_photographs = this.appraisal_photographs

                _.forEach(appraisal_photographs, (value, key) => {
                    appraisal_photographs[key].is_cover_photo = false
                })

                if (boolean === true) {
                    appraisal_photographs[photo_id].is_cover_photo = true
                } else {
                    photo_url = null
                }

                this.SET_APPRAISALREPORT_COVER_PHOTO_URL(photo_url)

                // TODO: hi h a la possibilitat de que al guardar aquí actualitzem un appraisalreport incorrecte?
                this.UPDATE_APPRAISALREPORT({
                    object: this.appraisalreport,
                    path: this.appraisalreport.path,
                    parent_path: this.appraisalreport.parent_path,
                    key: this.appraisalreport.id
                }).then((res) => {

                })

                // console.log('appraisal_photographs: ')
                // console.log(appraisal_photographs)
                this.appraisal_photographs = appraisal_photographs
                this.$forceUpdate()

                this.SET_PHOTOGRAPH({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + photo_id + '/'}).then((res) => {
                    if (boolean === true) {
                        this.SET_PHOTOGRAPH_IS_COVER_PHOTO(true)
                    } else {
                        this.SET_PHOTOGRAPH_IS_COVER_PHOTO(false)
                    }

                    this.UPDATE_PHOTOGRAPH({
                        object: this.photograph,
                        path: this.photograph.path,
                        parent_path: this.photograph.parent_path,
                        key: this.photograph.id
                    }).then((res) => {

                    })

                })

            }, 0),
            set_appraisal_usage_type: _.debounce(function(e){
                this.SET_APPRAISAL_USAGE_TYPE(e)
            }, 500),
            recalcAppraisal: function () {
                this.appraisal = this.calcAppraisal(this.appraisal, this.appraisal.marketstudy_id, this.appraisal.market_value, this.appraisal.market_unit_value)
            },
            set_base_fees: _.debounce(function (adjusted_market_value) {


                let base_fees = 0
                let bp_coef = 1
                if(this.realestate.invoice_base_price_coef){
                    bp_coef = this.realestate.invoice_base_price_coef
                }
                let invoice_excess_pct = 0
                let base_price = 0

                let is_eco = this.realestate.invoice_appraisal_type_is_eco

                let roundToTwoTemp = function(num) {
                    return +(Math.round(num + 'e+2') + 'e-2')
                };

                if(this.realestate.property_type.name_db === 'residential' || this.realestate.property_type.name_db === 'parking' || this.realestate.property_type.name_db === 'storage'){
                    _.forEach(this.valuation_prices.group_A, function(range, key) {
                        // console.log('adjusted_market_value: ')
                        // console.log(adjusted_market_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if(adjusted_market_value >= range.floor && adjusted_market_value < range.ceil ){

                            if(is_eco){

                                base_fees = range.mortgage_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)


                                invoice_excess_pct = range.increment_pct_mortgage_valuation
                                base_price = roundToTwoTemp( (base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef )

                            }else{
                                base_fees = range.standard_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)

                                invoice_excess_pct = range.increment_pct_standard_valuation
                                base_price = roundToTwoTemp((base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef)
                            }


                        }
                    })
                }else if(this.realestate.property_type.name_db === 'retail_and_industrial' || this.realestate.property_type.name_db === 'office'){

                    _.forEach(this.valuation_prices.group_B, function(range, key) {

                        // console.log('adjusted_market_value: ')
                        // console.log(adjusted_market_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if(adjusted_market_value >= range.floor && adjusted_market_value < range.ceil ){

                            if(is_eco){

                                base_fees = range.mortgage_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)


                                invoice_excess_pct = range.increment_pct_mortgage_valuation
                                base_price = roundToTwoTemp( (base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef )

                            }else{
                                base_fees = range.standard_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)

                                invoice_excess_pct = range.increment_pct_standard_valuation
                                base_price = roundToTwoTemp( (base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef )
                            }
                        }

                    })

                }
                else{
                    _.forEach(this.valuation_prices.group_C, function(range, key) {
                        // console.log('adjusted_market_value: ')
                        // console.log(adjusted_market_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if(adjusted_market_value >= range.floor && adjusted_market_value < range.ceil ){


                            base_fees = range.standard_valuation_fee
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            invoice_excess_pct = range.increment_pct_standard_valuation
                            base_price = roundToTwoTemp( (base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef )


                        }
                    })

                }
                /*
				else if(this.realestate.property_type.name_db === 'entire_buildings' || this.realestate.property_type.name_db === 'land'){

				}
				*/

                this.SET_REALESTATE_INVOICE_BASE_FEES(base_fees)
                this.SET_REALESTATE_INVOICE_EXCESS_PCT(invoice_excess_pct)
                this.SET_REALESTATE_INVOICE_BASE_PRICE(base_price)
                this.SET_REALESTATE_INVOICE_BASE_PRICE_COEF(bp_coef)


                this.SET_REALESTATE_INVOICE_BASE_FEES(base_fees)

                let total_travel_fees = this.realestate.total_travel_fees
                this.calc_invoice_base_price(base_fees, invoice_excess_pct, bp_coef, total_travel_fees)


            }, 0),
            calc_invoice_base_price: _.debounce(function (base_fees, invoice_excess_pct, bp_coef, total_travel_fees) {
                let base_price = this.roundToTwo( (base_fees + (base_fees * (invoice_excess_pct/100))) * bp_coef )
                this.SET_REALESTATE_INVOICE_BASE_PRICE(base_price)

                let invoice_price_incl_travel_expenses = base_price + total_travel_fees
                this.SET_REALESTATE_INVOICE_PRICE_INCL_TRAVEL_EXPENSES(invoice_price_incl_travel_expenses)
            }, 0),
            set_realestate_invoice_base_fees: _.debounce(function(e){
                this.SET_REALESTATE_INVOICE_BASE_FEES(Number(e.target.value))
            }, 1000),
            set_realestate_invoice_excess_pct: _.debounce(function(e){
                this.SET_REALESTATE_INVOICE_EXCESS_PCT(Number(e.target.value))
            }, 1000),
            set_realestate_invoice_base_price: _.debounce(function(e){
                this.SET_REALESTATE_INVOICE_BASE_PRICE(Number(e.target.value))
            }, 1000),
            set_realestate_invoice_base_price_coef: _.debounce(function(e){
                this.SET_REALESTATE_INVOICE_BASE_PRICE_COEF(Number(e.target.value))
            }, 1000),
            set_realestate_invoice_appraisal_type_is_eco: _.debounce(function(e){

            }, 0),
            recalcMarketAndAppraisals: function () {
                // TODO: recalcular mercat (si és que està vinculat a un) i amb el nou valor de mercat actualitzar i recalcular les taxacions que estiguin lligades a aquell estudi
                // this.appraisal = this.calcAppraisal(this.appraisal, this.appraisal.market_value, this.appraisal.market_unit_value)
            },
            onRequestIdescatInfoByCodeIne: function () {
                // TODO: missatge d'error quan el MUC no funciona
                // TODO: link directe a la pàgina del MUC
                // TODO: afegir BCN PIC i Àrea Metropolitana

                console.log('requesting MUC info...')
                this.idescat_info_loading = true
                this.REQUEST_IDESCAT_INFO_BY_CODE_INE({
                    code_ine: this.realestate.municipality.ine_province_code + this.realestate.municipality.ine_municipality_code + this.realestate.municipality.ine_control_digit,
                }).then((res) => {
                    //
                    this.idescat_info_loading = false
                })
            },
            onRequestMucInfo: function () {
                console.log('requesting MUC info...')
                this.muc_info_loading = true
                this.REQUEST_MUC_INFO({
                    x: this.realestate.epsg25831_x,
                    y: this.realestate.epsg25831_y
                }).then((res) => {
                    //
                    this.muc_info_loading = false
                })
            },
            onRequestMucMap: function () {
                console.log('requesting MUC maps...')
                this.muc_map_01_loading = true
                this.muc_map_02_loading = true
                this.muc_map_03_loading = true

                if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                if (!this.appraisal.map_urban_muc_land_colors_zoom) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (!this.appraisal.map_urban_muc_council_qual_zoom) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (!this.appraisal.map_urban_icc_topo_zoom) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                this.REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX({
                    x: this.realestate.epsg25831_x + this.appraisal.map_urban_muc_land_colors_offset_x,
                    y: this.realestate.epsg25831_y + this.appraisal.map_urban_muc_land_colors_offset_y,
                    width: this.urban_map_width,
                    height: this.urban_map_height,
                    zoom: this.appraisal.map_urban_muc_land_colors_zoom,
                    realestate_id: this.realestate.id,
                    appraisal_id: this.appraisal.id
                }).then((res) => {
                    //
                    console.log('res in AppraisalEditor.vue: ')
                    console.log(res)
                    this.appraisal.map_urban_muc_land_colors = res
                    this.muc_map_01_loading = false
                })
                this.REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX({
                    x: this.realestate.epsg25831_x + this.appraisal.map_urban_muc_council_qual_offset_x,
                    y: this.realestate.epsg25831_y + this.appraisal.map_urban_muc_council_qual_offset_y,
                    width: this.urban_map_width,
                    height: this.urban_map_height,
                    zoom: this.appraisal.map_urban_muc_council_qual_zoom,
                    realestate_id: this.realestate.id,
                    appraisal_id: this.appraisal.id
                }).then((res) => {
                    //
                    console.log('res in AppraisalEditor.vue: ')
                    console.log(res)
                    this.appraisal.map_urban_muc_council_qual = res
                    this.muc_map_02_loading = false
                })
                this.REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX({
                    x: this.realestate.epsg25831_x + this.appraisal.map_urban_icc_topo_offset_x,
                    y: this.realestate.epsg25831_y + this.appraisal.map_urban_icc_topo_offset_y,
                    width: this.urban_map_width,
                    height: this.urban_map_height,
                    zoom: this.appraisal.map_urban_icc_topo_zoom,
                    realestate_id: this.realestate.id,
                    appraisal_id: this.appraisal.id
                }).then((res) => {
                    //
                    console.log('res in AppraisalEditor.vue: ')
                    console.log(res)
                    this.appraisal.map_urban_icc_topo = res
                    this.muc_map_03_loading = false
                })
            },
            onSaveCurrentAppraisal: function (data) {
                this.UPDATE_APPRAISAL_ROOMS({
                    appraisal_id: this.appraisal.id,
                    object: this.appraisal_rooms
                })
                this.UPDATE_APPRAISAL_COVERED_OUTDOORS({
                    appraisal_id: this.appraisal.id,
                    object: this.appraisal_covered_outdoors
                })
                this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({
                    appraisal_id: this.appraisal.id,
                    object: this.appraisal_uncovered_outdoors
                })
                this.UPDATE_APPRAISAL({
                    key: this.appraisal.id,
                    object: this.appraisal,
                    parent_path: 'realestates/' + this.realestate.id + '/' + 'appraisals' + '/',
                    path: this.appraisal.path + this.appraisal.id,
                    realestate_id: this.realestate.id
                }).then((res) => {
                    if (data.go_up) {
                        this.onGoUp()
                    } else {
                        this.setCurrentTab(this.currentTabTitle)
                        window.scroll(0, 0)
                    }
                })

                this.UPDATE_REALESTATE({
                    key: this.realestate.id,
                    object: this.realestate,
                    // parent_path: 'appraisalreports/' + this.appraisalreport.id + '/' + 'realestates' + '/',
                    path: this.realestate.path + this.realestate.id,
                    file_id: this.appraisalfile.id,
                    report_id: this.appraisalreport.id
                }).then((res) => {

                })
            },
            setCurrentTabTitle: function (tabTitle) {
                console.log('hey, current Tab Title: ' + tabTitle)
                this.currentTabTitle = tabTitle
            },
            setCurrentTab: function (tabTitle) {
                console.log('hey, current Tab: ' + tabTitle)
                this.tabName = tabTitle
            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah up')
                this.$router.push({name: 'realestate-editor', query: {id: this.realestate.id}})
            },
            onCancelAll: function () {
                const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                if (result) {
                    router.go(-1)
                } else {
                    return false

                }

            },
            onCreateNewRoom: function () {
                this.master_loading = true

                this.RESET_ROOM().then((res) => {
                    this.CREATE_NEW_ROOM({
                        path: 'appraisal_rooms' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'rooms' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        // this.$router.push({name: 'room-editor', query: {id: this.appraisal.id}})
                        this.FETCH_APPRAISAL_ROOMS({path: 'appraisal_rooms' + '/' + this.appraisal.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })
                })

            },
            onCreateNewConstraint: function () {

                // this.master_loading = true

                this.RESET_CONSTRAINT().then((res) => {
                    this.CREATE_NEW_CONSTRAINT({
                        path: 'appraisal_constraints' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'constraints' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        this.$router.push({name: 'constraint-editor', query: {id: this.appraisal.id}})

                    })
                })

            },
            onCreateNewWarning: function () {

                // this.master_loading = true

                this.RESET_WARNING().then((res) => {
                    this.CREATE_NEW_WARNING({
                        path: 'appraisal_warnings' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'warnings' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        this.$router.push({name: 'warning-editor', query: {id: this.appraisal.id}})

                    })
                })

            },
            onCreateNewNote: function () {

                // this.master_loading = true

                this.RESET_NOTE().then((res) => {
                    this.CREATE_NEW_NOTE({
                        path: 'appraisal_notes' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'notes' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        this.$router.push({name: 'note-editor', query: {id: this.appraisal.id}})

                    })
                })

            },
            onCreateNewCoveredOutdoor: function () {
                this.master_loading = true
                this.RESET_COVERED_OUTDOOR().then((res) => {
                    this.CREATE_NEW_COVERED_OUTDOOR({
                        path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'covered_outdoors' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        // this.$router.push({name: 'covered_outdoor-editor', query: {id: this.appraisal.id}})
                        this.FETCH_APPRAISAL_COVERED_OUTDOORS({path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })
                })

            },
            onCreateNewUncoveredOutdoor: function () {
                this.master_loading = true
                this.RESET_UNCOVERED_OUTDOOR().then((res) => {
                    this.CREATE_NEW_UNCOVERED_OUTDOOR({
                        path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/',
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'uncovered_outdoors' + '/',
                        appraisal_id: this.appraisal.id,
                    }).then((res) => {
                        // this.$router.push({name: 'uncovered_outdoor-editor', query: {id: this.appraisal.id}})
                        this.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })
                })

            },
            onDecreaseZoomMapUrbanMuc: function () {
                // console.log('decreasing Maps Zoom...')

                if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                let map_urban_muc_land_colors_zoom = (Number(this.appraisal.map_urban_muc_land_colors_zoom) + this.urban_map_zoom_factor)
                this.appraisal.map_urban_muc_land_colors_zoom = map_urban_muc_land_colors_zoom
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM(map_urban_muc_land_colors_zoom)

                let map_urban_muc_council_qual_zoom = (Number(this.appraisal.map_urban_muc_council_qual_zoom) + this.urban_map_zoom_factor)
                this.appraisal.map_urban_muc_council_qual_zoom = map_urban_muc_council_qual_zoom
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM(map_urban_muc_council_qual_zoom)

                let map_urban_icc_topo_zoom = (Number(this.appraisal.map_urban_icc_topo_zoom) + this.urban_map_zoom_factor)
                this.appraisal.map_urban_icc_topo_zoom = map_urban_icc_topo_zoom
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM(map_urban_icc_topo_zoom)

                console.log('map_urban_muc_land_colors_zoom: ')
                console.log(map_urban_muc_land_colors_zoom)

                console.log('map_urban_muc_council_qual_zoom: ')
                console.log(map_urban_muc_council_qual_zoom)

                console.log('map_urban_icc_topo_zoom: ')
                console.log(map_urban_icc_topo_zoom)

                this.onRequestMucMap()
            },
            onIncreaseZoomMapUrbanMuc: function () {
                // console.log('increasing Maps Zoom...')

                if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                    this.appraisal.map_urban_muc_land_colors_zoom = 1
                }

                if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                    this.appraisal.map_urban_muc_council_qual_zoom = 1
                }

                if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                    this.appraisal.map_urban_icc_topo_zoom = 1
                }

                let map_urban_muc_land_colors_zoom = (Number(this.appraisal.map_urban_muc_land_colors_zoom) - this.urban_map_zoom_factor)
                this.appraisal.map_urban_muc_land_colors_zoom = map_urban_muc_land_colors_zoom
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM(map_urban_muc_land_colors_zoom)

                let map_urban_muc_council_qual_zoom = (Number(this.appraisal.map_urban_muc_council_qual_zoom) - this.urban_map_zoom_factor)
                this.appraisal.map_urban_muc_council_qual_zoom = map_urban_muc_council_qual_zoom
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM(map_urban_muc_council_qual_zoom)

                let map_urban_icc_topo_zoom = (Number(this.appraisal.map_urban_icc_topo_zoom) - this.urban_map_zoom_factor)
                this.appraisal.map_urban_icc_topo_zoom = map_urban_icc_topo_zoom
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM(map_urban_icc_topo_zoom)

                console.log('map_urban_muc_land_colors_zoom: ')
                console.log(map_urban_muc_land_colors_zoom)

                console.log('map_urban_muc_council_qual_zoom: ')
                console.log(map_urban_muc_council_qual_zoom)

                console.log('map_urban_icc_topo_zoom: ')
                console.log(map_urban_icc_topo_zoom)

                this.onRequestMucMap()
            },
            onGoUpMapUrbanMuc: function () {
                // console.log('going up Maps Zoom...')

                let map_urban_muc_land_colors_offset_y = this.appraisal.map_urban_muc_land_colors_offset_y + this.urban_map_offset
                this.appraisal.map_urban_muc_land_colors_offset_y = map_urban_muc_land_colors_offset_y
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X(map_urban_muc_land_colors_offset_y)

                let map_urban_muc_council_qual_offset_y = this.appraisal.map_urban_muc_council_qual_offset_y + this.urban_map_offset
                this.appraisal.map_urban_muc_council_qual_offset_y = map_urban_muc_council_qual_offset_y
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X(map_urban_muc_council_qual_offset_y)

                let map_urban_icc_topo_offset_y = this.appraisal.map_urban_icc_topo_offset_y + this.urban_map_offset
                this.appraisal.map_urban_icc_topo_offset_y = map_urban_icc_topo_offset_y
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X(map_urban_icc_topo_offset_y)

                this.onRequestMucMap()
            },
            onGoLeftMapUrbanMuc: function () {
                // console.log('going left Maps Zoom...')

                let map_urban_muc_land_colors_offset_x = this.appraisal.map_urban_muc_land_colors_offset_x - this.urban_map_offset
                this.appraisal.map_urban_muc_land_colors_offset_x = map_urban_muc_land_colors_offset_x
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y(map_urban_muc_land_colors_offset_x)

                let map_urban_muc_council_qual_offset_x = this.appraisal.map_urban_muc_council_qual_offset_x - this.urban_map_offset
                this.appraisal.map_urban_muc_council_qual_offset_x = map_urban_muc_council_qual_offset_x
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y(map_urban_muc_council_qual_offset_x)

                let map_urban_icc_topo_offset_x = this.appraisal.map_urban_icc_topo_offset_x - this.urban_map_offset
                this.appraisal.map_urban_icc_topo_offset_x = map_urban_icc_topo_offset_x
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y(map_urban_icc_topo_offset_x)

                this.onRequestMucMap()
            },
            onGoRightMapUrbanMuc: function () {
                // console.log('going right Maps Zoom...')

                let map_urban_muc_land_colors_offset_x = this.appraisal.map_urban_muc_land_colors_offset_x + this.urban_map_offset
                this.appraisal.map_urban_muc_land_colors_offset_x = map_urban_muc_land_colors_offset_x
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y(map_urban_muc_land_colors_offset_x)

                let map_urban_muc_council_qual_offset_x = this.appraisal.map_urban_muc_council_qual_offset_x + this.urban_map_offset
                this.appraisal.map_urban_muc_council_qual_offset_x = map_urban_muc_council_qual_offset_x
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y(map_urban_muc_council_qual_offset_x)

                let map_urban_icc_topo_offset_x = this.appraisal.map_urban_icc_topo_offset_x + this.urban_map_offset
                this.appraisal.map_urban_icc_topo_offset_x = map_urban_icc_topo_offset_x
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y(map_urban_icc_topo_offset_x)

                this.onRequestMucMap()
            },
            onGoDownMapUrbanMuc: function () {
                // console.log('going down Maps Zoom...')

                let map_urban_muc_land_colors_offset_y = this.appraisal.map_urban_muc_land_colors_offset_y - this.urban_map_offset
                this.appraisal.map_urban_muc_land_colors_offset_y = map_urban_muc_land_colors_offset_y
                this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X(map_urban_muc_land_colors_offset_y)

                let map_urban_muc_council_qual_offset_y = this.appraisal.map_urban_muc_council_qual_offset_y - this.urban_map_offset
                this.appraisal.map_urban_muc_council_qual_offset_y = map_urban_muc_council_qual_offset_y
                this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X(map_urban_muc_council_qual_offset_y)

                let map_urban_icc_topo_offset_y = this.appraisal.map_urban_icc_topo_offset_y - this.urban_map_offset
                this.appraisal.map_urban_icc_topo_offset_y = map_urban_icc_topo_offset_y
                this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X(map_urban_icc_topo_offset_y)

                this.onRequestMucMap()
            },

            duplicateRoom: function (entity) {
                /*
				 this.master_loading = true

				 const new_versionnumber = entity.version + 1

				 this.RESET_APPRAISALREPORT().then((res) => {
				 this.CREATE_NEW_APPRAISALREPORT({
				 path: 'appraisalreports' + '/',
				 parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
				 file_id: this.appraisalfile.id,
				 number: entity.number,
				 version: new_versionnumber
				 }).then((res) => {

				 console.log('duplicateAppraisalReport then res:')
				 console.log(res)

				 const new_object_id = res.key
				 const new_object_version = new_versionnumber

				 this.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {

				 console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
				 console.log(res)

				 let new_object = res
				 new_object.id = new_object_id
				 new_object.version = new_object_version


				 this.UPDATE_APPRAISALREPORT({
				 object: new_object,
				 path: 'appraisalreports/',
				 parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
				 key: new_object_id
				 }).then((res) => {

				 this.master_loading = true
				 this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
				 .then(() => {
				 this.master_loading = false
				 })

				 })

				 })


				 })
				 })
				 */

            },
            editRoom: function (entity) {

                /*

				 this.SET_APPRAISAL({path: 'appraisals' + '/' + entity.id + '/'}).then((res) => {
				 this.$router.push({name: 'appraisal-editor', query: {id: entity.id}})

				 })

				 */

            },
            deleteRoom: function (entity) {
                this.master_loading = true
                this.DELETE_ROOM({
                    path: 'appraisal_rooms' + '/' + this.appraisal.id + '/' + entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'rooms' + '/' + entity.id,
                    appraisal_id: this.appraisal.id,
                }).then((res) => {
                    // this.$router.push({name: 'room-editor', query: {id: this.appraisal.id}})
                    this.FETCH_APPRAISAL_ROOMS({path: 'appraisal_rooms' + '/' + this.appraisal.id + '/'}).then(() => {
                        this.calc_net_area(this.object_to_array(this.appraisal_rooms))
                        this.calc_adopted_areas()
                        this.master_loading = false
                    })
                })

            },
            deleteCoveredOutdoor: function (entity) {
                this.master_loading = true
                this.DELETE_COVERED_OUTDOOR({
                    path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/' + entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'covered_outdoors' + '/' + entity.id,
                    appraisal_id: this.appraisal.id,
                }).then((res) => {
                    this.FETCH_APPRAISAL_COVERED_OUTDOORS({path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                        this.calc_covered_outdoors_net_area(this.object_to_array(this.appraisal_covered_outdoors))
                        this.calc_adopted_areas()
                        this.master_loading = false
                    })
                })

            },
            deleteUncoveredOutdoor: function (entity) {
                this.master_loading = true
                this.DELETE_UNCOVERED_OUTDOOR({
                    path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/' + entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'uncovered_outdoors' + '/' + entity.id,
                    appraisal_id: this.appraisal.id,
                }).then((res) => {
                    this.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/'}).then(() => {
                        this.calc_uncovered_outdoors_net_area(this.object_to_array(this.appraisal.uncovered_outdoors))
                        this.calc_adopted_areas()
                        this.master_loading = false
                    })
                })

            },
            editConstraint: function (entity) {
                // console.log('edit constraint...')
                this.SET_CONSTRAINT({path: 'appraisal_constraints' + '/' + this.appraisal.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'constraint-editor', query: {id: entity.id}})

                })
            },
            deleteConstraint: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_CONSTRAINT({
                        path: 'appraisal_constraints' + '/' + this.appraisal.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'constraints' + '/'
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_CONSTRAINTS({path: 'appraisal_constraints' + '/' + this.appraisal.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })
                }
            },
            editWarning: function (entity) {
                // console.log('edit warning...')
                this.SET_WARNING({path: 'appraisal_warnings' + '/' + this.appraisal.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'warning-editor', query: {id: entity.id}})

                })
            },
            deleteWarning: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_WARNING({
                        path: 'appraisal_warnings' + '/' + this.appraisal.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'warnings' + '/'
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_WARNINGS({path: 'appraisal_warnings' + '/' + this.appraisal.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })
                }
            },
            editNote: function (entity) {
                // console.log('edit note...')
                this.SET_NOTE({path: 'appraisal_notes' + '/' + this.appraisal.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'note-editor', query: {id: entity.id}})

                })
            },
            deleteNote: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_NOTE({
                        path: 'appraisal_notes' + '/' + this.appraisal.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'notes' + '/'
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_NOTES({path: 'appraisal_notes' + '/' + this.appraisal.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })
                }
            },

            uploadPhotographFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/'
                }
                this.UPLOAD_PHOTOGRAPH_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_PHOTOGRAPHS({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs'}).then(() => {
                        this.$forceUpdate()
                        this.master_loading = false
                    })
                })

            },
            editPhotograph: function (entity) {

                this.SET_PHOTOGRAPH({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'photograph-editor', query: {id: entity.id}})

                })

            },
            deletePhotograph: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_PHOTOGRAPH({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_PHOTOGRAPHS({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadRegistryAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/'
                }
                this.UPLOAD_REGISTRYANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_REGISTRYANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editRegistryAnnex: function (entity) {

                this.SET_REGISTRYANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'registry-annex-editor', query: {id: entity.id}})

                })

            },
            deleteRegistryAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_REGISTRYANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_REGISTRYANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadCadasterAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/'
                }
                this.UPLOAD_CADASTERANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_CADASTERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editCadasterAnnex: function (entity) {

                this.SET_CADASTERANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'cadaster-annex-editor', query: {id: entity.id}})

                })

            },
            deleteCadasterAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_CADASTERANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_CADASTERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadUrbanAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/'
                }
                this.UPLOAD_URBANANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_URBANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editUrbanAnnex: function (entity) {

                this.SET_URBANANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'urban-annex-editor', query: {id: entity.id}})

                })

            },
            deleteUrbanAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_URBANANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_URBANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadPlanAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/'
                }
                this.UPLOAD_PLANANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_PLANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editPlanAnnex: function (entity) {

                this.SET_PLANANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'plan-annex-editor', query: {id: entity.id}})

                })

            },
            deletePlanAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_PLANANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_PLANANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadCessionAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/'
                }
                this.UPLOAD_CESSIONANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_CESSIONANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editCessionAnnex: function (entity) {

                this.SET_CESSIONANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'cession-annex-editor', query: {id: entity.id}})

                })

            },
            deleteCessionAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_CESSIONANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_CESSIONANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            },

            uploadOtherAnnexFiles: function (e) {
                // console.log(e)
                this.master_loading = true
                let data = {
                    files: e.target.files,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/'
                }
                this.UPLOAD_OTHERANNEX_FILES(data).then(() => {
                    this.FETCH_APPRAISAL_OTHERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes'}).then(() => {
                        this.master_loading = false
                    })
                })

            },
            editOtherAnnex: function (entity) {

                this.SET_OTHERANNEX({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'other-annex-editor', query: {id: entity.id}})

                })

            },
            deleteOtherAnnex: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.DELETE_OTHERANNEX({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/' + entity.id + '/',
                        filename: entity.filename,
                        key: entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISAL_OTHERANNEXES({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes'}).then(() => {
                            this.master_loading = false
                        })
                    })
                }

            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit appraisal'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AppraisalEditor.vue?53addb25